/* WARNING: This file is auto-generated . Do not edit manually. */

import { CloudLoadbalancingL7PolicyUpdate } from '../models/CloudLoadbalancingL7PolicyUpdate';
import { CloudProjectDatabaseServiceRestore } from '../models/CloudProjectDatabaseServiceRestore';
import { CloudRoleRoles } from '../models/CloudRoleRoles';
import { CloudProjectNetworkPrivateRegionCreation } from '../models/CloudProjectNetworkPrivateRegionCreation';
import { CloudLoadbalancingPoolMember } from '../models/CloudLoadbalancingPoolMember';
import { CloudProjectDatabaseServiceCurrentQueries } from '../models/CloudProjectDatabaseServiceCurrentQueries';
import { CloudProjectDatabaseServiceCertificates } from '../models/CloudProjectDatabaseServiceCertificates';
import { CloudInstanceRescueAdminPassword } from '../models/CloudInstanceRescueAdminPassword';
import { CloudProjectKubeNodeCreation } from '../models/CloudProjectKubeNodeCreation';
import { CloudProjectStorageUserCreation } from '../models/CloudProjectStorageUserCreation';
import { CloudProjectProductAgreements } from '../models/CloudProjectProductAgreements';
import { CloudContainerRegistryRegistry } from '../models/CloudContainerRegistryRegistry';
import { CloudKeymanagerSecret } from '../models/CloudKeymanagerSecret';
import { CloudLabAgreements } from '../models/CloudLabAgreements';
import { CloudProjectInstanceUpdate } from '../models/CloudProjectInstanceUpdate';
import { CloudProjectDataProcessingJob } from '../models/CloudProjectDataProcessingJob';
import { CloudIpFailoverIp } from '../models/CloudIpFailoverIp';
import { CloudProjectDataProcessingNotebookCapability } from '../models/CloudProjectDataProcessingNotebookCapability';
import { CloudProjectContainerRegistryUpdate } from '../models/CloudProjectContainerRegistryUpdate';
import { CloudProjectIpFailoverAttachCreation } from '../models/CloudProjectIpFailoverAttachCreation';
import { CloudProjectKubeNodePoolUpdate } from '../models/CloudProjectKubeNodePoolUpdate';
import { CloudUsageUsageHistory } from '../models/CloudUsageUsageHistory';
import { CloudLoadbalancingUpdateHealthMonitor } from '../models/CloudLoadbalancingUpdateHealthMonitor';
import { CloudProjectIoStreamCreation } from '../models/CloudProjectIoStreamCreation';
import { CloudNetworkGatewayCreateInterface } from '../models/CloudNetworkGatewayCreateInterface';
import { CloudProjectAiRegistryRegistryUpdateInput } from '../models/CloudProjectAiRegistryRegistryUpdateInput';
import { CloudProjectVolumeSnapshotCreation } from '../models/CloudProjectVolumeSnapshotCreation';
import { CloudKeymanagerCertificate } from '../models/CloudKeymanagerCertificate';
import { CloudProjectDatabaseKafkaTopic } from '../models/CloudProjectDatabaseKafkaTopic';
import { CloudProjectNetworkPrivateSubnetCreation } from '../models/CloudProjectNetworkPrivateSubnetCreation';
import { CloudUsageUsageHistoryDetail } from '../models/CloudUsageUsageHistoryDetail';
import { CloudProjectAiNotebookFramework } from '../models/CloudProjectAiNotebookFramework';
import { CloudProjectAiJobPresetImage } from '../models/CloudProjectAiJobPresetImage';
import { CloudForecastProjectForecast } from '../models/CloudForecastProjectForecast';
import { CloudProjectDatabaseM3dbUserWithPassword } from '../models/CloudProjectDatabaseM3dbUserWithPassword';
import { CloudProjectKubeCustomizationAPIServerAdmissionPluginsEnum } from '../models/CloudProjectKubeCustomizationAPIServerAdmissionPluginsEnum';
import { CloudBackup } from '../models/CloudBackup';
import { CloudProjectAiAuthorizationStatus } from '../models/CloudProjectAiAuthorizationStatus';
import { CloudProjectDatabaseOpensearchPattern } from '../models/CloudProjectDatabaseOpensearchPattern';
import { CloudQuotaAllowedQuota } from '../models/CloudQuotaAllowedQuota';
import { CloudQuotaStorageQuota } from '../models/CloudQuotaStorageQuota';
import { CloudProjectBill } from '../models/CloudProjectBill';
import { CloudAclTypeEnum } from '../models/CloudAclTypeEnum';
import { CloudProjectDatabaseServiceNode } from '../models/CloudProjectDatabaseServiceNode';
import { CloudLoadbalancingAssociateFloatingIp } from '../models/CloudLoadbalancingAssociateFloatingIp';
import { CloudNetworkCreateGateway } from '../models/CloudNetworkCreateGateway';
import { CloudOrderOrder } from '../models/CloudOrderOrder';
import { CloudProjectAiServingNamespace } from '../models/CloudProjectAiServingNamespace';
import { CloudProjectSubnet } from '../models/CloudProjectSubnet';
import { CloudStorageContainerAccess } from '../models/CloudStorageContainerAccess';
import { CloudLoadbalancingCreateListener } from '../models/CloudLoadbalancingCreateListener';
import { CloudProjectDatabaseM3dbUser } from '../models/CloudProjectDatabaseM3dbUser';
import { CloudStorageContainer } from '../models/CloudStorageContainer';
import { CloudProjectAiVolumeDataSyncSpec } from '../models/CloudProjectAiVolumeDataSyncSpec';
import { CloudProjectAiCapabilitiesPreset } from '../models/CloudProjectAiCapabilitiesPreset';
import { CloudProjectInstanceReinstallCreation } from '../models/CloudProjectInstanceReinstallCreation';
import { CloudProjectAiJobJob } from '../models/CloudProjectAiJobJob';
import { CloudLoadbalancingLoadbalancerCreate } from '../models/CloudLoadbalancingLoadbalancerCreate';
import { CloudLoadbalancingCreateFloatingIp } from '../models/CloudLoadbalancingCreateFloatingIp';
import { CloudProjectAiNotebookBackup } from '../models/CloudProjectAiNotebookBackup';
import { CloudVolumeVolume } from '../models/CloudVolumeVolume';
import { CloudLoadbalancingPool } from '../models/CloudLoadbalancingPool';
import { CloudProjectKubeUpdatePolicyUpdate } from '../models/CloudProjectKubeUpdatePolicyUpdate';
import { CloudPrice } from '../models/CloudPrice';
import { CloudProjectDatabaseServiceMaintenance } from '../models/CloudProjectDatabaseServiceMaintenance';
import { CloudProjectAiCapabilitiesProjectQuotas } from '../models/CloudProjectAiCapabilitiesProjectQuotas';
import { CloudLoadbalancingLoadBalancer } from '../models/CloudLoadbalancingLoadBalancer';
import { CloudUsageUsageForecast } from '../models/CloudUsageUsageForecast';
import { CloudKubeEtcdUsage } from '../models/CloudKubeEtcdUsage';
import { CloudProjectDatabaseKafkaConnectConnectorTask } from '../models/CloudProjectDatabaseKafkaConnectConnectorTask';
import { CloudProjectDatabaseServiceNodeCreation } from '../models/CloudProjectDatabaseServiceNodeCreation';
import { CloudProjectIoStreamSubscriptionStats } from '../models/CloudProjectIoStreamSubscriptionStats';
import { CloudProjectRegionWorkflowBackupCreation } from '../models/CloudProjectRegionWorkflowBackupCreation';
import { CloudStackStack } from '../models/CloudStackStack';
import { CloudKubeResponseMessage } from '../models/CloudKubeResponseMessage';
import { CloudUserUserDetail } from '../models/CloudUserUserDetail';
import { CloudProjectDatabaseCapabilitiesAdvancedConfigurationProperty } from '../models/CloudProjectDatabaseCapabilitiesAdvancedConfigurationProperty';
import { CloudProjectAiNotebookNotebookStateEnum } from '../models/CloudProjectAiNotebookNotebookStateEnum';
import { CloudContainerRegistryPlanUpdate } from '../models/CloudContainerRegistryPlanUpdate';
import { CloudProjectStorageUpdate } from '../models/CloudProjectStorageUpdate';
import { CloudSshkeySshKey } from '../models/CloudSshkeySshKey';
import { CloudProjectDatabaseServiceReplicationCreation } from '../models/CloudProjectDatabaseServiceReplicationCreation';
import { CloudProjectKubeCustomization } from '../models/CloudProjectKubeCustomization';
import { CloudProjectDataProcessingAuthorizationStatus } from '../models/CloudProjectDataProcessingAuthorizationStatus';
import { CloudProjectDatabaseServiceUserWithPasswordAndRoles } from '../models/CloudProjectDatabaseServiceUserWithPasswordAndRoles';
import { CloudNetworkGatewayInterface } from '../models/CloudNetworkGatewayInterface';
import { CloudLoadbalancingListener } from '../models/CloudLoadbalancingListener';
import { CloudProjectAiServingModelDefinition } from '../models/CloudProjectAiServingModelDefinition';
import { CloudProjectDatabaseOpensearchUserWithPassword } from '../models/CloudProjectDatabaseOpensearchUserWithPassword';
import { CloudInstanceInstance } from '../models/CloudInstanceInstance';
import { CloudProjectFloatingIp } from '../models/CloudProjectFloatingIp';
import { CloudProjectAiServingRegistryResponse } from '../models/CloudProjectAiServingRegistryResponse';
import { CloudProjectAiOrderEnum } from '../models/CloudProjectAiOrderEnum';
import { CloudProjectAiAppAppImageInput } from '../models/CloudProjectAiAppAppImageInput';
import { CloudUserOpenrc } from '../models/CloudUserOpenrc';
import { CloudImageOSTypeEnum } from '../models/CloudImageOSTypeEnum';
import { CloudKubeAuditLogs } from '../models/CloudKubeAuditLogs';
import { CloudProjectDatabaseKafkaConnectCapabilitiesConnectorConfigurationProperty } from '../models/CloudProjectDatabaseKafkaConnectCapabilitiesConnectorConfigurationProperty';
import { CloudProjectInstanceRescueModeCreation } from '../models/CloudProjectInstanceRescueModeCreation';
import { CloudProjectDatabaseRedisUserWithPassword } from '../models/CloudProjectDatabaseRedisUserWithPassword';
import { CloudProjectDatabaseServiceUser } from '../models/CloudProjectDatabaseServiceUser';
import { CloudProjectKubeCreation } from '../models/CloudProjectKubeCreation';
import { CloudInstanceInstanceMetrics } from '../models/CloudInstanceInstanceMetrics';
import { CloudContainerRegistryPlan } from '../models/CloudContainerRegistryPlan';
import { CloudProjectStoragePublicUrlCreation } from '../models/CloudProjectStoragePublicUrlCreation';
import { CloudProjectKubeOpenIdConnectCreation } from '../models/CloudProjectKubeOpenIdConnectCreation';
import { CloudFlavorFlavor } from '../models/CloudFlavorFlavor';
import { CloudImageImage } from '../models/CloudImageImage';
import { CloudProjectDatabaseRedisUserCreation } from '../models/CloudProjectDatabaseRedisUserCreation';
import { CloudProjectActivateMonthlyBillingCreation } from '../models/CloudProjectActivateMonthlyBillingCreation';
import { ServiceTerminationFutureUseEnum } from '../models/ServiceTerminationFutureUseEnum';
import { CloudProjectAiAppAppSpecInput } from '../models/CloudProjectAiAppAppSpecInput';
import { CloudProjectDatabaseCapabilitiesIntegration } from '../models/CloudProjectDatabaseCapabilitiesIntegration';
import { CloudQuotaQuotas } from '../models/CloudQuotaQuotas';
import { CloudProjectAiCommand } from '../models/CloudProjectAiCommand';
import { CloudProjectLoadbalancerConfigurationCreation } from '../models/CloudProjectLoadbalancerConfigurationCreation';
import { CloudUserUser } from '../models/CloudUserUser';
import { CloudProjectAiCapabilitiesFeatures } from '../models/CloudProjectAiCapabilitiesFeatures';
import { CloudLoadbalancingPoolMemberUpdate } from '../models/CloudLoadbalancingPoolMemberUpdate';
import { CloudProjectAiServingToken } from '../models/CloudProjectAiServingToken';
import { CloudProjectInstanceBulkCreation } from '../models/CloudProjectInstanceBulkCreation';
import { CloudProjectMigrationUpdate } from '../models/CloudProjectMigrationUpdate';
import { CloudProjectAiServingFlavor } from '../models/CloudProjectAiServingFlavor';
import { CloudUserRCloneServiceEnum } from '../models/CloudUserRCloneServiceEnum';
import { CloudNetworkNetwork } from '../models/CloudNetworkNetwork';
import { CloudProjectVolumeCreation } from '../models/CloudProjectVolumeCreation';
import { CloudProjectDatabaseM3dbUserCreation } from '../models/CloudProjectDatabaseM3dbUserCreation';
import { CloudVolumeBackupVolumeBackupCreation } from '../models/CloudVolumeBackupVolumeBackupCreation';
import { CloudStorageQuota } from '../models/CloudStorageQuota';
import { CloudProjectDatabaseKafkaService } from '../models/CloudProjectDatabaseKafkaService';
import { CloudProjectVolumeDetachCreation } from '../models/CloudProjectVolumeDetachCreation';
import { CloudProjectDatabaseKafkaAcl } from '../models/CloudProjectDatabaseKafkaAcl';
import { CloudProjectDatabaseServiceLogEntry } from '../models/CloudProjectDatabaseServiceLogEntry';
import { CloudLoadbalancingL7Rule } from '../models/CloudLoadbalancingL7Rule';
import { CloudProjectAiServingNamespaceCreation } from '../models/CloudProjectAiServingNamespaceCreation';
import { CloudProjectAiRegistryRegistry } from '../models/CloudProjectAiRegistryRegistry';
import { CloudProjectKubeUpdateCreation } from '../models/CloudProjectKubeUpdateCreation';
import { CloudProjectInstanceGroupCreation } from '../models/CloudProjectInstanceGroupCreation';
import { CloudStoragePresignedURL } from '../models/CloudStoragePresignedURL';
import { CloudVolumeBackupVolumeBackup } from '../models/CloudVolumeBackupVolumeBackup';
import { CloudVolumeSnapshot } from '../models/CloudVolumeSnapshot';
import { CloudProjectDatabaseKafkaTopicCreation } from '../models/CloudProjectDatabaseKafkaTopicCreation';
import { CloudInstanceInstanceDetail } from '../models/CloudInstanceInstanceDetail';
import { CloudProjectIoStreamSubscription } from '../models/CloudProjectIoStreamSubscription';
import { NichandleOvhSubsidiaryEnum } from '../models/NichandleOvhSubsidiaryEnum';
import { CloudAcl } from '../models/CloudAcl';
import { CloudProjectAiLogs } from '../models/CloudProjectAiLogs';
import { CloudProjectNetworkPrivateUpdate } from '../models/CloudProjectNetworkPrivateUpdate';
import { CloudVolumeBackupVolumeCreationFromBackup } from '../models/CloudVolumeBackupVolumeCreationFromBackup';
import { CloudStoragePresignedURLInput } from '../models/CloudStoragePresignedURLInput';
import { CloudProjectDatabaseIpRestriction } from '../models/CloudProjectDatabaseIpRestriction';
import { CloudUserOpenrcVersionEnum } from '../models/CloudUserOpenrcVersionEnum';
import { CloudLoadbalancingPoolUpdate } from '../models/CloudLoadbalancingPoolUpdate';
import { CloudProjectVolumeAttachCreation } from '../models/CloudProjectVolumeAttachCreation';
import { CloudProjectKubeUpdate } from '../models/CloudProjectKubeUpdate';
import { CloudNetworkUpdateGateway } from '../models/CloudNetworkUpdateGateway';
import { CloudLoadbalancingHealthMonitor } from '../models/CloudLoadbalancingHealthMonitor';
import { CloudKubeCluster } from '../models/CloudKubeCluster';
import { CloudProjectDatabaseServiceUserWithPassword } from '../models/CloudProjectDatabaseServiceUserWithPassword';
import { CloudProjectDataProcessingNotebookNotebook } from '../models/CloudProjectDataProcessingNotebookNotebook';
import { CloudProjectAiServingModel } from '../models/CloudProjectAiServingModel';
import { CloudLoadbalancingPoolCreate } from '../models/CloudLoadbalancingPoolCreate';
import { CloudStorageContainerDetail } from '../models/CloudStorageContainerDetail';
import { CloudProjectAiVolumeDataSync } from '../models/CloudProjectAiVolumeDataSync';
import { CloudProjectDatabaseServiceUserWithRolesCreation } from '../models/CloudProjectDatabaseServiceUserWithRolesCreation';
import { CloudProjectNetwork } from '../models/CloudProjectNetwork';
import { CloudProjectLoadbalancerConfiguration } from '../models/CloudProjectLoadbalancerConfiguration';
import { CloudProjectAiNotebookNotebookUpdate } from '../models/CloudProjectAiNotebookNotebookUpdate';
import { CloudProjectAiServingMetrics } from '../models/CloudProjectAiServingMetrics';
import { CloudStorageAddContainerPolicy } from '../models/CloudStorageAddContainerPolicy';
import { CloudProjectEligibilityInfo } from '../models/CloudProjectEligibilityInfo';
import { CloudIpCloudIp } from '../models/CloudIpCloudIp';
import { CloudProjectDatabaseOpensearchIndex } from '../models/CloudProjectDatabaseOpensearchIndex';
import { CloudKubeFlavor } from '../models/CloudKubeFlavor';
import { CloudProjectInstanceResizeCreation } from '../models/CloudProjectInstanceResizeCreation';
import { CloudInstanceMetricsPeriodEnum } from '../models/CloudInstanceMetricsPeriodEnum';
import { CloudProjectDatabaseKafkaConnectCapabilitiesConnectorTransform } from '../models/CloudProjectDatabaseKafkaConnectCapabilitiesConnectorTransform';
import { CloudKubeNode } from '../models/CloudKubeNode';
import { CloudProjectUserTokenCreation } from '../models/CloudProjectUserTokenCreation';
import { CloudLoadbalancingL7Policy } from '../models/CloudLoadbalancingL7Policy';
import { CloudProjectNetworkPrivateCreation } from '../models/CloudProjectNetworkPrivateCreation';
import { CloudProjectDatabaseOpensearchUser } from '../models/CloudProjectDatabaseOpensearchUser';
import { CloudInstanceApplicationAccess } from '../models/CloudInstanceApplicationAccess';
import { CloudLoadbalancingFlavor } from '../models/CloudLoadbalancingFlavor';
import { CloudProjectNewProject } from '../models/CloudProjectNewProject';
import { CloudProject } from '../models/CloudProject';
import { CloudRoleRole } from '../models/CloudRoleRole';
import { CloudProjectDatabasePostgresqlConnectionPoolCreation } from '../models/CloudProjectDatabasePostgresqlConnectionPoolCreation';
import { CloudProjectDatabaseServiceMetricPeriodEnum } from '../models/CloudProjectDatabaseServiceMetricPeriodEnum';
import { CloudProjectDatabaseMysqlQueryStatistics } from '../models/CloudProjectDatabaseMysqlQueryStatistics';
import { CloudProjectStorageCreation } from '../models/CloudProjectStorageCreation';
import { CloudMigrationMigration } from '../models/CloudMigrationMigration';
import { CloudProjectDatabaseCapabilities } from '../models/CloudProjectDatabaseCapabilities';
import { CloudVolumeBackupVolumeBackupRestore } from '../models/CloudVolumeBackupVolumeBackupRestore';
import { CloudProjectIoStreamRegion } from '../models/CloudProjectIoStreamRegion';
import { CloudLab } from '../models/CloudLab';
import { CloudProjectAiNotebookEditor } from '../models/CloudProjectAiNotebookEditor';
import { CloudProjectDatabaseServiceBackup } from '../models/CloudProjectDatabaseServiceBackup';
import { CloudProjectAiServingFramework } from '../models/CloudProjectAiServingFramework';
import { CloudProjectKubeOpenIdConnectUpdate } from '../models/CloudProjectKubeOpenIdConnectUpdate';
import { CloudProjectRegionQuotaCreation } from '../models/CloudProjectRegionQuotaCreation';
import { CloudKubePrivateNetworkConfiguration } from '../models/CloudKubePrivateNetworkConfiguration';
import { CloudProjectDataProcessingJobLogs } from '../models/CloudProjectDataProcessingJobLogs';
import { CloudProjectDatabaseM3dbNamespaceCreation } from '../models/CloudProjectDatabaseM3dbNamespaceCreation';
import { CloudProjectDatabaseServiceUserCreation } from '../models/CloudProjectDatabaseServiceUserCreation';
import { CloudProjectAiCapabilitiesRegion } from '../models/CloudProjectAiCapabilitiesRegion';
import { CloudNetworkCreateGatewaySummary } from '../models/CloudNetworkCreateGatewaySummary';
import { ServicesService } from '../models/ServicesService';
import { CloudProjectRegionCreation } from '../models/CloudProjectRegionCreation';
import { CloudUserRclone } from '../models/CloudUserRclone';
import { CloudProjectIoStream } from '../models/CloudProjectIoStream';
import { CloudProjectAiNotebookNotebookSpecInput } from '../models/CloudProjectAiNotebookNotebookSpecInput';
import { CloudProjectInstanceRebootCreation } from '../models/CloudProjectInstanceRebootCreation';
import { CloudProjectAiNotebookNotebook } from '../models/CloudProjectAiNotebookNotebook';
import { CloudProjectIoStreamStats } from '../models/CloudProjectIoStreamStats';
import { CloudProjectAiServingPresetImage } from '../models/CloudProjectAiServingPresetImage';
import { CloudContainerRegistryCapability } from '../models/CloudContainerRegistryCapability';
import { CloudAuthenticationToken } from '../models/CloudAuthenticationToken';
import { CloudProjectDatabaseOpensearchUserCreation } from '../models/CloudProjectDatabaseOpensearchUserCreation';
import { CloudProjectIoStreamTokenCreation } from '../models/CloudProjectIoStreamTokenCreation';
import { CloudProjectDatabaseServiceCurrentqueriesQueryCancelResponse } from '../models/CloudProjectDatabaseServiceCurrentqueriesQueryCancelResponse';
import { CloudProjectContainerRegistryCreation } from '../models/CloudProjectContainerRegistryCreation';
import { CloudUsageUsageCurrent } from '../models/CloudUsageUsageCurrent';
import { CloudOperation } from '../models/CloudOperation';
import { CloudProjectKubeResetCreation } from '../models/CloudProjectKubeResetCreation';
import { CloudNetworkSubnet } from '../models/CloudNetworkSubnet';
import { CloudProjectAiTokenToken } from '../models/CloudProjectAiTokenToken';
import { CloudSshkeySshKeyDetail } from '../models/CloudSshkeySshKeyDetail';
import { CloudProjectKubeRestart } from '../models/CloudProjectKubeRestart';
import { CloudInstancegroupInstanceGroup } from '../models/CloudInstancegroupInstanceGroup';
import { CloudCapabilitiesAvailability } from '../models/CloudCapabilitiesAvailability';
import { CloudNetworkCreateNetwork } from '../models/CloudNetworkCreateNetwork';
import { CloudProjectProjectUsage } from '../models/CloudProjectProjectUsage';
import { CloudStoragePolicyRaw } from '../models/CloudStoragePolicyRaw';
import { CloudProjectAiCapabilitiesFlavor } from '../models/CloudProjectAiCapabilitiesFlavor';
import { CloudInstanceCreateFloatingIp } from '../models/CloudInstanceCreateFloatingIp';
import { CloudProjectAiServingBackend } from '../models/CloudProjectAiServingBackend';
import { CloudAlertingAlert } from '../models/CloudAlertingAlert';
import { CloudProjectIoStreamToken } from '../models/CloudProjectIoStreamToken';
import { CloudProjectUserRoleUpdate } from '../models/CloudProjectUserRoleUpdate';
import { CloudProjectProductNameEnum } from '../models/CloudProjectProductNameEnum';
import { CloudProjectDatabaseKafkaConnectCapabilitiesConnector } from '../models/CloudProjectDatabaseKafkaConnectCapabilitiesConnector';
import { CloudProjectDatabaseServiceIntegration } from '../models/CloudProjectDatabaseServiceIntegration';
import { CloudProjectAiLabel } from '../models/CloudProjectAiLabel';
import { CloudProjectVolumeUpsizeCreation } from '../models/CloudProjectVolumeUpsizeCreation';
import { CloudProjectDataProcessingMetrics } from '../models/CloudProjectDataProcessingMetrics';
import { CloudProjectKubeNodePoolCreation } from '../models/CloudProjectKubeNodePoolCreation';
import { CloudStorageContainerObjectTempURL } from '../models/CloudStorageContainerObjectTempURL';
import { CloudProjectDatabaseIpRestrictionCreation } from '../models/CloudProjectDatabaseIpRestrictionCreation';
import { CloudStorageContainerCreation } from '../models/CloudStorageContainerCreation';
import { CloudProjectDatabasePostgresqlQueryStatistics } from '../models/CloudProjectDatabasePostgresqlQueryStatistics';
import { CloudVrack } from '../models/CloudVrack';
import { CloudProjectStorageCorsCreation } from '../models/CloudProjectStorageCorsCreation';
import { CloudProjectDatabasePostgresqlConnectionPool } from '../models/CloudProjectDatabasePostgresqlConnectionPool';
import { CloudProjectUserRoleCreation } from '../models/CloudProjectUserRoleCreation';
import { CloudProjectInstanceSnapshotCreation } from '../models/CloudProjectInstanceSnapshotCreation';
import { CloudProjectNewProjectInfo } from '../models/CloudProjectNewProjectInfo';
import { CloudProjectDatabaseRedisUser } from '../models/CloudProjectDatabaseRedisUser';
import { CloudProjectAiAppApp } from '../models/CloudProjectAiAppApp';
import { CloudProjectDataProcessingCapability } from '../models/CloudProjectDataProcessingCapability';
import { CloudOrderRuleInstanceCategories } from '../models/CloudOrderRuleInstanceCategories';
import { CloudProjectDatabaseServiceCreation } from '../models/CloudProjectDatabaseServiceCreation';
import { CloudProjectKubeIpRestrictionUpsert } from '../models/CloudProjectKubeIpRestrictionUpsert';
import { CloudProjectDatabaseKafkaConnectConnectorCreation } from '../models/CloudProjectDatabaseKafkaConnectConnectorCreation';
import { CloudRegion } from '../models/CloudRegion';
import { CloudAlerting } from '../models/CloudAlerting';
import { CloudProjectAiServingRegistry } from '../models/CloudProjectAiServingRegistry';
import { CloudProjectDatabaseKafkaPermissions } from '../models/CloudProjectDatabaseKafkaPermissions';
import { CloudProjectAiServingFeatures } from '../models/CloudProjectAiServingFeatures';
import { ServiceTerminationReasonEnum } from '../models/ServiceTerminationReasonEnum';
import { CloudKubeOpenIdConnect } from '../models/CloudKubeOpenIdConnect';
import { CloudProjectLoadBalancer } from '../models/CloudProjectLoadBalancer';
import { CloudProjectDatabaseTemporaryWriteDeadline } from '../models/CloudProjectDatabaseTemporaryWriteDeadline';
import { CloudProjectSshkeyCreation } from '../models/CloudProjectSshkeyCreation';
import { CloudProjectInstanceInterfaceCreation } from '../models/CloudProjectInstanceInterfaceCreation';
import { CloudProjectAiJobJobSpecInput } from '../models/CloudProjectAiJobJobSpecInput';
import { CloudKubeRegionEnum } from '../models/CloudKubeRegionEnum';
import { CloudProjectDatabaseOpensearchService } from '../models/CloudProjectDatabaseOpensearchService';
import { CloudInstanceInstanceVnc } from '../models/CloudInstanceInstanceVnc';
import { CloudOrderRuleAvailability } from '../models/CloudOrderRuleAvailability';
import { CloudProjectInstanceCreation } from '../models/CloudProjectInstanceCreation';
import { CloudProjectAiAppAppStateEnum } from '../models/CloudProjectAiAppAppStateEnum';
import { CloudProjectAiTokenTokenSpec } from '../models/CloudProjectAiTokenTokenSpec';
import { CloudProjectLoadbalancerRegion } from '../models/CloudProjectLoadbalancerRegion';
import { CloudUserS3CredentialsWithSecret } from '../models/CloudUserS3CredentialsWithSecret';
import { CloudProjectDataProcessingNotebookNotebookSpec } from '../models/CloudProjectDataProcessingNotebookNotebookSpec';
import { CloudKubeNodePool } from '../models/CloudKubeNodePool';
import { CloudProjectDatabaseService } from '../models/CloudProjectDatabaseService';
import { CloudProjectDatabaseServiceReplication } from '../models/CloudProjectDatabaseServiceReplication';
import { CloudProjectDatabaseServiceUserWithRoles } from '../models/CloudProjectDatabaseServiceUserWithRoles';
import { CloudNetworkGateway } from '../models/CloudNetworkGateway';
import { CloudProjectDatabaseAvailability } from '../models/CloudProjectDatabaseAvailability';
import { CloudInstanceInterfaceInterface } from '../models/CloudInstanceInterfaceInterface';
import { CloudProjectDatabaseServiceDatabase } from '../models/CloudProjectDatabaseServiceDatabase';
import { CloudKubeKubeconfig } from '../models/CloudKubeKubeconfig';
import { CloudAvailableRegion } from '../models/CloudAvailableRegion';
import { CloudProjectLoadBalancerCreation } from '../models/CloudProjectLoadBalancerCreation';
import { CloudProjectDatabaseKafkaConnectConnector } from '../models/CloudProjectDatabaseKafkaConnectConnector';
import { CloudProjectDatabaseOpensearchPermissions } from '../models/CloudProjectDatabaseOpensearchPermissions';
import { CloudProjectDatabaseM3dbNamespace } from '../models/CloudProjectDatabaseM3dbNamespace';
import { CloudProjectDatabaseServiceMetric } from '../models/CloudProjectDatabaseServiceMetric';
import { CloudProjectIoStreamSubscriptionCreation } from '../models/CloudProjectIoStreamSubscriptionCreation';
import { CloudProjectAiAppScalingStrategyInput } from '../models/CloudProjectAiAppScalingStrategyInput';
import { CloudProjectContainerRegistryUsersCreation } from '../models/CloudProjectContainerRegistryUsersCreation';
import { CloudInstanceMetricsTypeEnum } from '../models/CloudInstanceMetricsTypeEnum';
import { CloudContainerRegistryUser } from '../models/CloudContainerRegistryUser';
import { CloudQuotaStorageQuotaUpdate } from '../models/CloudQuotaStorageQuotaUpdate';
import { CloudProjectVolumeUpdate } from '../models/CloudProjectVolumeUpdate';
import { CloudColdArchiveContainer } from '../models/CloudColdArchiveContainer';
import { CloudProjectUserCreation } from '../models/CloudProjectUserCreation';
import { CloudProjectDatabaseServiceCurrentqueriesQueryCancelRequest } from '../models/CloudProjectDatabaseServiceCurrentqueriesQueryCancelRequest';
import { CloudProjectDatabaseKafkaUserAccess } from '../models/CloudProjectDatabaseKafkaUserAccess';
import { CloudProjectAiJobJobStateEnum } from '../models/CloudProjectAiJobJobStateEnum';
import { CloudInstanceAssociateFloatingIp } from '../models/CloudInstanceAssociateFloatingIp';
import { CloudAlertingDelayEnum } from '../models/CloudAlertingDelayEnum';
import { CloudKeymanagerCertificateCreate } from '../models/CloudKeymanagerCertificateCreate';
import { CloudCredit } from '../models/CloudCredit';
import OVHBase from '../ovh';

class CloudHandler {
  ovh: OVHBase;

  constructor(ovh: OVHBase) {
    this.ovh = ovh;
  }

  /** Get agreements related to a product */
  getAgreements = (): Promise<CloudProjectProductAgreements> => {
    return this.ovh.request('GET', '/cloud/agreements');
  };

  /** Start a new cloud project */
  postCreateProject = (body: {
    credit?: number;
    description?: string;
    voucher?: string;
  }): Promise<CloudProjectNewProject> => {
    return this.ovh.request('POST', '/cloud/createProject', body);
  };

  /** Get information about a cloud project creation */
  getCreateProjectInfo = (): Promise<CloudProjectNewProjectInfo> => {
    return this.ovh.request('GET', '/cloud/createProjectInfo');
  };

  /** Check your eligibility to create a Public Cloud order */
  checkEligibility = (): Promise<CloudProjectEligibilityInfo> => {
    return this.ovh.request('GET', '/cloud/eligibility');
  };

  /** Get all cloud pending orders */
  getOrder = (): Promise<CloudOrderOrder[]> => {
    return this.ovh.request('GET', '/cloud/order');
  };

  /** Get product availability */
  getOrderRuleAvailability = (): Promise<CloudOrderRuleAvailability> => {
    return this.ovh.request('GET', '/cloud/order/rule/availability');
  };

  /** Get instance categories */
  getOrderRuleInstanceCategory = (): Promise<CloudOrderRuleInstanceCategories> => {
    return this.ovh.request('GET', '/cloud/order/rule/instanceCategory');
  };

  /** Get services prices */
  getPrice = (): Promise<CloudPrice> => {
    return this.ovh.request('GET', '/cloud/price');
  };

  /** List available services */
  listProject = (): Promise<string[]> => {
    return this.ovh.request('GET', '/cloud/project');
  };

  /** Get this object properties */
  getProjectByServiceName = (serviceName: string): Promise<CloudProject> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}`);
  };

  /** Alter this object properties */
  updateProjectByServiceName = (serviceName: string, body: CloudProject): Promise<void> => {
    return this.ovh.request('PUT', `/cloud/project/${serviceName}`, body);
  };

  /** Get ACL on your cloud project */
  getProjectAclByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/acl`);
  };

  /** Create new ACL */
  createProjectAclByServiceName = (
    serviceName: string,
    body: { accountId: string; type: CloudAclTypeEnum }
  ): Promise<CloudAcl> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/acl`, body);
  };

  /** Delete ACL */
  deleteProjectAclByServiceNameAndAccountId = (
    accountId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/acl/${accountId}`);
  };

  /** Get this object properties */
  getProjectAclByServiceNameAndAccountId = (
    accountId: string,
    serviceName: string
  ): Promise<CloudAcl> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/acl/${accountId}`);
  };

  /** Activate monthly billing on multiple instances */
  postProjectActivateMonthlyBillingByServiceName = (
    serviceName: string,
    body: CloudProjectActivateMonthlyBillingCreation
  ): Promise<CloudInstanceInstanceDetail[]> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/activateMonthlyBilling`, body);
  };

  /** List apps */
  listProjectAiAppByServiceName = (serviceName: string): Promise<CloudProjectAiAppApp[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/app`);
  };

  /** Create a new app */
  createProjectAiAppByServiceName = (
    serviceName: string,
    body: CloudProjectAiAppAppSpecInput
  ): Promise<CloudProjectAiAppApp> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/ai/app`, body);
  };

  /** Generate an app spec corresponding CLI command */
  postProjectAiAppCommandByServiceName = (
    serviceName: string,
    body: CloudProjectAiAppAppSpecInput
  ): Promise<CloudProjectAiCommand> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/ai/app/command`, body);
  };

  /** Delete an app */
  deleteProjectAiAppByServiceNameAndAppId = (appId: string, serviceName: string): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/ai/app/${appId}`);
  };

  /** Get app information */
  getProjectAiAppByServiceNameAndAppId = (
    appId: string,
    serviceName: string
  ): Promise<CloudProjectAiAppApp> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/app/${appId}`);
  };

  /** Starts a manual data synchronization on an app */
  postProjectAiAppDatasyncByServiceNameAndAppId = (
    appId: string,
    serviceName: string,
    body: CloudProjectAiVolumeDataSyncSpec
  ): Promise<CloudProjectAiVolumeDataSync> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/ai/app/${appId}/datasync`, body);
  };

  /** Set the Docker image of an AI app */
  putProjectAiAppImageByServiceNameAndAppId = (
    appId: string,
    serviceName: string,
    body: CloudProjectAiAppAppImageInput
  ): Promise<void> => {
    return this.ovh.request('PUT', `/cloud/project/${serviceName}/ai/app/${appId}/image`, body);
  };

  /** Update/add an AI Solutions app label */
  updateProjectAiAppLabelByServiceNameAndAppId = (
    appId: string,
    serviceName: string,
    body: CloudProjectAiLabel
  ): Promise<void> => {
    return this.ovh.request('PUT', `/cloud/project/${serviceName}/ai/app/${appId}/label`, body);
  };

  /** Get the logs of an app */
  getProjectAiAppLogByServiceNameAndAppId = (
    appId: string,
    serviceName: string
  ): Promise<CloudProjectAiLogs> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/app/${appId}/log`);
  };

  /** Scale a App */
  putProjectAiAppScalingstrategyByServiceNameAndAppId = (
    appId: string,
    serviceName: string,
    body: CloudProjectAiAppScalingStrategyInput
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/ai/app/${appId}/scalingstrategy`,
      body
    );
  };

  /** Start an existing AI Solutions app */
  putProjectAiAppStartByServiceNameAndAppId = (
    appId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('PUT', `/cloud/project/${serviceName}/ai/app/${appId}/start`);
  };

  /** Stop an AI Solutions app */
  putProjectAiAppStopByServiceNameAndAppId = (
    appId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('PUT', `/cloud/project/${serviceName}/ai/app/${appId}/stop`);
  };

  /** Get authorization status */
  getProjectAiAuthorizationByServiceName = (
    serviceName: string
  ): Promise<CloudProjectAiAuthorizationStatus> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/authorization`);
  };

  /** Authorization of AI Solutions service by allowing access to your object storage containers */
  postProjectAiAuthorizationByServiceName = (serviceName: string): Promise<void> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/ai/authorization`);
  };

  /** List AI Solutions available features */
  listProjectAiCapabilitiesFeatureByServiceName = (
    serviceName: string
  ): Promise<CloudProjectAiCapabilitiesFeatures> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/capabilities/feature`);
  };

  /** List AI Solutions available quotas */
  listProjectAiCapabilitiesQuotaByServiceName = (
    serviceName: string
  ): Promise<CloudProjectAiCapabilitiesProjectQuotas> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/capabilities/quota`);
  };

  /** List Region */
  listProjectAiCapabilitiesRegionByServiceName = (
    serviceName: string
  ): Promise<CloudProjectAiCapabilitiesRegion[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/capabilities/region`);
  };

  /** Get Region Information */
  getProjectAiCapabilitiesRegionByServiceNameAndRegion = (
    region: string,
    serviceName: string
  ): Promise<CloudProjectAiCapabilitiesRegion> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/ai/capabilities/region/${region}`
    );
  };

  /** Get Available data regions Information */
  getProjectAiCapabilitiesRegionDataRegionByServiceNameAndRegion = (
    region: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/ai/capabilities/region/${region}/data/region`
    );
  };

  /** List Flavors */
  listProjectAiCapabilitiesRegionFlavorByServiceNameAndRegion = (
    region: string,
    serviceName: string
  ): Promise<CloudProjectAiCapabilitiesFlavor[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/ai/capabilities/region/${region}/flavor`
    );
  };

  /** Get Flavor Information */
  getProjectAiCapabilitiesRegionFlavorByServiceNameAndRegionAndFlavorId = (
    flavorId: string,
    region: string,
    serviceName: string
  ): Promise<CloudProjectAiCapabilitiesFlavor> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/ai/capabilities/region/${region}/flavor/${flavorId}`
    );
  };

  /** List Presets */
  listProjectAiCapabilitiesRegionPresetByServiceNameAndRegion = (
    region: string,
    serviceName: string
  ): Promise<CloudProjectAiCapabilitiesPreset[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/ai/capabilities/region/${region}/preset`
    );
  };

  /** Get Preset Information */
  getProjectAiCapabilitiesRegionPresetByServiceNameAndRegionAndPresetId = (
    presetId: string,
    region: string,
    serviceName: string
  ): Promise<CloudProjectAiCapabilitiesPreset> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/ai/capabilities/region/${region}/preset/${presetId}`
    );
  };

  /** Deprecated - ML Serving is End Of Life - List Serving Engine available backends */
  getProjectAiCapabilitiesServingBackendByServiceName = (
    serviceName: string
  ): Promise<CloudProjectAiServingBackend[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/capabilities/serving/backend`);
  };

  /** Deprecated - ML Serving is End Of Life - List Serving Engine Features */
  getProjectAiCapabilitiesServingFeatureByServiceName = (
    serviceName: string
  ): Promise<CloudProjectAiServingFeatures> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/capabilities/serving/feature`);
  };

  /** Deprecated - ML Serving is End Of Life - List Serving Engine available flavor */
  getProjectAiCapabilitiesServingFlavorByServiceName = (
    serviceName: string
  ): Promise<CloudProjectAiServingFlavor[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/capabilities/serving/flavor`);
  };

  /** Deprecated - ML Serving is End Of Life - List Serving Engine available frameworks */
  getProjectAiCapabilitiesServingFrameworkByServiceName = (
    serviceName: string
  ): Promise<CloudProjectAiServingFramework[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/ai/capabilities/serving/framework`
    );
  };

  /** Deprecated - ML Serving is End Of Life - List Serving Engine Preset Model Images */
  getProjectAiCapabilitiesServingPresetImageByServiceName = (
    serviceName: string
  ): Promise<CloudProjectAiServingPresetImage[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/ai/capabilities/serving/presetImage`
    );
  };

  /** Deprecated - ML Serving is End Of Life - List Serving Engine available regions */
  getProjectAiCapabilitiesServingRegionByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/capabilities/serving/region`);
  };

  /** List jobs */
  listProjectAiJobByServiceName = (serviceName: string): Promise<CloudProjectAiJobJob[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/job`);
  };

  /** Create a new job */
  createProjectAiJobByServiceName = (
    serviceName: string,
    body: CloudProjectAiJobJobSpecInput
  ): Promise<CloudProjectAiJobJob> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/ai/job`, body);
  };

  /** List AI Solutions Preset Model Images */
  listProjectAiJobCapabilitiesPresetImageByServiceName = (
    serviceName: string
  ): Promise<CloudProjectAiJobPresetImage[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/job/capabilities/presetImage`);
  };

  /** Generate a job spec corresponding CLI command */
  postProjectAiJobCommandByServiceName = (
    serviceName: string,
    body: CloudProjectAiJobJobSpecInput
  ): Promise<CloudProjectAiCommand> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/ai/job/command`, body);
  };

  /** Permanently delete a job */
  deleteProjectAiJobByServiceNameAndJobId = (jobId: string, serviceName: string): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/ai/job/${jobId}`);
  };

  /** Get job information */
  getProjectAiJobByServiceNameAndJobId = (
    jobId: string,
    serviceName: string
  ): Promise<CloudProjectAiJobJob> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/job/${jobId}`);
  };

  /** Starts a manual data synchronization on an AI Solutions job */
  postProjectAiJobDatasyncByServiceNameAndJobId = (
    jobId: string,
    serviceName: string,
    body: CloudProjectAiVolumeDataSyncSpec
  ): Promise<CloudProjectAiVolumeDataSync> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/ai/job/${jobId}/datasync`, body);
  };

  /** Kill a AI Solutions job */
  putProjectAiJobKillByServiceNameAndJobId = (
    jobId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('PUT', `/cloud/project/${serviceName}/ai/job/${jobId}/kill`);
  };

  /** Update/add an AI Solutions job label */
  updateProjectAiJobLabelByServiceNameAndJobId = (
    jobId: string,
    serviceName: string,
    body: CloudProjectAiLabel
  ): Promise<void> => {
    return this.ovh.request('PUT', `/cloud/project/${serviceName}/ai/job/${jobId}/label`, body);
  };

  /** Get the logs of a job */
  getProjectAiJobLogByServiceNameAndJobId = (
    jobId: string,
    serviceName: string
  ): Promise<CloudProjectAiLogs> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/job/${jobId}/log`);
  };

  /** List notebooks */
  listProjectAiNotebookByServiceName = (
    serviceName: string
  ): Promise<CloudProjectAiNotebookNotebook[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/notebook`);
  };

  /** Create a new notebook */
  createProjectAiNotebookByServiceName = (
    serviceName: string,
    body: CloudProjectAiNotebookNotebookSpecInput
  ): Promise<CloudProjectAiNotebookNotebook> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/ai/notebook`, body);
  };

  /** List AI Solutions Notebook available code editors */
  listProjectAiNotebookCapabilitiesEditorByServiceName = (
    serviceName: string
  ): Promise<CloudProjectAiNotebookEditor[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/notebook/capabilities/editor`);
  };

  /** List AI Solutions Notebook available frameworks */
  listProjectAiNotebookCapabilitiesFrameworkByServiceName = (
    serviceName: string
  ): Promise<CloudProjectAiNotebookFramework[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/ai/notebook/capabilities/framework`
    );
  };

  /** Generate a notebook spec corresponding CLI command */
  postProjectAiNotebookCommandByServiceName = (
    serviceName: string,
    body: CloudProjectAiNotebookNotebookSpecInput
  ): Promise<CloudProjectAiCommand> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/ai/notebook/command`, body);
  };

  /** Delete a notebook */
  deleteProjectAiNotebookByServiceNameAndNotebookId = (
    notebookId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/ai/notebook/${notebookId}`);
  };

  /** Get notebook information */
  getProjectAiNotebookByServiceNameAndNotebookId = (
    notebookId: string,
    serviceName: string
  ): Promise<CloudProjectAiNotebookNotebook> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/notebook/${notebookId}`);
  };

  /** Update an existing notebook. Only labels update can be done while notebook is running. */
  updateProjectAiNotebookByServiceNameAndNotebookId = (
    notebookId: string,
    serviceName: string,
    body: CloudProjectAiNotebookNotebookUpdate
  ): Promise<void> => {
    return this.ovh.request('PUT', `/cloud/project/${serviceName}/ai/notebook/${notebookId}`, body);
  };

  /** List all backups of an AI Solutions notebook */
  listProjectAiNotebookBackupByServiceNameAndNotebookId = (
    notebookId: string,
    serviceName: string
  ): Promise<CloudProjectAiNotebookBackup[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/ai/notebook/${notebookId}/backup`
    );
  };

  /** Get details for a single AI Solutions notebook backup */
  getProjectAiNotebookBackupByServiceNameAndNotebookIdAndBackupId = (
    backupId: string,
    notebookId: string,
    serviceName: string
  ): Promise<CloudProjectAiNotebookBackup> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/ai/notebook/${notebookId}/backup/${backupId}`
    );
  };

  /** Starts a new AI Solutions notebook from a backup */
  postProjectAiNotebookBackupForkByServiceNameAndNotebookIdAndBackupId = (
    backupId: string,
    notebookId: string,
    serviceName: string
  ): Promise<CloudProjectAiNotebookNotebook> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/ai/notebook/${notebookId}/backup/${backupId}/fork`
    );
  };

  /** Starts a manual data synchronization on an AI Solutions notebook */
  postProjectAiNotebookDatasyncByServiceNameAndNotebookId = (
    notebookId: string,
    serviceName: string,
    body: CloudProjectAiVolumeDataSyncSpec
  ): Promise<CloudProjectAiVolumeDataSync> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/ai/notebook/${notebookId}/datasync`,
      body
    );
  };

  /** Update/add an AI Solutions notebook label */
  updateProjectAiNotebookLabelByServiceNameAndNotebookId = (
    notebookId: string,
    serviceName: string,
    body: CloudProjectAiLabel
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/ai/notebook/${notebookId}/label`,
      body
    );
  };

  /** Get the logs of a notebook */
  getProjectAiNotebookLogByServiceNameAndNotebookId = (
    notebookId: string,
    serviceName: string
  ): Promise<CloudProjectAiLogs> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/notebook/${notebookId}/log`);
  };

  /** Start an AI Solutions notebook */
  putProjectAiNotebookStartByServiceNameAndNotebookId = (
    notebookId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('PUT', `/cloud/project/${serviceName}/ai/notebook/${notebookId}/start`);
  };

  /** Stop an AI Solutions notebook */
  putProjectAiNotebookStopByServiceNameAndNotebookId = (
    notebookId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('PUT', `/cloud/project/${serviceName}/ai/notebook/${notebookId}/stop`);
  };

  /** List Docker registries */
  listProjectAiRegistryByServiceName = (
    serviceName: string
  ): Promise<CloudProjectAiRegistryRegistry[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/registry`);
  };

  /** Create a Docker registry */
  createProjectAiRegistryByServiceName = (
    serviceName: string,
    body: CloudProjectAiRegistryRegistry
  ): Promise<CloudProjectAiRegistryRegistry> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/ai/registry`, body);
  };

  /** Delete a Docker registry */
  deleteProjectAiRegistryByServiceNameAndRegistryId = (
    registryId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/ai/registry/${registryId}`);
  };

  /** Get information about a Docker registry */
  getProjectAiRegistryByServiceNameAndRegistryId = (
    registryId: string,
    serviceName: string
  ): Promise<CloudProjectAiRegistryRegistry> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/registry/${registryId}`);
  };

  /** Update a Docker registry */
  updateProjectAiRegistryByServiceNameAndRegistryId = (
    registryId: string,
    serviceName: string,
    body: CloudProjectAiRegistryRegistryUpdateInput
  ): Promise<void> => {
    return this.ovh.request('PUT', `/cloud/project/${serviceName}/ai/registry/${registryId}`, body);
  };

  /** Deprecated - ML Serving is End Of Life - List namespaces of the project */
  getProjectAiServingByServiceName = (
    serviceName: string
  ): Promise<CloudProjectAiServingNamespace[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/serving`);
  };

  /** Deprecated - ML Serving is End Of Life - Create a new namespace */
  postProjectAiServingByServiceName = (
    serviceName: string,
    body: CloudProjectAiServingNamespaceCreation
  ): Promise<CloudProjectAiServingNamespace> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/ai/serving`, body);
  };

  /** Deprecated - ML Serving is End Of Life - Delete a namespace */
  deleteProjectAiServingByServiceNameAndNamespaceId = (
    namespaceId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/ai/serving/${namespaceId}`);
  };

  /** Deprecated - ML Serving is End Of Life - Get the namespace information */
  getProjectAiServingByServiceNameAndNamespaceId = (
    namespaceId: string,
    serviceName: string
  ): Promise<CloudProjectAiServingNamespace> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/serving/${namespaceId}`);
  };

  /** Deprecated - ML Serving is End Of Life - Get metrics token and urls compatible with this token */
  getProjectAiServingMetricsByServiceNameAndNamespaceId = (
    namespaceId: string,
    serviceName: string
  ): Promise<CloudProjectAiServingMetrics> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/ai/serving/${namespaceId}/metrics`
    );
  };

  /** Deprecated - ML Serving is End Of Life - List models */
  getProjectAiServingModelByServiceNameAndNamespaceId = (
    namespaceId: string,
    serviceName: string
  ): Promise<CloudProjectAiServingModel[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/serving/${namespaceId}/model`);
  };

  /** Deprecated - ML Serving is End Of Life - Create a new model */
  postProjectAiServingModelByServiceNameAndNamespaceId = (
    namespaceId: string,
    serviceName: string,
    body: CloudProjectAiServingModelDefinition
  ): Promise<CloudProjectAiServingModel> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/ai/serving/${namespaceId}/model`,
      body
    );
  };

  /** Deprecated - ML Serving is End Of Life - Delete a model */
  deleteProjectAiServingModelByServiceNameAndNamespaceIdAndModelId = (
    modelId: string,
    namespaceId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/ai/serving/${namespaceId}/model/${modelId}`
    );
  };

  /** Deprecated - ML Serving is End Of Life - Get model information */
  getProjectAiServingModelByServiceNameAndNamespaceIdAndModelId = (
    modelId: string,
    namespaceId: string,
    serviceName: string
  ): Promise<CloudProjectAiServingModel> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/ai/serving/${namespaceId}/model/${modelId}`
    );
  };

  /** Deprecated - ML Serving is End Of Life - Update a model */
  putProjectAiServingModelByServiceNameAndNamespaceIdAndModelId = (
    modelId: string,
    namespaceId: string,
    serviceName: string
  ): Promise<CloudProjectAiServingModel> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/ai/serving/${namespaceId}/model/${modelId}`
    );
  };

  /** Deprecated - ML Serving is End Of Life - Detach the current registry */
  deleteProjectAiServingRegistryByServiceNameAndNamespaceId = (
    namespaceId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/ai/serving/${namespaceId}/registry`
    );
  };

  /** Deprecated - ML Serving is End Of Life - Get registry information */
  getProjectAiServingRegistryByServiceNameAndNamespaceId = (
    namespaceId: string,
    serviceName: string
  ): Promise<CloudProjectAiServingRegistry> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/ai/serving/${namespaceId}/registry`
    );
  };

  /** Deprecated - ML Serving is End Of Life - Attach a docker registry */
  postProjectAiServingRegistryByServiceNameAndNamespaceId = (
    namespaceId: string,
    serviceName: string,
    body: CloudProjectAiServingRegistry
  ): Promise<CloudProjectAiServingRegistryResponse> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/ai/serving/${namespaceId}/registry`,
      body
    );
  };

  /** Deprecated - ML Serving is End Of Life - List tokens */
  getProjectAiServingTokenByServiceNameAndNamespaceId = (
    namespaceId: string,
    serviceName: string
  ): Promise<CloudProjectAiServingToken[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/serving/${namespaceId}/token`);
  };

  /** Deprecated - ML Serving is End Of Life - Create a new token */
  postProjectAiServingTokenByServiceNameAndNamespaceId = (
    namespaceId: string,
    serviceName: string,
    body: CloudProjectAiServingToken
  ): Promise<CloudProjectAiServingToken> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/ai/serving/${namespaceId}/token`,
      body
    );
  };

  /** Deprecated - ML Serving is End Of Life - Delete a token */
  deleteProjectAiServingTokenByServiceNameAndNamespaceIdAndTokenId = (
    namespaceId: string,
    serviceName: string,
    tokenId: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/ai/serving/${namespaceId}/token/${tokenId}`
    );
  };

  /** Deprecated - ML Serving is End Of Life - Get token information */
  getProjectAiServingTokenByServiceNameAndNamespaceIdAndTokenId = (
    namespaceId: string,
    serviceName: string,
    tokenId: string
  ): Promise<CloudProjectAiServingToken> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/ai/serving/${namespaceId}/token/${tokenId}`
    );
  };

  /** Deprecated - ML Serving is End Of Life - Renew a new token */
  putProjectAiServingTokenByServiceNameAndNamespaceIdAndTokenId = (
    namespaceId: string,
    serviceName: string,
    tokenId: string
  ): Promise<CloudProjectAiServingToken> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/ai/serving/${namespaceId}/token/${tokenId}`
    );
  };

  /** List application tokens */
  listProjectAiTokenByServiceName = (serviceName: string): Promise<CloudProjectAiTokenToken[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/token`);
  };

  /** Create a new application token */
  createProjectAiTokenByServiceName = (
    serviceName: string,
    body: CloudProjectAiTokenTokenSpec
  ): Promise<CloudProjectAiTokenToken> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/ai/token`, body);
  };

  /** Delete this application token */
  deleteProjectAiTokenByServiceNameAndId = (id: string, serviceName: string): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/ai/token/${id}`);
  };

  /** Get application token information */
  getProjectAiTokenByServiceNameAndId = (
    id: string,
    serviceName: string
  ): Promise<CloudProjectAiTokenToken> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ai/token/${id}`);
  };

  /** Renew an application token */
  postProjectAiTokenRenewByServiceNameAndId = (
    id: string,
    serviceName: string
  ): Promise<CloudProjectAiTokenToken> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/ai/token/${id}/renew`);
  };

  /** Manage alerts on your consumption */
  getProjectAlertingByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/alerting`);
  };

  /** Add new alert */
  addProjectAlertingByServiceName = (
    serviceName: string,
    body: { delay: CloudAlertingDelayEnum; email: string; monthlyThreshold: number }
  ): Promise<CloudAlerting> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/alerting`, body);
  };

  /** Delete alerting */
  deleteProjectAlertingByServiceNameAndId = (id: string, serviceName: string): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/alerting/${id}`);
  };

  /** Get this object properties */
  getProjectAlertingByServiceNameAndId = (
    id: string,
    serviceName: string
  ): Promise<CloudAlerting> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/alerting/${id}`);
  };

  /** Alter this object properties */
  updateProjectAlertingByServiceNameAndId = (
    id: string,
    serviceName: string,
    body: CloudAlerting
  ): Promise<void> => {
    return this.ovh.request('PUT', `/cloud/project/${serviceName}/alerting/${id}`, body);
  };

  /** See alerts */
  getProjectAlertingAlertByServiceNameAndId = (
    id: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/alerting/${id}/alert`);
  };

  /** Get this object properties */
  getProjectAlertingAlertByServiceNameAndIdAndAlertId = (
    alertId: number,
    id: string,
    serviceName: string
  ): Promise<CloudAlertingAlert> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/alerting/${id}/alert/${alertId}`);
  };

  /** Get your project bills */
  getProjectBillByServiceName = (serviceName: string): Promise<CloudProjectBill[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/bill`);
  };

  /** Cancel project creation */
  postProjectCancelByServiceName = (serviceName: string): Promise<void> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/cancel`);
  };

  /** List container registry capabilities per region */
  listProjectCapabilitiesContainerRegistryByServiceName = (
    serviceName: string
  ): Promise<CloudContainerRegistryCapability[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/capabilities/containerRegistry`);
  };

  /** List of admissionPlugins managed by MKS product that can be enabled or disabled. */
  listProjectCapabilitiesKubeAdmissionpluginsByServiceName = (
    serviceName: string
  ): Promise<CloudProjectKubeCustomizationAPIServerAdmissionPluginsEnum[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/capabilities/kube/admissionplugins`
    );
  };

  /** List Kubernetes available flavors for a region */
  listProjectCapabilitiesKubeFlavorsByServiceName = (
    serviceName: string
  ): Promise<CloudKubeFlavor[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/capabilities/kube/flavors`);
  };

  /** List Kubernetes available regions */
  listProjectCapabilitiesKubeRegionsByServiceName = (
    serviceName: string
  ): Promise<CloudKubeRegionEnum[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/capabilities/kube/regions`);
  };

  /** List all available regions */
  listProjectCapabilitiesLoadbalancerRegionByServiceName = (
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/capabilities/loadbalancer/region`
    );
  };

  /** Get specific information of a region */
  getProjectCapabilitiesLoadbalancerRegionByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<CloudProjectLoadbalancerRegion> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/capabilities/loadbalancer/region/${regionName}`
    );
  };

  /** List product availability */
  listProjectCapabilitiesProductAvailabilityByServiceName = (
    serviceName: string
  ): Promise<CloudCapabilitiesAvailability> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/capabilities/productAvailability`
    );
  };

  /** Launch a contact change procedure */
  launchProjectChangeContactByServiceName = (
    serviceName: string,
    body: { contactAdmin?: string; contactBilling?: string; contactTech?: string }
  ): Promise<number[]> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/changeContact`, body);
  };

  /** Confirm termination of your service */
  confirmProjectTerminationByServiceName = (
    serviceName: string,
    body: {
      commentary?: string;
      futureUse?: ServiceTerminationFutureUseEnum;
      reason?: ServiceTerminationReasonEnum;
      token: string;
    }
  ): Promise<string> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/confirmTermination`, body);
  };

  /** Get your project consumption */
  getProjectConsumptionByServiceName = (serviceName: string): Promise<CloudProjectProjectUsage> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/consumption`);
  };

  /** List registries of the project */
  listProjectContainerRegistryByServiceName = (
    serviceName: string
  ): Promise<CloudContainerRegistryRegistry[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/containerRegistry`);
  };

  /** Create a new registry */
  createProjectContainerRegistryByServiceName = (
    serviceName: string,
    body: CloudProjectContainerRegistryCreation
  ): Promise<CloudContainerRegistryRegistry> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/containerRegistry`, body);
  };

  /** Delete a registry */
  deleteProjectContainerRegistryByServiceNameAndRegistryID = (
    registryID: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/containerRegistry/${registryID}`
    );
  };

  /** Get the registry information */
  getProjectContainerRegistryByServiceNameAndRegistryID = (
    registryID: string,
    serviceName: string
  ): Promise<CloudContainerRegistryRegistry> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/containerRegistry/${registryID}`);
  };

  /** Update the registry */
  updateProjectContainerRegistryByServiceNameAndRegistryID = (
    registryID: string,
    serviceName: string,
    body: CloudProjectContainerRegistryUpdate
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/containerRegistry/${registryID}`,
      body
    );
  };

  /** Get available plans for the current registry. */
  getProjectContainerRegistryCapabilitiesPlanByServiceNameAndRegistryID = (
    registryID: string,
    serviceName: string
  ): Promise<CloudContainerRegistryPlan[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/containerRegistry/${registryID}/capabilities/plan`
    );
  };

  /** Show the actual plan of the registry. */
  getProjectContainerRegistryPlanByServiceNameAndRegistryID = (
    registryID: string,
    serviceName: string
  ): Promise<CloudContainerRegistryPlan> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/containerRegistry/${registryID}/plan`
    );
  };

  /** Update the plan of a registry. */
  updateProjectContainerRegistryPlanByServiceNameAndRegistryID = (
    registryID: string,
    serviceName: string,
    body: CloudContainerRegistryPlanUpdate
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/containerRegistry/${registryID}/plan`,
      body
    );
  };

  /** List registry user */
  listProjectContainerRegistryUsersByServiceNameAndRegistryID = (
    registryID: string,
    serviceName: string
  ): Promise<CloudContainerRegistryUser[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/containerRegistry/${registryID}/users`
    );
  };

  /** Create a new registry user */
  createProjectContainerRegistryUsersByServiceNameAndRegistryID = (
    registryID: string,
    serviceName: string,
    body: CloudProjectContainerRegistryUsersCreation
  ): Promise<CloudContainerRegistryUser> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/containerRegistry/${registryID}/users`,
      body
    );
  };

  /** Delete a registry user */
  deleteProjectContainerRegistryUsersByServiceNameAndRegistryIDAndUserID = (
    registryID: string,
    serviceName: string,
    userID: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/containerRegistry/${registryID}/users/${userID}`
    );
  };

  /** Get your credit */
  getProjectCreditByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/credit`);
  };

  /** Add credit to your project */
  addProjectCreditByServiceName = (serviceName: string, body: { code: string }): Promise<void> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/credit`, body);
  };

  /** Get this object properties */
  getProjectCreditByServiceNameAndId = (id: number, serviceName: string): Promise<CloudCredit> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/credit/${id}`);
  };

  /** Get authorization status */
  getProjectDataProcessingAuthorizationByServiceName = (
    serviceName: string
  ): Promise<CloudProjectDataProcessingAuthorizationStatus> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/dataProcessing/authorization`);
  };

  /** Authorization of Data Processing service by allowing access to your object storage containers */
  postProjectDataProcessingAuthorizationByServiceName = (serviceName: string): Promise<void> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/dataProcessing/authorization`);
  };

  /** Data processing capabilities */
  getProjectDataProcessingCapabilitiesByServiceName = (
    serviceName: string
  ): Promise<CloudProjectDataProcessingCapability[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/dataProcessing/capabilities`);
  };

  /** List all jobs */
  listProjectDataProcessingJobsByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/dataProcessing/jobs`);
  };

  /** Submit a job */
  postProjectDataProcessingJobsByServiceName = (
    serviceName: string,
    body: CloudProjectDataProcessingJob
  ): Promise<CloudProjectDataProcessingJob> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/dataProcessing/jobs`, body);
  };

  /** Kill job with given id */
  deleteProjectDataProcessingJobsByServiceNameAndJobId = (
    jobId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/dataProcessing/jobs/${jobId}`);
  };

  /** Get jobs information */
  getProjectDataProcessingJobsByServiceNameAndJobId = (
    jobId: string,
    serviceName: string
  ): Promise<CloudProjectDataProcessingJob> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/dataProcessing/jobs/${jobId}`);
  };

  /** Get the logs of a job */
  getProjectDataProcessingJobsLogsByServiceNameAndJobId = (
    jobId: string,
    serviceName: string
  ): Promise<CloudProjectDataProcessingJobLogs> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/dataProcessing/jobs/${jobId}/logs`
    );
  };

  /** Get metrics token and urls compatible with this token */
  getProjectDataProcessingMetricsByServiceName = (
    serviceName: string
  ): Promise<CloudProjectDataProcessingMetrics> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/dataProcessing/metrics`);
  };

  /** List all notebooks */
  listProjectDataProcessingNotebooksByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/dataProcessing/notebooks`);
  };

  /** Create a notebook */
  createProjectDataProcessingNotebooksByServiceName = (
    serviceName: string,
    body: CloudProjectDataProcessingNotebookNotebookSpec
  ): Promise<CloudProjectDataProcessingNotebookNotebook> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/dataProcessing/notebooks`, body);
  };

  /** Get notebooks capabilities */
  getProjectDataProcessingNotebooksCapabilitiesByServiceName = (
    serviceName: string
  ): Promise<CloudProjectDataProcessingNotebookCapability[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/dataProcessing/notebooks/capabilities`
    );
  };

  /** Delete notebook with given id */
  deleteProjectDataProcessingNotebooksByServiceNameAndNotebookId = (
    notebookId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/dataProcessing/notebooks/${notebookId}`
    );
  };

  /** Get notebook information */
  getProjectDataProcessingNotebooksByServiceNameAndNotebookId = (
    notebookId: string,
    serviceName: string
  ): Promise<CloudProjectDataProcessingNotebookNotebook> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/dataProcessing/notebooks/${notebookId}`
    );
  };

  /** Start a Data Processing notebook */
  putProjectDataProcessingNotebooksStartByServiceNameAndNotebookId = (
    notebookId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/dataProcessing/notebooks/${notebookId}/start`
    );
  };

  /** Stop a Data Processing notebook */
  putProjectDataProcessingNotebooksStopByServiceNameAndNotebookId = (
    notebookId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/dataProcessing/notebooks/${notebookId}/stop`
    );
  };

  /** Get database engines availability */
  getProjectDatabaseAvailabilityByServiceName = (
    serviceName: string
  ): Promise<CloudProjectDatabaseAvailability[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/availability`);
  };

  /** Get database engines capabilities */
  getProjectDatabaseCapabilitiesByServiceName = (
    serviceName: string
  ): Promise<CloudProjectDatabaseCapabilities> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/capabilities`);
  };

  /** List all the cassandra clusters of the project */
  listProjectDatabaseCassandraByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/cassandra`);
  };

  /** Create a new cassandra cluster */
  createProjectDatabaseCassandraByServiceName = (
    serviceName: string,
    body: CloudProjectDatabaseServiceCreation
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/database/cassandra`, body);
  };

  /** Delete a cassandra cluster */
  deleteProjectDatabaseCassandraByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}`
    );
  };

  /** Get cassandra cluster properties */
  getProjectDatabaseCassandraByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/cassandra/${clusterId}`);
  };

  /** Update an existing cassandra cluster */
  updateProjectDatabaseCassandraByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseService
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}`,
      body
    );
  };

  /** Get cassandra advanced configuration */
  getProjectDatabaseCassandraAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<Record<string, string>> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/advancedConfiguration`
    );
  };

  /** Update cassandra advanced configuration */
  updateProjectDatabaseCassandraAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: Record<string, string>
  ): Promise<Record<string, string>> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/advancedConfiguration`,
      body
    );
  };

  /** List backups of the cassandra */
  listProjectDatabaseCassandraBackupByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/backup`
    );
  };

  /** Get cassandra backups */
  getProjectDatabaseCassandraBackupByServiceNameAndClusterIdAndBackupId = (
    backupId: string,
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceBackup> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/backup/${backupId}`
    );
  };

  /** Get cassandra advanced configuration fields */
  getProjectDatabaseCassandraCapabilitiesAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseCapabilitiesAdvancedConfigurationProperty[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/capabilities/advancedConfiguration`
    );
  };

  /** Get integration capabilities related to the cassandra service */
  getProjectDatabaseCassandraCapabilitiesIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseCapabilitiesIntegration[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/capabilities/integration`
    );
  };

  /** Retrieve the certificates of the cassandra cluster */
  getProjectDatabaseCassandraCertificatesByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceCertificates> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/certificates`
    );
  };

  /** List integrations */
  listProjectDatabaseCassandraIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/integration`
    );
  };

  /** Create a new integration */
  createProjectDatabaseCassandraIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceIntegration
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/integration`,
      body
    );
  };

  /** Delete an integration */
  deleteProjectDatabaseCassandraIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/integration/${integrationId}`
    );
  };

  /** Get an integration */
  getProjectDatabaseCassandraIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/integration/${integrationId}`
    );
  };

  /** List cassandra ip restrictions */
  listProjectDatabaseCassandraIpRestrictionByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/ipRestriction`
    );
  };

  /** Add ip restrictions to the cassandra */
  addProjectDatabaseCassandraIpRestrictionByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseIpRestrictionCreation
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/ipRestriction`,
      body
    );
  };

  /** Deletes the given IP from the restricted IPs of the cassandra */
  deleteProjectDatabaseCassandraIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/ipRestriction/${ipBlock}`
    );
  };

  /** Get cassandra ip restrictions */
  getProjectDatabaseCassandraIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/ipRestriction/${ipBlock}`
    );
  };

  /** Changes the list of ip restrictions to the cassandra */
  updateProjectDatabaseCassandraIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string,
    body: CloudProjectDatabaseIpRestriction
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/ipRestriction/${ipBlock}`,
      body
    );
  };

  /** Retrieve the most recent cassandra log messages (limited to 1000) */
  getProjectDatabaseCassandraLogsByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceLogEntry[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/logs`
    );
  };

  /** List maintenances for the cassandra cluster */
  listProjectDatabaseCassandraMaintenanceByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/maintenance`
    );
  };

  /** Get the maintenance for the cassandra cluster */
  getProjectDatabaseCassandraMaintenanceByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/maintenance/${maintenanceId}`
    );
  };

  /** Apply the maintenance */
  postProjectDatabaseCassandraMaintenanceApplyByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/maintenance/${maintenanceId}/apply`
    );
  };

  /** List available metrics for the cassandra cluster */
  listProjectDatabaseCassandraMetricByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/metric`
    );
  };

  /** Get the metric values for the cassandra cluster */
  getProjectDatabaseCassandraMetricByServiceNameAndClusterIdAndMetricName = (
    clusterId: string,
    metricName: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMetric> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/metric/${metricName}`
    );
  };

  /** List nodes of the cassandra */
  listProjectDatabaseCassandraNodeByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/node`
    );
  };

  /** Get cassandra nodes */
  getProjectDatabaseCassandraNodeByServiceNameAndClusterIdAndNodeId = (
    clusterId: string,
    nodeId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceNode> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/node/${nodeId}`
    );
  };

  /** List users of the cassandra */
  listProjectDatabaseCassandraUserByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/user`
    );
  };

  /** Create a new user on the cassandra cluster */
  createProjectDatabaseCassandraUserByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceUserCreation
  ): Promise<CloudProjectDatabaseServiceUserWithPassword> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/user`,
      body
    );
  };

  /** Delete a cassandra user */
  deleteProjectDatabaseCassandraUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/user/${userId}`
    );
  };

  /** Get cassandra users */
  getProjectDatabaseCassandraUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<CloudProjectDatabaseServiceUser> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/user/${userId}`
    );
  };

  /** Resets the password of a user */
  postProjectDatabaseCassandraUserCredentialsResetByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<CloudProjectDatabaseServiceUserWithPassword> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/cassandra/${clusterId}/user/${userId}/credentials/reset`
    );
  };

  /** List all the grafana of the project */
  listProjectDatabaseGrafanaByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/grafana`);
  };

  /** Create a new grafana cluster */
  createProjectDatabaseGrafanaByServiceName = (
    serviceName: string,
    body: CloudProjectDatabaseServiceCreation
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/database/grafana`, body);
  };

  /** Delete a grafana cluster */
  deleteProjectDatabaseGrafanaByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}`
    );
  };

  /** Get grafana cluster properties */
  getProjectDatabaseGrafanaByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/grafana/${clusterId}`);
  };

  /** Update an existing grafana cluster */
  updateProjectDatabaseGrafanaByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseService
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}`,
      body
    );
  };

  /** Get grafana advanced configuration */
  getProjectDatabaseGrafanaAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<Record<string, string>> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/advancedConfiguration`
    );
  };

  /** Update grafana advanced configuration */
  updateProjectDatabaseGrafanaAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: Record<string, string>
  ): Promise<Record<string, string>> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/advancedConfiguration`,
      body
    );
  };

  /** List backups of the grafana */
  listProjectDatabaseGrafanaBackupByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/backup`
    );
  };

  /** Get grafana backups */
  getProjectDatabaseGrafanaBackupByServiceNameAndClusterIdAndBackupId = (
    backupId: string,
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceBackup> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/backup/${backupId}`
    );
  };

  /** Get grafana advanced configuration fields */
  getProjectDatabaseGrafanaCapabilitiesAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseCapabilitiesAdvancedConfigurationProperty[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/capabilities/advancedConfiguration`
    );
  };

  /** Get integration capabilities related to the grafana service */
  getProjectDatabaseGrafanaCapabilitiesIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseCapabilitiesIntegration[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/capabilities/integration`
    );
  };

  /** List integrations */
  listProjectDatabaseGrafanaIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/integration`
    );
  };

  /** Create a new integration */
  createProjectDatabaseGrafanaIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceIntegration
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/integration`,
      body
    );
  };

  /** Delete an integration */
  deleteProjectDatabaseGrafanaIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/integration/${integrationId}`
    );
  };

  /** Get an integration */
  getProjectDatabaseGrafanaIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/integration/${integrationId}`
    );
  };

  /** List grafana ip restrictions */
  listProjectDatabaseGrafanaIpRestrictionByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/ipRestriction`
    );
  };

  /** Add ip restrictions to the grafana */
  addProjectDatabaseGrafanaIpRestrictionByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseIpRestrictionCreation
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/ipRestriction`,
      body
    );
  };

  /** Deletes the given IP from the restricted IPs of the grafana */
  deleteProjectDatabaseGrafanaIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/ipRestriction/${ipBlock}`
    );
  };

  /** Get grafana ip restrictions */
  getProjectDatabaseGrafanaIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/ipRestriction/${ipBlock}`
    );
  };

  /** Changes the list of ip restrictions to the grafana */
  updateProjectDatabaseGrafanaIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string,
    body: CloudProjectDatabaseIpRestriction
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/ipRestriction/${ipBlock}`,
      body
    );
  };

  /** Retrieve the most recent grafana log messages (limited to 1000) */
  getProjectDatabaseGrafanaLogsByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceLogEntry[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/logs`
    );
  };

  /** List maintenances for the grafana cluster */
  listProjectDatabaseGrafanaMaintenanceByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/maintenance`
    );
  };

  /** Get the maintenance for the grafana cluster */
  getProjectDatabaseGrafanaMaintenanceByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/maintenance/${maintenanceId}`
    );
  };

  /** Apply the maintenance */
  postProjectDatabaseGrafanaMaintenanceApplyByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/maintenance/${maintenanceId}/apply`
    );
  };

  /** List available metrics for the grafana cluster */
  listProjectDatabaseGrafanaMetricByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/metric`
    );
  };

  /** Get the metric values for the grafana cluster */
  getProjectDatabaseGrafanaMetricByServiceNameAndClusterIdAndMetricName = (
    clusterId: string,
    metricName: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMetric> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/metric/${metricName}`
    );
  };

  /** List nodes of the grafana */
  listProjectDatabaseGrafanaNodeByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/node`
    );
  };

  /** Get grafana nodes */
  getProjectDatabaseGrafanaNodeByServiceNameAndClusterIdAndNodeId = (
    clusterId: string,
    nodeId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceNode> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/node/${nodeId}`
    );
  };

  /** List users of the grafana */
  listProjectDatabaseGrafanaUserByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/user`
    );
  };

  /** Get grafana users */
  getProjectDatabaseGrafanaUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<CloudProjectDatabaseServiceUser> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/user/${userId}`
    );
  };

  /** Resets the password of a user */
  postProjectDatabaseGrafanaUserCredentialsResetByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<CloudProjectDatabaseServiceUserWithPassword> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/grafana/${clusterId}/user/${userId}/credentials/reset`
    );
  };

  /** List all the kafka of the project */
  listProjectDatabaseKafkaByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/kafka`);
  };

  /** Create a new kafka cluster */
  createProjectDatabaseKafkaByServiceName = (
    serviceName: string,
    body: CloudProjectDatabaseServiceCreation
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/database/kafka`, body);
  };

  /** Delete a kafka cluster */
  deleteProjectDatabaseKafkaByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/database/kafka/${clusterId}`);
  };

  /** Get kafka cluster properties */
  getProjectDatabaseKafkaByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseKafkaService> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/kafka/${clusterId}`);
  };

  /** Update an existing kafka cluster */
  updateProjectDatabaseKafkaByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseKafkaService
  ): Promise<CloudProjectDatabaseKafkaService> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}`,
      body
    );
  };

  /** List acls of the kafka */
  listProjectDatabaseKafkaAclByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/kafka/${clusterId}/acl`);
  };

  /** Create a new acl on the kafka cluster */
  createProjectDatabaseKafkaAclByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseKafkaAcl
  ): Promise<CloudProjectDatabaseKafkaAcl> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/acl`,
      body
    );
  };

  /** Delete a kafka acl */
  deleteProjectDatabaseKafkaAclByServiceNameAndClusterIdAndAclId = (
    aclId: string,
    clusterId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/acl/${aclId}`
    );
  };

  /** Get kafka acls */
  getProjectDatabaseKafkaAclByServiceNameAndClusterIdAndAclId = (
    aclId: string,
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseKafkaAcl> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/acl/${aclId}`
    );
  };

  /** Get kafka advanced configuration */
  getProjectDatabaseKafkaAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<Record<string, string>> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/advancedConfiguration`
    );
  };

  /** Update kafka advanced configuration */
  updateProjectDatabaseKafkaAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: Record<string, string>
  ): Promise<Record<string, string>> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/advancedConfiguration`,
      body
    );
  };

  /** Get kafka advanced configuration fields */
  getProjectDatabaseKafkaCapabilitiesAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseCapabilitiesAdvancedConfigurationProperty[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/capabilities/advancedConfiguration`
    );
  };

  /** Get integration capabilities related to the kafka service */
  getProjectDatabaseKafkaCapabilitiesIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseCapabilitiesIntegration[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/capabilities/integration`
    );
  };

  /** Retrieve the certificates of the kafka cluster */
  getProjectDatabaseKafkaCertificatesByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceCertificates> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/certificates`
    );
  };

  /** List integrations */
  listProjectDatabaseKafkaIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/integration`
    );
  };

  /** Create a new integration */
  createProjectDatabaseKafkaIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceIntegration
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/integration`,
      body
    );
  };

  /** Delete an integration */
  deleteProjectDatabaseKafkaIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/integration/${integrationId}`
    );
  };

  /** Get an integration */
  getProjectDatabaseKafkaIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/integration/${integrationId}`
    );
  };

  /** List kafka ip restrictions */
  listProjectDatabaseKafkaIpRestrictionByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/ipRestriction`
    );
  };

  /** Add ip restrictions to the kafka */
  addProjectDatabaseKafkaIpRestrictionByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseIpRestrictionCreation
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/ipRestriction`,
      body
    );
  };

  /** Deletes the given IP from the restricted IPs of the kafka */
  deleteProjectDatabaseKafkaIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/ipRestriction/${ipBlock}`
    );
  };

  /** Get kafka ip restrictions */
  getProjectDatabaseKafkaIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/ipRestriction/${ipBlock}`
    );
  };

  /** Changes the list of ip restrictions to the kafka */
  updateProjectDatabaseKafkaIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string,
    body: CloudProjectDatabaseIpRestriction
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/ipRestriction/${ipBlock}`,
      body
    );
  };

  /** Retrieve the most recent kafka log messages (limited to 1000) */
  getProjectDatabaseKafkaLogsByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceLogEntry[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/logs`
    );
  };

  /** List maintenances for the kafka cluster */
  listProjectDatabaseKafkaMaintenanceByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/maintenance`
    );
  };

  /** Get the maintenance for the kafka cluster */
  getProjectDatabaseKafkaMaintenanceByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/maintenance/${maintenanceId}`
    );
  };

  /** Apply the maintenance */
  postProjectDatabaseKafkaMaintenanceApplyByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/maintenance/${maintenanceId}/apply`
    );
  };

  /** List available metrics for the kafka cluster */
  listProjectDatabaseKafkaMetricByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/metric`
    );
  };

  /** Get the metric values for the kafka cluster */
  getProjectDatabaseKafkaMetricByServiceNameAndClusterIdAndMetricName = (
    clusterId: string,
    metricName: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMetric> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/metric/${metricName}`
    );
  };

  /** List nodes of the kafka */
  listProjectDatabaseKafkaNodeByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/node`
    );
  };

  /** Get kafka nodes */
  getProjectDatabaseKafkaNodeByServiceNameAndClusterIdAndNodeId = (
    clusterId: string,
    nodeId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceNode> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/node/${nodeId}`
    );
  };

  /** Retrieve the permissions available on the cluster */
  getProjectDatabaseKafkaPermissionsByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseKafkaPermissions> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/permissions`
    );
  };

  /** List topics of the kafka */
  listProjectDatabaseKafkaTopicByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/topic`
    );
  };

  /** Create a new topic on the kafka cluster */
  createProjectDatabaseKafkaTopicByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseKafkaTopicCreation
  ): Promise<CloudProjectDatabaseKafkaTopic> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/topic`,
      body
    );
  };

  /** Delete a kafka topic */
  deleteProjectDatabaseKafkaTopicByServiceNameAndClusterIdAndTopicId = (
    clusterId: string,
    serviceName: string,
    topicId: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/topic/${topicId}`
    );
  };

  /** Get kafka topics */
  getProjectDatabaseKafkaTopicByServiceNameAndClusterIdAndTopicId = (
    clusterId: string,
    serviceName: string,
    topicId: string
  ): Promise<CloudProjectDatabaseKafkaTopic> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/topic/${topicId}`
    );
  };

  /** Updates the topic on the kafka cluster */
  updateProjectDatabaseKafkaTopicByServiceNameAndClusterIdAndTopicId = (
    clusterId: string,
    serviceName: string,
    topicId: string,
    body: CloudProjectDatabaseKafkaTopic
  ): Promise<CloudProjectDatabaseKafkaTopic> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/topic/${topicId}`,
      body
    );
  };

  /** List users of the kafka */
  listProjectDatabaseKafkaUserByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/user`
    );
  };

  /** Create a new user on the kafka cluster */
  createProjectDatabaseKafkaUserByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceUserCreation
  ): Promise<CloudProjectDatabaseServiceUserWithPassword> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/user`,
      body
    );
  };

  /** Delete a kafka user */
  deleteProjectDatabaseKafkaUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/user/${userId}`
    );
  };

  /** Get kafka users */
  getProjectDatabaseKafkaUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<CloudProjectDatabaseServiceUser> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/user/${userId}`
    );
  };

  /** Retrieve the user acces for the cluster */
  getProjectDatabaseKafkaUserAccessByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<CloudProjectDatabaseKafkaUserAccess> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/user/${userId}/access`
    );
  };

  /** Resets the password of a user */
  postProjectDatabaseKafkaUserCredentialsResetByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<CloudProjectDatabaseServiceUserWithPassword> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/kafka/${clusterId}/user/${userId}/credentials/reset`
    );
  };

  /** List all the kafkaConnect of the project */
  listProjectDatabaseKafkaConnectByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/kafkaConnect`);
  };

  /** Create a new kafkaConnect cluster */
  createProjectDatabaseKafkaConnectByServiceName = (
    serviceName: string,
    body: CloudProjectDatabaseServiceCreation
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/database/kafkaConnect`, body);
  };

  /** Delete a kafkaConnect cluster */
  deleteProjectDatabaseKafkaConnectByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}`
    );
  };

  /** Get kafkaConnect cluster properties */
  getProjectDatabaseKafkaConnectByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}`
    );
  };

  /** Update an existing kafkaConnect cluster */
  updateProjectDatabaseKafkaConnectByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseService
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}`,
      body
    );
  };

  /** Get kafkaConnect advanced configuration */
  getProjectDatabaseKafkaConnectAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<Record<string, string>> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/advancedConfiguration`
    );
  };

  /** Update kafkaConnect advanced configuration */
  updateProjectDatabaseKafkaConnectAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: Record<string, string>
  ): Promise<Record<string, string>> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/advancedConfiguration`,
      body
    );
  };

  /** Get kafkaConnect advanced configuration fields */
  getProjectDatabaseKafkaConnectCapabilitiesAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseCapabilitiesAdvancedConfigurationProperty[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/capabilities/advancedConfiguration`
    );
  };

  /** List Kafka Connect connectors */
  listProjectDatabaseKafkaConnectCapabilitiesConnectorByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/capabilities/connector`
    );
  };

  /** Get Kafka Connect connector capability */
  getProjectDatabaseKafkaConnectCapabilitiesConnectorByServiceNameAndClusterIdAndConnectorId = (
    clusterId: string,
    connectorId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseKafkaConnectCapabilitiesConnector> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/capabilities/connector/${connectorId}`
    );
  };

  /** Get Kafka Connect connector configuration */
  getProjectDatabaseKafkaConnectCapabilitiesConnectorConfigurationByServiceNameAndClusterIdAndConnectorId =
    (
      clusterId: string,
      connectorId: string,
      serviceName: string
    ): Promise<CloudProjectDatabaseKafkaConnectCapabilitiesConnectorConfigurationProperty[]> => {
      return this.ovh.request(
        'GET',
        `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/capabilities/connector/${connectorId}/configuration`
      );
    };

  /** Get Kafka Connect connector transforms */
  getProjectDatabaseKafkaConnectCapabilitiesConnectorTransformsByServiceNameAndClusterIdAndConnectorId =
    (
      clusterId: string,
      connectorId: string,
      serviceName: string
    ): Promise<CloudProjectDatabaseKafkaConnectCapabilitiesConnectorTransform[]> => {
      return this.ovh.request(
        'GET',
        `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/capabilities/connector/${connectorId}/transforms`
      );
    };

  /** Get integration capabilities related to the kafkaConnect service */
  getProjectDatabaseKafkaConnectCapabilitiesIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseCapabilitiesIntegration[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/capabilities/integration`
    );
  };

  /** List the connectors */
  listProjectDatabaseKafkaConnectConnectorByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/connector`
    );
  };

  /** Create a new connector */
  createProjectDatabaseKafkaConnectConnectorByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseKafkaConnectConnectorCreation
  ): Promise<CloudProjectDatabaseKafkaConnectConnector> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/connector`,
      body
    );
  };

  /** Delete a connector */
  deleteProjectDatabaseKafkaConnectConnectorByServiceNameAndClusterIdAndConnectorId = (
    clusterId: string,
    connectorId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/connector/${connectorId}`
    );
  };

  /** Get connector */
  getProjectDatabaseKafkaConnectConnectorByServiceNameAndClusterIdAndConnectorId = (
    clusterId: string,
    connectorId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseKafkaConnectConnector> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/connector/${connectorId}`
    );
  };

  /** Update a connector */
  updateProjectDatabaseKafkaConnectConnectorByServiceNameAndClusterIdAndConnectorId = (
    clusterId: string,
    connectorId: string,
    serviceName: string,
    body: CloudProjectDatabaseKafkaConnectConnector
  ): Promise<CloudProjectDatabaseKafkaConnectConnector> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/connector/${connectorId}`,
      body
    );
  };

  /** Pause the kafka connector execution */
  postProjectDatabaseKafkaConnectConnectorPauseByServiceNameAndClusterIdAndConnectorId = (
    clusterId: string,
    connectorId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/connector/${connectorId}/pause`
    );
  };

  /** Restart the kafka connector execution */
  postProjectDatabaseKafkaConnectConnectorRestartByServiceNameAndClusterIdAndConnectorId = (
    clusterId: string,
    connectorId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/connector/${connectorId}/restart`
    );
  };

  /** Resume the kafka connector execution */
  postProjectDatabaseKafkaConnectConnectorResumeByServiceNameAndClusterIdAndConnectorId = (
    clusterId: string,
    connectorId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/connector/${connectorId}/resume`
    );
  };

  /** List the connector tasks */
  listProjectDatabaseKafkaConnectConnectorTaskByServiceNameAndClusterIdAndConnectorId = (
    clusterId: string,
    connectorId: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/connector/${connectorId}/task`
    );
  };

  /** Get connector task */
  getProjectDatabaseKafkaConnectConnectorTaskByServiceNameAndClusterIdAndConnectorIdAndTaskId = (
    clusterId: string,
    connectorId: string,
    serviceName: string,
    taskId: number
  ): Promise<CloudProjectDatabaseKafkaConnectConnectorTask> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/connector/${connectorId}/task/${taskId}`
    );
  };

  /** Restart the kafka connector task execution */
  postProjectDatabaseKafkaConnectConnectorTaskRestartByServiceNameAndClusterIdAndConnectorIdAndTaskId =
    (
      clusterId: string,
      connectorId: string,
      serviceName: string,
      taskId: number
    ): Promise<void> => {
      return this.ovh.request(
        'POST',
        `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/connector/${connectorId}/task/${taskId}/restart`
      );
    };

  /** List integrations */
  listProjectDatabaseKafkaConnectIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/integration`
    );
  };

  /** Create a new integration */
  createProjectDatabaseKafkaConnectIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceIntegration
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/integration`,
      body
    );
  };

  /** Delete an integration */
  deleteProjectDatabaseKafkaConnectIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/integration/${integrationId}`
    );
  };

  /** Get an integration */
  getProjectDatabaseKafkaConnectIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/integration/${integrationId}`
    );
  };

  /** List kafkaConnect ip restrictions */
  listProjectDatabaseKafkaConnectIpRestrictionByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/ipRestriction`
    );
  };

  /** Add ip restrictions to the kafkaConnect */
  addProjectDatabaseKafkaConnectIpRestrictionByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseIpRestrictionCreation
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/ipRestriction`,
      body
    );
  };

  /** Deletes the given IP from the restricted IPs of the kafkaConnect */
  deleteProjectDatabaseKafkaConnectIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/ipRestriction/${ipBlock}`
    );
  };

  /** Get kafkaConnect ip restrictions */
  getProjectDatabaseKafkaConnectIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/ipRestriction/${ipBlock}`
    );
  };

  /** Changes the list of ip restrictions to the kafkaConnect */
  updateProjectDatabaseKafkaConnectIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string,
    body: CloudProjectDatabaseIpRestriction
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/ipRestriction/${ipBlock}`,
      body
    );
  };

  /** Retrieve the most recent kafkaConnect log messages (limited to 1000) */
  getProjectDatabaseKafkaConnectLogsByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceLogEntry[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/logs`
    );
  };

  /** List maintenances for the kafka connect cluster */
  listProjectDatabaseKafkaConnectMaintenanceByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/maintenance`
    );
  };

  /** Get the maintenance for the kafka connect cluster */
  getProjectDatabaseKafkaConnectMaintenanceByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/maintenance/${maintenanceId}`
    );
  };

  /** Apply the maintenance */
  postProjectDatabaseKafkaConnectMaintenanceApplyByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/maintenance/${maintenanceId}/apply`
    );
  };

  /** List available metrics for the kafkaConnect cluster */
  listProjectDatabaseKafkaConnectMetricByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/metric`
    );
  };

  /** Get the metric values for the kafkaConnect cluster */
  getProjectDatabaseKafkaConnectMetricByServiceNameAndClusterIdAndMetricName = (
    clusterId: string,
    metricName: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMetric> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/metric/${metricName}`
    );
  };

  /** List nodes of the kafkaConnect */
  listProjectDatabaseKafkaConnectNodeByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/node`
    );
  };

  /** Get kafkaConnect nodes */
  getProjectDatabaseKafkaConnectNodeByServiceNameAndClusterIdAndNodeId = (
    clusterId: string,
    nodeId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceNode> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/node/${nodeId}`
    );
  };

  /** List users of the kafkaConnect */
  listProjectDatabaseKafkaConnectUserByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/user`
    );
  };

  /** Create a new user on the kafkaConnect cluster */
  createProjectDatabaseKafkaConnectUserByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceUserCreation
  ): Promise<CloudProjectDatabaseServiceUserWithPassword> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/user`,
      body
    );
  };

  /** Delete a kafkaConnect user */
  deleteProjectDatabaseKafkaConnectUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/user/${userId}`
    );
  };

  /** Get kafkaConnect users */
  getProjectDatabaseKafkaConnectUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<CloudProjectDatabaseServiceUser> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/user/${userId}`
    );
  };

  /** Resets the password of a user */
  postProjectDatabaseKafkaConnectUserCredentialsResetByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<CloudProjectDatabaseServiceUserWithPassword> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/kafkaConnect/${clusterId}/user/${userId}/credentials/reset`
    );
  };

  /** List all the kafkaMirrorMaker of the project */
  listProjectDatabaseKafkaMirrorMakerByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/kafkaMirrorMaker`);
  };

  /** Create a new kafkaMirrorMaker */
  createProjectDatabaseKafkaMirrorMakerByServiceName = (
    serviceName: string,
    body: CloudProjectDatabaseServiceCreation
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker`,
      body
    );
  };

  /** Delete a kafkaMirrorMaker */
  deleteProjectDatabaseKafkaMirrorMakerByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker/${clusterId}`
    );
  };

  /** Get kafkaMirrorMaker properties */
  getProjectDatabaseKafkaMirrorMakerByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker/${clusterId}`
    );
  };

  /** Update an existing kafkaMirrorMaker */
  updateProjectDatabaseKafkaMirrorMakerByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseService
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker/${clusterId}`,
      body
    );
  };

  /** Get integration capabilities related to the kafkaMirrorMaker service */
  getProjectDatabaseKafkaMirrorMakerCapabilitiesIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseCapabilitiesIntegration[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker/${clusterId}/capabilities/integration`
    );
  };

  /** List integrations */
  listProjectDatabaseKafkaMirrorMakerIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker/${clusterId}/integration`
    );
  };

  /** Create a new integration */
  createProjectDatabaseKafkaMirrorMakerIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceIntegration
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker/${clusterId}/integration`,
      body
    );
  };

  /** Delete an integration */
  deleteProjectDatabaseKafkaMirrorMakerIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker/${clusterId}/integration/${integrationId}`
    );
  };

  /** Get an integration */
  getProjectDatabaseKafkaMirrorMakerIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker/${clusterId}/integration/${integrationId}`
    );
  };

  /** Retrieve the most recent kafkaMirrorMaker log messages (limited to 1000) */
  getProjectDatabaseKafkaMirrorMakerLogsByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceLogEntry[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker/${clusterId}/logs`
    );
  };

  /** List maintenances for the kafka mirror maker cluster */
  listProjectDatabaseKafkaMirrorMakerMaintenanceByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker/${clusterId}/maintenance`
    );
  };

  /** Get the maintenance for the kafka mirror maker cluster */
  getProjectDatabaseKafkaMirrorMakerMaintenanceByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker/${clusterId}/maintenance/${maintenanceId}`
    );
  };

  /** Apply the maintenance */
  postProjectDatabaseKafkaMirrorMakerMaintenanceApplyByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker/${clusterId}/maintenance/${maintenanceId}/apply`
    );
  };

  /** List available metrics for the kafkaMirrorMaker */
  listProjectDatabaseKafkaMirrorMakerMetricByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker/${clusterId}/metric`
    );
  };

  /** Get the metric values for the kafkaMirrorMaker */
  getProjectDatabaseKafkaMirrorMakerMetricByServiceNameAndClusterIdAndMetricName = (
    clusterId: string,
    metricName: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMetric> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker/${clusterId}/metric/${metricName}`
    );
  };

  /** List nodes of the kafkaMirrorMaker */
  listProjectDatabaseKafkaMirrorMakerNodeByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker/${clusterId}/node`
    );
  };

  /** Get kafkaMirrorMaker nodes */
  getProjectDatabaseKafkaMirrorMakerNodeByServiceNameAndClusterIdAndNodeId = (
    clusterId: string,
    nodeId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceNode> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker/${clusterId}/node/${nodeId}`
    );
  };

  /** List replication of the kafkaMirrorMaker */
  listProjectDatabaseKafkaMirrorMakerReplicationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker/${clusterId}/replication`
    );
  };

  /** Create a new replication */
  createProjectDatabaseKafkaMirrorMakerReplicationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceReplicationCreation
  ): Promise<CloudProjectDatabaseServiceReplication> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker/${clusterId}/replication`,
      body
    );
  };

  /** Delete an replication */
  deleteProjectDatabaseKafkaMirrorMakerReplicationByServiceNameAndClusterIdAndReplicationId = (
    clusterId: string,
    replicationId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker/${clusterId}/replication/${replicationId}`
    );
  };

  /** Get kafkaMirrorMaker replication */
  getProjectDatabaseKafkaMirrorMakerReplicationByServiceNameAndClusterIdAndReplicationId = (
    clusterId: string,
    replicationId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceReplication> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker/${clusterId}/replication/${replicationId}`
    );
  };

  /** Updates a replication */
  updateProjectDatabaseKafkaMirrorMakerReplicationByServiceNameAndClusterIdAndReplicationId = (
    clusterId: string,
    replicationId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceReplication
  ): Promise<CloudProjectDatabaseServiceReplication> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/kafkaMirrorMaker/${clusterId}/replication/${replicationId}`,
      body
    );
  };

  /** List all the m3aggregator of the project */
  listProjectDatabaseM3aggregatorByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/m3aggregator`);
  };

  /** Create a new m3aggregator */
  createProjectDatabaseM3aggregatorByServiceName = (
    serviceName: string,
    body: CloudProjectDatabaseServiceCreation
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/database/m3aggregator`, body);
  };

  /** Delete a m3aggregator */
  deleteProjectDatabaseM3aggregatorByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/m3aggregator/${clusterId}`
    );
  };

  /** Get m3aggregator properties */
  getProjectDatabaseM3aggregatorByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3aggregator/${clusterId}`
    );
  };

  /** Update an existing m3aggregator */
  updateProjectDatabaseM3aggregatorByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseService
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/m3aggregator/${clusterId}`,
      body
    );
  };

  /** Get integration capabilities related to the m3aggregator service */
  getProjectDatabaseM3aggregatorCapabilitiesIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseCapabilitiesIntegration[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3aggregator/${clusterId}/capabilities/integration`
    );
  };

  /** List integrations */
  listProjectDatabaseM3aggregatorIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3aggregator/${clusterId}/integration`
    );
  };

  /** Create a new integration */
  createProjectDatabaseM3aggregatorIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceIntegration
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/m3aggregator/${clusterId}/integration`,
      body
    );
  };

  /** Delete an integration */
  deleteProjectDatabaseM3aggregatorIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/m3aggregator/${clusterId}/integration/${integrationId}`
    );
  };

  /** Get an integration */
  getProjectDatabaseM3aggregatorIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3aggregator/${clusterId}/integration/${integrationId}`
    );
  };

  /** Retrieve the most recent m3aggregator log messages (limited to 1000) */
  getProjectDatabaseM3aggregatorLogsByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceLogEntry[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3aggregator/${clusterId}/logs`
    );
  };

  /** List maintenances for the m3aggregator cluster */
  listProjectDatabaseM3aggregatorMaintenanceByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3aggregator/${clusterId}/maintenance`
    );
  };

  /** Get the maintenance for the m3aggregator cluster */
  getProjectDatabaseM3aggregatorMaintenanceByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3aggregator/${clusterId}/maintenance/${maintenanceId}`
    );
  };

  /** Apply the maintenance */
  postProjectDatabaseM3aggregatorMaintenanceApplyByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/m3aggregator/${clusterId}/maintenance/${maintenanceId}/apply`
    );
  };

  /** List available metrics for the m3aggregator */
  listProjectDatabaseM3aggregatorMetricByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3aggregator/${clusterId}/metric`
    );
  };

  /** Get the metric values for the m3aggregator */
  getProjectDatabaseM3aggregatorMetricByServiceNameAndClusterIdAndMetricName = (
    clusterId: string,
    metricName: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMetric> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3aggregator/${clusterId}/metric/${metricName}`
    );
  };

  /** List nodes of the m3aggregator */
  listProjectDatabaseM3aggregatorNodeByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3aggregator/${clusterId}/node`
    );
  };

  /** Get m3aggregator nodes */
  getProjectDatabaseM3aggregatorNodeByServiceNameAndClusterIdAndNodeId = (
    clusterId: string,
    nodeId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceNode> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3aggregator/${clusterId}/node/${nodeId}`
    );
  };

  /** List all the m3db clusters of the project */
  listProjectDatabaseM3dbByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/m3db`);
  };

  /** Create a new m3db cluster */
  createProjectDatabaseM3dbByServiceName = (
    serviceName: string,
    body: CloudProjectDatabaseServiceCreation
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/database/m3db`, body);
  };

  /** Delete a m3db cluster */
  deleteProjectDatabaseM3dbByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/database/m3db/${clusterId}`);
  };

  /** Get m3db cluster properties */
  getProjectDatabaseM3dbByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/m3db/${clusterId}`);
  };

  /** Update an existing m3db cluster */
  updateProjectDatabaseM3dbByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseService
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}`,
      body
    );
  };

  /** Get m3db advanced configuration */
  getProjectDatabaseM3dbAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<Record<string, string>> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/advancedConfiguration`
    );
  };

  /** Update m3db advanced configuration */
  updateProjectDatabaseM3dbAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: Record<string, string>
  ): Promise<Record<string, string>> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/advancedConfiguration`,
      body
    );
  };

  /** List backups of the m3db */
  listProjectDatabaseM3dbBackupByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/backup`
    );
  };

  /** Get m3db backups */
  getProjectDatabaseM3dbBackupByServiceNameAndClusterIdAndBackupId = (
    backupId: string,
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceBackup> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/backup/${backupId}`
    );
  };

  /** Get m3db advanced configuration fields */
  getProjectDatabaseM3dbCapabilitiesAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseCapabilitiesAdvancedConfigurationProperty[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/capabilities/advancedConfiguration`
    );
  };

  /** Get integration capabilities related to the m3db service */
  getProjectDatabaseM3dbCapabilitiesIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseCapabilitiesIntegration[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/capabilities/integration`
    );
  };

  /** List integrations */
  listProjectDatabaseM3dbIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/integration`
    );
  };

  /** Create a new integration */
  createProjectDatabaseM3dbIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceIntegration
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/integration`,
      body
    );
  };

  /** Delete an integration */
  deleteProjectDatabaseM3dbIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/integration/${integrationId}`
    );
  };

  /** Get an integration */
  getProjectDatabaseM3dbIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/integration/${integrationId}`
    );
  };

  /** List m3db ip restrictions */
  listProjectDatabaseM3dbIpRestrictionByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/ipRestriction`
    );
  };

  /** Add ip restrictions to the m3db */
  addProjectDatabaseM3dbIpRestrictionByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseIpRestrictionCreation
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/ipRestriction`,
      body
    );
  };

  /** Deletes the given IP from the restricted IPs of the m3db */
  deleteProjectDatabaseM3dbIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/ipRestriction/${ipBlock}`
    );
  };

  /** Get m3db ip restrictions */
  getProjectDatabaseM3dbIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/ipRestriction/${ipBlock}`
    );
  };

  /** Changes the list of ip restrictions to the m3db */
  updateProjectDatabaseM3dbIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string,
    body: CloudProjectDatabaseIpRestriction
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/ipRestriction/${ipBlock}`,
      body
    );
  };

  /** Retrieve the most recent m3db log messages (limited to 1000) */
  getProjectDatabaseM3dbLogsByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceLogEntry[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/m3db/${clusterId}/logs`);
  };

  /** List maintenances for the m3db cluster */
  listProjectDatabaseM3dbMaintenanceByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/maintenance`
    );
  };

  /** Get the maintenance for the m3db cluster */
  getProjectDatabaseM3dbMaintenanceByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/maintenance/${maintenanceId}`
    );
  };

  /** Apply the maintenance */
  postProjectDatabaseM3dbMaintenanceApplyByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/maintenance/${maintenanceId}/apply`
    );
  };

  /** List available metrics for the m3db cluster */
  listProjectDatabaseM3dbMetricByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/metric`
    );
  };

  /** Get the metric values for the m3db cluster */
  getProjectDatabaseM3dbMetricByServiceNameAndClusterIdAndMetricName = (
    clusterId: string,
    metricName: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMetric> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/metric/${metricName}`
    );
  };

  /** List namespaces of the m3db */
  listProjectDatabaseM3dbNamespaceByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/namespace`
    );
  };

  /** Create a new namespace on the m3db cluster */
  createProjectDatabaseM3dbNamespaceByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseM3dbNamespaceCreation
  ): Promise<CloudProjectDatabaseM3dbNamespace> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/namespace`,
      body
    );
  };

  /** Delete m3db namespace */
  deleteProjectDatabaseM3dbNamespaceByServiceNameAndClusterIdAndNamespaceId = (
    clusterId: string,
    namespaceId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/namespace/${namespaceId}`
    );
  };

  /** Get m3db namespaces */
  getProjectDatabaseM3dbNamespaceByServiceNameAndClusterIdAndNamespaceId = (
    clusterId: string,
    namespaceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseM3dbNamespace> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/namespace/${namespaceId}`
    );
  };

  /** Updates the namespace on the m3db cluster */
  updateProjectDatabaseM3dbNamespaceByServiceNameAndClusterIdAndNamespaceId = (
    clusterId: string,
    namespaceId: string,
    serviceName: string,
    body: CloudProjectDatabaseM3dbNamespace
  ): Promise<CloudProjectDatabaseM3dbNamespace> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/namespace/${namespaceId}`,
      body
    );
  };

  /** List nodes of the m3db */
  listProjectDatabaseM3dbNodeByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/m3db/${clusterId}/node`);
  };

  /** Get m3db nodes */
  getProjectDatabaseM3dbNodeByServiceNameAndClusterIdAndNodeId = (
    clusterId: string,
    nodeId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceNode> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/node/${nodeId}`
    );
  };

  /** List users of the m3db */
  listProjectDatabaseM3dbUserByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/m3db/${clusterId}/user`);
  };

  /** Create a new user on the m3db cluster */
  createProjectDatabaseM3dbUserByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseM3dbUserCreation
  ): Promise<CloudProjectDatabaseM3dbUserWithPassword> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/user`,
      body
    );
  };

  /** Delete m3db user */
  deleteProjectDatabaseM3dbUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/user/${userId}`
    );
  };

  /** Get m3db users */
  getProjectDatabaseM3dbUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<CloudProjectDatabaseM3dbUser> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/user/${userId}`
    );
  };

  /** Updates the user on the m3db cluster */
  updateProjectDatabaseM3dbUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string,
    body: CloudProjectDatabaseM3dbUser
  ): Promise<CloudProjectDatabaseM3dbUser> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/user/${userId}`,
      body
    );
  };

  /** Resets the password of a user */
  postProjectDatabaseM3dbUserCredentialsResetByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<CloudProjectDatabaseM3dbUserWithPassword> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/m3db/${clusterId}/user/${userId}/credentials/reset`
    );
  };

  /** List mongodbs of the project */
  listProjectDatabaseMongodbByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/mongodb`);
  };

  /** Create a new mongodb cluster */
  createProjectDatabaseMongodbByServiceName = (
    serviceName: string,
    body: CloudProjectDatabaseServiceCreation
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/database/mongodb`, body);
  };

  /** Delete a mongodb cluster */
  deleteProjectDatabaseMongodbByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}`
    );
  };

  /** Get mongodb cluster properties */
  getProjectDatabaseMongodbByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/mongodb/${clusterId}`);
  };

  /** Update an existing mongodb cluster */
  updateProjectDatabaseMongodbByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseService
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}`,
      body
    );
  };

  /** List backups of the mongodb */
  listProjectDatabaseMongodbBackupByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/backup`
    );
  };

  /** Get mongodb backups */
  getProjectDatabaseMongodbBackupByServiceNameAndClusterIdAndBackupId = (
    backupId: string,
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceBackup> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/backup/${backupId}`
    );
  };

  /** Restore the backup */
  postProjectDatabaseMongodbBackupRestoreByServiceNameAndClusterIdAndBackupId = (
    backupId: string,
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceBackup> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/backup/${backupId}/restore`
    );
  };

  /** List mongodb ip restrictions */
  listProjectDatabaseMongodbIpRestrictionByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/ipRestriction`
    );
  };

  /** Add ip restrictions to the mongodb */
  addProjectDatabaseMongodbIpRestrictionByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseIpRestrictionCreation
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/ipRestriction`,
      body
    );
  };

  /** Deletes the given IP from the restricted IPs of the mongodb */
  deleteProjectDatabaseMongodbIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/ipRestriction/${ipBlock}`
    );
  };

  /** Get mongodb ip restrictions */
  getProjectDatabaseMongodbIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/ipRestriction/${ipBlock}`
    );
  };

  /** Changes the list of ip restrictions to the mongodb */
  updateProjectDatabaseMongodbIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string,
    body: CloudProjectDatabaseIpRestriction
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/ipRestriction/${ipBlock}`,
      body
    );
  };

  /** Retrieve the most recent mongoDB log messages (limited to 1000) */
  getProjectDatabaseMongodbLogsByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceLogEntry[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/logs`
    );
  };

  /** List maintenances for the mongodb cluster */
  listProjectDatabaseMongodbMaintenanceByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/maintenance`
    );
  };

  /** Get the maintenance for the mongodb cluster */
  getProjectDatabaseMongodbMaintenanceByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/maintenance/${maintenanceId}`
    );
  };

  /** Apply the maintenance */
  postProjectDatabaseMongodbMaintenanceApplyByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/maintenance/${maintenanceId}/apply`
    );
  };

  /** List available metrics for the mongodb cluster */
  listProjectDatabaseMongodbMetricByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/metric`
    );
  };

  /** Get the metric values for the mongodb cluster */
  getProjectDatabaseMongodbMetricByServiceNameAndClusterIdAndMetricName = (
    clusterId: string,
    metricName: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMetric> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/metric/${metricName}`
    );
  };

  /** List nodes of the mongodb */
  listProjectDatabaseMongodbNodeByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/node`
    );
  };

  /** Create a new node on the mongodb cluster */
  createProjectDatabaseMongodbNodeByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceNodeCreation
  ): Promise<CloudProjectDatabaseServiceNode> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/node`,
      body
    );
  };

  /** Delete a mongodb cluster's node */
  deleteProjectDatabaseMongodbNodeByServiceNameAndClusterIdAndNodeId = (
    clusterId: string,
    nodeId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/node/${nodeId}`
    );
  };

  /** Get mongodb nodes */
  getProjectDatabaseMongodbNodeByServiceNameAndClusterIdAndNodeId = (
    clusterId: string,
    nodeId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceNode> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/node/${nodeId}`
    );
  };

  /** Modify mongodb nodes */
  putProjectDatabaseMongodbNodeByServiceNameAndClusterIdAndNodeId = (
    clusterId: string,
    nodeId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceNode
  ): Promise<CloudProjectDatabaseServiceNode> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/node/${nodeId}`,
      body
    );
  };

  /** Initiate a restore */
  postProjectDatabaseMongodbRestoreByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceRestore
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/restore`,
      body
    );
  };

  /** Get mongodb roles */
  getProjectDatabaseMongodbRolesByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/roles`
    );
  };

  /** List users of the mongodb */
  listProjectDatabaseMongodbUserByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/user`
    );
  };

  /** Create a new user on the mongodb cluster */
  createProjectDatabaseMongodbUserByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceUserWithRolesCreation
  ): Promise<CloudProjectDatabaseServiceUserWithPasswordAndRoles> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/user`,
      body
    );
  };

  /** Delete a mongodb user */
  deleteProjectDatabaseMongodbUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/user/${userId}`
    );
  };

  /** Get mongodb users */
  getProjectDatabaseMongodbUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<CloudProjectDatabaseServiceUserWithRoles> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/user/${userId}`
    );
  };

  /** Updates the user on the mongodb cluster */
  updateProjectDatabaseMongodbUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string,
    body: CloudProjectDatabaseServiceUserWithPasswordAndRoles
  ): Promise<CloudProjectDatabaseServiceUserWithRoles> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/user/${userId}`,
      body
    );
  };

  /** Resets the password of a user */
  postProjectDatabaseMongodbUserCredentialsResetByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<CloudProjectDatabaseServiceUserWithPasswordAndRoles> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/mongodb/${clusterId}/user/${userId}/credentials/reset`
    );
  };

  /** List all the mysql of the project */
  listProjectDatabaseMysqlByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/mysql`);
  };

  /** Create a new mysql cluster */
  createProjectDatabaseMysqlByServiceName = (
    serviceName: string,
    body: CloudProjectDatabaseServiceCreation
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/database/mysql`, body);
  };

  /** Delete a mysql cluster */
  deleteProjectDatabaseMysqlByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/database/mysql/${clusterId}`);
  };

  /** Get mysql cluster properties */
  getProjectDatabaseMysqlByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/mysql/${clusterId}`);
  };

  /** Update an existing mysql cluster */
  updateProjectDatabaseMysqlByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseService
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}`,
      body
    );
  };

  /** Get mysql advanced configuration */
  getProjectDatabaseMysqlAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<Record<string, string>> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/advancedConfiguration`
    );
  };

  /** Update mysql advanced configuration */
  updateProjectDatabaseMysqlAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: Record<string, string>
  ): Promise<Record<string, string>> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/advancedConfiguration`,
      body
    );
  };

  /** List backups of the mysql */
  listProjectDatabaseMysqlBackupByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/backup`
    );
  };

  /** Get mysql backups */
  getProjectDatabaseMysqlBackupByServiceNameAndClusterIdAndBackupId = (
    backupId: string,
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceBackup> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/backup/${backupId}`
    );
  };

  /** Get mysql advanced configuration fields */
  getProjectDatabaseMysqlCapabilitiesAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseCapabilitiesAdvancedConfigurationProperty[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/capabilities/advancedConfiguration`
    );
  };

  /** Get integration capabilities related to the mysql service */
  getProjectDatabaseMysqlCapabilitiesIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseCapabilitiesIntegration[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/capabilities/integration`
    );
  };

  /** Retrieve the certificates of the mysql cluster */
  getProjectDatabaseMysqlCertificatesByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceCertificates> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/certificates`
    );
  };

  /** Retrieve the current queries for the cluster */
  getProjectDatabaseMysqlCurrentQueriesByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceCurrentQueries> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/currentQueries`
    );
  };

  /** Cancel the given current query of the cluster */
  postProjectDatabaseMysqlCurrentQueriesCancelByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceCurrentqueriesQueryCancelRequest
  ): Promise<CloudProjectDatabaseServiceCurrentqueriesQueryCancelResponse> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/currentQueries/cancel`,
      body
    );
  };

  getProjectDatabaseMysqlDatabaseByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/database`
    );
  };

  /** Create a new database on the mysql cluster */
  createProjectDatabaseMysqlDatabaseByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceDatabase
  ): Promise<CloudProjectDatabaseServiceDatabase> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/database`,
      body
    );
  };

  /** Delete a mysql database */
  deleteProjectDatabaseMysqlDatabaseByServiceNameAndClusterIdAndDatabaseId = (
    clusterId: string,
    databaseId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/database/${databaseId}`
    );
  };

  /** Get the database for the mysql cluster */
  getProjectDatabaseMysqlDatabaseByServiceNameAndClusterIdAndDatabaseId = (
    clusterId: string,
    databaseId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceDatabase> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/database/${databaseId}`
    );
  };

  /** Enable temporary write permission on readonly lock mysql service */
  enableProjectDatabaseMysqlWritesByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseTemporaryWriteDeadline> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/enableWrites`
    );
  };

  /** List integrations */
  listProjectDatabaseMysqlIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/integration`
    );
  };

  /** Create a new integration */
  createProjectDatabaseMysqlIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceIntegration
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/integration`,
      body
    );
  };

  /** Delete an integration */
  deleteProjectDatabaseMysqlIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/integration/${integrationId}`
    );
  };

  /** Get an integration */
  getProjectDatabaseMysqlIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/integration/${integrationId}`
    );
  };

  /** List mysql ip restrictions */
  listProjectDatabaseMysqlIpRestrictionByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/ipRestriction`
    );
  };

  /** Add ip restrictions to the mysql */
  addProjectDatabaseMysqlIpRestrictionByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseIpRestrictionCreation
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/ipRestriction`,
      body
    );
  };

  /** Deletes the given IP from the restricted IPs of the mysql */
  deleteProjectDatabaseMysqlIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/ipRestriction/${ipBlock}`
    );
  };

  /** Get mysql ip restrictions */
  getProjectDatabaseMysqlIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/ipRestriction/${ipBlock}`
    );
  };

  /** Changes the list of ip restrictions to the mysql */
  updateProjectDatabaseMysqlIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string,
    body: CloudProjectDatabaseIpRestriction
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/ipRestriction/${ipBlock}`,
      body
    );
  };

  /** Retrieve the most recent mysql log messages (limited to 1000) */
  getProjectDatabaseMysqlLogsByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceLogEntry[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/logs`
    );
  };

  /** List maintenances for the mysql cluster */
  listProjectDatabaseMysqlMaintenanceByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/maintenance`
    );
  };

  /** Get the maintenance for the mysql cluster */
  getProjectDatabaseMysqlMaintenanceByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/maintenance/${maintenanceId}`
    );
  };

  /** Apply the maintenance */
  postProjectDatabaseMysqlMaintenanceApplyByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/maintenance/${maintenanceId}/apply`
    );
  };

  /** List available metrics for the mysql cluster */
  listProjectDatabaseMysqlMetricByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/metric`
    );
  };

  /** Get the metric values for the mysql cluster */
  getProjectDatabaseMysqlMetricByServiceNameAndClusterIdAndMetricName = (
    clusterId: string,
    metricName: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMetric> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/metric/${metricName}`
    );
  };

  /** List nodes of the mysql */
  listProjectDatabaseMysqlNodeByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/node`
    );
  };

  /** Get mysql nodes */
  getProjectDatabaseMysqlNodeByServiceNameAndClusterIdAndNodeId = (
    clusterId: string,
    nodeId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceNode> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/node/${nodeId}`
    );
  };

  /** Retrieve the query statistics for the cluster */
  getProjectDatabaseMysqlQueryStatisticsByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseMysqlQueryStatistics> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/queryStatistics`
    );
  };

  /** Reset the query statistics of the cluster */
  postProjectDatabaseMysqlQueryStatisticsResetByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/queryStatistics/reset`
    );
  };

  /** List users of the mysql */
  listProjectDatabaseMysqlUserByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/user`
    );
  };

  /** Create a new user on the mysql cluster */
  createProjectDatabaseMysqlUserByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceUserCreation
  ): Promise<CloudProjectDatabaseServiceUserWithPassword> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/user`,
      body
    );
  };

  /** Delete a mysql user */
  deleteProjectDatabaseMysqlUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/user/${userId}`
    );
  };

  /** Get mysql users */
  getProjectDatabaseMysqlUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<CloudProjectDatabaseServiceUser> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/user/${userId}`
    );
  };

  /** Resets the password of a user */
  postProjectDatabaseMysqlUserCredentialsResetByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<CloudProjectDatabaseServiceUserWithPassword> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/mysql/${clusterId}/user/${userId}/credentials/reset`
    );
  };

  /** List all the opensearch of the project */
  listProjectDatabaseOpensearchByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/opensearch`);
  };

  /** Create a new opensearch cluster */
  createProjectDatabaseOpensearchByServiceName = (
    serviceName: string,
    body: CloudProjectDatabaseServiceCreation
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/database/opensearch`, body);
  };

  /** Delete a opensearch cluster */
  deleteProjectDatabaseOpensearchByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}`
    );
  };

  /** Get opensearch cluster properties */
  getProjectDatabaseOpensearchByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseOpensearchService> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}`
    );
  };

  /** Update an existing opensearch cluster */
  updateProjectDatabaseOpensearchByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseOpensearchService
  ): Promise<CloudProjectDatabaseOpensearchService> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}`,
      body
    );
  };

  /** Get opensearch advanced configuration */
  getProjectDatabaseOpensearchAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<Record<string, string>> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/advancedConfiguration`
    );
  };

  /** Update opensearch advanced configuration */
  updateProjectDatabaseOpensearchAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: Record<string, string>
  ): Promise<Record<string, string>> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/advancedConfiguration`,
      body
    );
  };

  /** List backups of the opensearch */
  listProjectDatabaseOpensearchBackupByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/backup`
    );
  };

  /** Get opensearch backups */
  getProjectDatabaseOpensearchBackupByServiceNameAndClusterIdAndBackupId = (
    backupId: string,
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceBackup> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/backup/${backupId}`
    );
  };

  /** Get opensearch advanced configuration fields */
  getProjectDatabaseOpensearchCapabilitiesAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseCapabilitiesAdvancedConfigurationProperty[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/capabilities/advancedConfiguration`
    );
  };

  /** Get integration capabilities related to the opensearch service */
  getProjectDatabaseOpensearchCapabilitiesIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseCapabilitiesIntegration[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/capabilities/integration`
    );
  };

  /** List indexes of the opensearch */
  listProjectDatabaseOpensearchIndexByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/index`
    );
  };

  /** Delete an opensearch index */
  deleteProjectDatabaseOpensearchIndexByServiceNameAndClusterIdAndIndexId = (
    clusterId: string,
    indexId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/index/${indexId}`
    );
  };

  /** Get opensearch index */
  getProjectDatabaseOpensearchIndexByServiceNameAndClusterIdAndIndexId = (
    clusterId: string,
    indexId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseOpensearchIndex> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/index/${indexId}`
    );
  };

  /** List integrations */
  listProjectDatabaseOpensearchIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/integration`
    );
  };

  /** Create a new integration */
  createProjectDatabaseOpensearchIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceIntegration
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/integration`,
      body
    );
  };

  /** Delete an integration */
  deleteProjectDatabaseOpensearchIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/integration/${integrationId}`
    );
  };

  /** Get an integration */
  getProjectDatabaseOpensearchIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/integration/${integrationId}`
    );
  };

  /** List opensearch ip restrictions */
  listProjectDatabaseOpensearchIpRestrictionByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/ipRestriction`
    );
  };

  /** Add ip restrictions to the opensearch */
  addProjectDatabaseOpensearchIpRestrictionByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseIpRestrictionCreation
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/ipRestriction`,
      body
    );
  };

  /** Deletes the given IP from the restricted IPs of the opensearch */
  deleteProjectDatabaseOpensearchIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/ipRestriction/${ipBlock}`
    );
  };

  /** Get opensearch ip restrictions */
  getProjectDatabaseOpensearchIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/ipRestriction/${ipBlock}`
    );
  };

  /** Changes the list of ip restrictions to the opensearch */
  updateProjectDatabaseOpensearchIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string,
    body: CloudProjectDatabaseIpRestriction
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/ipRestriction/${ipBlock}`,
      body
    );
  };

  /** Retrieve the most recent opensearch log messages (limited to 1000) */
  getProjectDatabaseOpensearchLogsByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceLogEntry[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/logs`
    );
  };

  /** List maintenances for the opensearch cluster */
  listProjectDatabaseOpensearchMaintenanceByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/maintenance`
    );
  };

  /** Get the maintenance for the opensearch cluster */
  getProjectDatabaseOpensearchMaintenanceByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/maintenance/${maintenanceId}`
    );
  };

  /** Apply the maintenance */
  postProjectDatabaseOpensearchMaintenanceApplyByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/maintenance/${maintenanceId}/apply`
    );
  };

  /** List available metrics for the opensearch cluster */
  listProjectDatabaseOpensearchMetricByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/metric`
    );
  };

  /** Get the metric values for the opensearch cluster */
  getProjectDatabaseOpensearchMetricByServiceNameAndClusterIdAndMetricName = (
    clusterId: string,
    metricName: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMetric> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/metric/${metricName}`
    );
  };

  /** List nodes of the opensearch */
  listProjectDatabaseOpensearchNodeByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/node`
    );
  };

  /** Get opensearch nodes */
  getProjectDatabaseOpensearchNodeByServiceNameAndClusterIdAndNodeId = (
    clusterId: string,
    nodeId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceNode> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/node/${nodeId}`
    );
  };

  /** List patterns of the opensearch */
  listProjectDatabaseOpensearchPatternByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/pattern`
    );
  };

  /** Create a new pattern on the opensearch cluster */
  createProjectDatabaseOpensearchPatternByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseOpensearchPattern
  ): Promise<CloudProjectDatabaseOpensearchPattern> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/pattern`,
      body
    );
  };

  /** Delete an opensearch pattern */
  deleteProjectDatabaseOpensearchPatternByServiceNameAndClusterIdAndPatternId = (
    clusterId: string,
    patternId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/pattern/${patternId}`
    );
  };

  /** Get opensearch patterns */
  getProjectDatabaseOpensearchPatternByServiceNameAndClusterIdAndPatternId = (
    clusterId: string,
    patternId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseOpensearchPattern> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/pattern/${patternId}`
    );
  };

  /** Retrieve the opensearch permissions values */
  getProjectDatabaseOpensearchPermissionsByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseOpensearchPermissions> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/permissions`
    );
  };

  /** List users of the opensearch */
  listProjectDatabaseOpensearchUserByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/user`
    );
  };

  /** Create a new user on the opensearch cluster */
  createProjectDatabaseOpensearchUserByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseOpensearchUserCreation
  ): Promise<CloudProjectDatabaseOpensearchUserWithPassword> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/user`,
      body
    );
  };

  /** Delete a opensearch user */
  deleteProjectDatabaseOpensearchUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/user/${userId}`
    );
  };

  /** Get opensearch users */
  getProjectDatabaseOpensearchUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<CloudProjectDatabaseOpensearchUser> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/user/${userId}`
    );
  };

  /** Update a user on the opensearch cluster */
  updateProjectDatabaseOpensearchUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string,
    body: CloudProjectDatabaseOpensearchUser
  ): Promise<CloudProjectDatabaseOpensearchUser> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/user/${userId}`,
      body
    );
  };

  /** Resets the password of a user */
  postProjectDatabaseOpensearchUserCredentialsResetByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<CloudProjectDatabaseOpensearchUserWithPassword> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/opensearch/${clusterId}/user/${userId}/credentials/reset`
    );
  };

  /** List all the postgresql of the project */
  listProjectDatabasePostgresqlByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/postgresql`);
  };

  /** Create a new postgresql cluster */
  createProjectDatabasePostgresqlByServiceName = (
    serviceName: string,
    body: CloudProjectDatabaseServiceCreation
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/database/postgresql`, body);
  };

  /** Delete a postgresql cluster */
  deleteProjectDatabasePostgresqlByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}`
    );
  };

  /** Get postgresql cluster properties */
  getProjectDatabasePostgresqlByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}`
    );
  };

  /** Update an existing postgresql cluster */
  updateProjectDatabasePostgresqlByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseService
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}`,
      body
    );
  };

  /** Get postgresql advanced configuration */
  getProjectDatabasePostgresqlAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<Record<string, string>> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/advancedConfiguration`
    );
  };

  /** Update postgresql advanced configuration */
  updateProjectDatabasePostgresqlAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: Record<string, string>
  ): Promise<Record<string, string>> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/advancedConfiguration`,
      body
    );
  };

  /** List backups of the postgresql */
  listProjectDatabasePostgresqlBackupByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/backup`
    );
  };

  /** Get postgresql backups */
  getProjectDatabasePostgresqlBackupByServiceNameAndClusterIdAndBackupId = (
    backupId: string,
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceBackup> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/backup/${backupId}`
    );
  };

  /** Get postgresql advanced configuration fields */
  getProjectDatabasePostgresqlCapabilitiesAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseCapabilitiesAdvancedConfigurationProperty[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/capabilities/advancedConfiguration`
    );
  };

  /** Get integration capabilities related to the postgresql service */
  getProjectDatabasePostgresqlCapabilitiesIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseCapabilitiesIntegration[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/capabilities/integration`
    );
  };

  /** Retrieve the certificates of the postgresql cluster */
  getProjectDatabasePostgresqlCertificatesByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceCertificates> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/certificates`
    );
  };

  getProjectDatabasePostgresqlConnectionPoolByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/connectionPool`
    );
  };

  /** Create a new connectionPool on the postgresql cluster */
  createProjectDatabasePostgresqlConnectionPoolByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabasePostgresqlConnectionPoolCreation
  ): Promise<CloudProjectDatabasePostgresqlConnectionPool> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/connectionPool`,
      body
    );
  };

  /** Delete a postgresql connectionPool */
  deleteProjectDatabasePostgresqlConnectionPoolByServiceNameAndClusterIdAndConnectionPoolId = (
    clusterId: string,
    connectionPoolId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/connectionPool/${connectionPoolId}`
    );
  };

  /** Get the connectionPool for the postgresql cluster */
  getProjectDatabasePostgresqlConnectionPoolByServiceNameAndClusterIdAndConnectionPoolId = (
    clusterId: string,
    connectionPoolId: string,
    serviceName: string
  ): Promise<CloudProjectDatabasePostgresqlConnectionPool> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/connectionPool/${connectionPoolId}`
    );
  };

  /** Update a connectionPool on the postgresql cluster */
  updateProjectDatabasePostgresqlConnectionPoolByServiceNameAndClusterIdAndConnectionPoolId = (
    clusterId: string,
    connectionPoolId: string,
    serviceName: string,
    body: CloudProjectDatabasePostgresqlConnectionPool
  ): Promise<CloudProjectDatabasePostgresqlConnectionPool> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/connectionPool/${connectionPoolId}`,
      body
    );
  };

  /** Retrieve the current queries for the cluster */
  getProjectDatabasePostgresqlCurrentQueriesByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceCurrentQueries> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/currentQueries`
    );
  };

  /** Cancel the given current query of the cluster */
  postProjectDatabasePostgresqlCurrentQueriesCancelByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceCurrentqueriesQueryCancelRequest
  ): Promise<CloudProjectDatabaseServiceCurrentqueriesQueryCancelResponse> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/currentQueries/cancel`,
      body
    );
  };

  getProjectDatabasePostgresqlDatabaseByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/database`
    );
  };

  /** Create a new database on the postgresql cluster */
  createProjectDatabasePostgresqlDatabaseByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceDatabase
  ): Promise<CloudProjectDatabaseServiceDatabase> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/database`,
      body
    );
  };

  /** Delete a postgresql database */
  deleteProjectDatabasePostgresqlDatabaseByServiceNameAndClusterIdAndDatabaseId = (
    clusterId: string,
    databaseId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/database/${databaseId}`
    );
  };

  /** Get the database for the postgresql cluster */
  getProjectDatabasePostgresqlDatabaseByServiceNameAndClusterIdAndDatabaseId = (
    clusterId: string,
    databaseId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceDatabase> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/database/${databaseId}`
    );
  };

  /** Enable temporary write permission on readonly lock postgresql service */
  enableProjectDatabasePostgresqlWritesByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseTemporaryWriteDeadline> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/enableWrites`
    );
  };

  /** List integrations */
  listProjectDatabasePostgresqlIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/integration`
    );
  };

  /** Create a new integration */
  createProjectDatabasePostgresqlIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceIntegration
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/integration`,
      body
    );
  };

  /** Delete an integration */
  deleteProjectDatabasePostgresqlIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/integration/${integrationId}`
    );
  };

  /** Get an integration */
  getProjectDatabasePostgresqlIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/integration/${integrationId}`
    );
  };

  /** List postgresql ip restrictions */
  listProjectDatabasePostgresqlIpRestrictionByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/ipRestriction`
    );
  };

  /** Add ip restrictions to the postgresql */
  addProjectDatabasePostgresqlIpRestrictionByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseIpRestrictionCreation
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/ipRestriction`,
      body
    );
  };

  /** Deletes the given IP from the restricted IPs of the postgresql */
  deleteProjectDatabasePostgresqlIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/ipRestriction/${ipBlock}`
    );
  };

  /** Get postgresql ip restrictions */
  getProjectDatabasePostgresqlIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/ipRestriction/${ipBlock}`
    );
  };

  /** Changes the list of ip restrictions to the postgresql */
  updateProjectDatabasePostgresqlIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string,
    body: CloudProjectDatabaseIpRestriction
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/ipRestriction/${ipBlock}`,
      body
    );
  };

  /** Retrieve the most recent postgresql log messages (limited to 1000) */
  getProjectDatabasePostgresqlLogsByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceLogEntry[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/logs`
    );
  };

  /** List maintenances for the postgresql cluster */
  listProjectDatabasePostgresqlMaintenanceByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/maintenance`
    );
  };

  /** Get the maintenance for the postgresql cluster */
  getProjectDatabasePostgresqlMaintenanceByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/maintenance/${maintenanceId}`
    );
  };

  /** Apply the maintenance */
  postProjectDatabasePostgresqlMaintenanceApplyByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/maintenance/${maintenanceId}/apply`
    );
  };

  /** List available metrics for the postgresql cluster */
  listProjectDatabasePostgresqlMetricByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/metric`
    );
  };

  /** Get the metric values for the postgresql cluster */
  getProjectDatabasePostgresqlMetricByServiceNameAndClusterIdAndMetricName = (
    clusterId: string,
    metricName: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMetric> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/metric/${metricName}`
    );
  };

  /** List nodes of the postgresql */
  listProjectDatabasePostgresqlNodeByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/node`
    );
  };

  /** Get postgresql nodes */
  getProjectDatabasePostgresqlNodeByServiceNameAndClusterIdAndNodeId = (
    clusterId: string,
    nodeId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceNode> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/node/${nodeId}`
    );
  };

  /** Retrieve the query statistics for the cluster */
  getProjectDatabasePostgresqlQueryStatisticsByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabasePostgresqlQueryStatistics> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/queryStatistics`
    );
  };

  /** Reset the query statistics of the cluster */
  postProjectDatabasePostgresqlQueryStatisticsResetByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/queryStatistics/reset`
    );
  };

  /** Get postgresql roles */
  getProjectDatabasePostgresqlRolesByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/roles`
    );
  };

  /** List users of the postgresql */
  listProjectDatabasePostgresqlUserByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/user`
    );
  };

  /** Create a new user on the postgresql cluster */
  createProjectDatabasePostgresqlUserByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceUserWithRolesCreation
  ): Promise<CloudProjectDatabaseServiceUserWithPasswordAndRoles> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/user`,
      body
    );
  };

  /** Delete a postgresql user */
  deleteProjectDatabasePostgresqlUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/user/${userId}`
    );
  };

  /** Get postgresql users */
  getProjectDatabasePostgresqlUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<CloudProjectDatabaseServiceUserWithRoles> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/user/${userId}`
    );
  };

  /** Updates the user on the postgresql cluster */
  updateProjectDatabasePostgresqlUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string,
    body: CloudProjectDatabaseServiceUserWithRoles
  ): Promise<CloudProjectDatabaseServiceUserWithRoles> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/user/${userId}`,
      body
    );
  };

  /** Resets the password of a user */
  postProjectDatabasePostgresqlUserCredentialsResetByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<CloudProjectDatabaseServiceUserWithPasswordAndRoles> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/postgresql/${clusterId}/user/${userId}/credentials/reset`
    );
  };

  /** List all the redis of the project */
  listProjectDatabaseRedisByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/redis`);
  };

  /** Create a new redis cluster */
  createProjectDatabaseRedisByServiceName = (
    serviceName: string,
    body: CloudProjectDatabaseServiceCreation
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/database/redis`, body);
  };

  /** Delete a redis cluster */
  deleteProjectDatabaseRedisByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/database/redis/${clusterId}`);
  };

  /** Get redis cluster properties */
  getProjectDatabaseRedisByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/redis/${clusterId}`);
  };

  /** Update an existing redis cluster */
  updateProjectDatabaseRedisByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseService
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/redis/${clusterId}`,
      body
    );
  };

  /** Get redis advanced configuration */
  getProjectDatabaseRedisAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<Record<string, string>> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/advancedConfiguration`
    );
  };

  /** Update redis advanced configuration */
  updateProjectDatabaseRedisAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: Record<string, string>
  ): Promise<Record<string, string>> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/advancedConfiguration`,
      body
    );
  };

  /** List backups of the redis */
  listProjectDatabaseRedisBackupByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/backup`
    );
  };

  /** Get redis backups */
  getProjectDatabaseRedisBackupByServiceNameAndClusterIdAndBackupId = (
    backupId: string,
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceBackup> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/backup/${backupId}`
    );
  };

  /** Get redis advanced configuration fields */
  getProjectDatabaseRedisCapabilitiesAdvancedConfigurationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseCapabilitiesAdvancedConfigurationProperty[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/capabilities/advancedConfiguration`
    );
  };

  /** Get available categories in the redis service */
  getProjectDatabaseRedisCapabilitiesCategoriesByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/capabilities/categories`
    );
  };

  /** Get available commands in the redis service */
  getProjectDatabaseRedisCapabilitiesCommandsByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/capabilities/commands`
    );
  };

  /** Get integration capabilities related to the redis service */
  getProjectDatabaseRedisCapabilitiesIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseCapabilitiesIntegration[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/capabilities/integration`
    );
  };

  /** List integrations */
  listProjectDatabaseRedisIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/integration`
    );
  };

  /** Create a new integration */
  createProjectDatabaseRedisIntegrationByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseServiceIntegration
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/integration`,
      body
    );
  };

  /** Delete an integration */
  deleteProjectDatabaseRedisIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/integration/${integrationId}`
    );
  };

  /** Get an integration */
  getProjectDatabaseRedisIntegrationByServiceNameAndClusterIdAndIntegrationId = (
    clusterId: string,
    integrationId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceIntegration> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/integration/${integrationId}`
    );
  };

  /** List redis ip restrictions */
  listProjectDatabaseRedisIpRestrictionByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/ipRestriction`
    );
  };

  /** Add ip restrictions to the redis */
  addProjectDatabaseRedisIpRestrictionByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseIpRestrictionCreation
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/ipRestriction`,
      body
    );
  };

  /** Deletes the given IP from the restricted IPs of the redis */
  deleteProjectDatabaseRedisIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/ipRestriction/${ipBlock}`
    );
  };

  /** Get redis ip restrictions */
  getProjectDatabaseRedisIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/ipRestriction/${ipBlock}`
    );
  };

  /** Changes the list of ip restrictions to the redis */
  updateProjectDatabaseRedisIpRestrictionByServiceNameAndClusterIdAndIpBlock = (
    clusterId: string,
    ipBlock: string,
    serviceName: string,
    body: CloudProjectDatabaseIpRestriction
  ): Promise<CloudProjectDatabaseIpRestriction> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/ipRestriction/${ipBlock}`,
      body
    );
  };

  /** Retrieve the most recent redis log messages (limited to 1000) */
  getProjectDatabaseRedisLogsByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceLogEntry[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/logs`
    );
  };

  /** List maintenances for the redis cluster */
  listProjectDatabaseRedisMaintenanceByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/maintenance`
    );
  };

  /** Get the maintenance for the redis cluster */
  getProjectDatabaseRedisMaintenanceByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/maintenance/${maintenanceId}`
    );
  };

  /** Apply the maintenance */
  postProjectDatabaseRedisMaintenanceApplyByServiceNameAndClusterIdAndMaintenanceId = (
    clusterId: string,
    maintenanceId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMaintenance> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/maintenance/${maintenanceId}/apply`
    );
  };

  /** List available metrics for the redis cluster */
  listProjectDatabaseRedisMetricByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/metric`
    );
  };

  /** Get the metric values for the redis cluster */
  getProjectDatabaseRedisMetricByServiceNameAndClusterIdAndMetricName = (
    clusterId: string,
    metricName: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceMetric> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/metric/${metricName}`
    );
  };

  /** List nodes of the redis */
  listProjectDatabaseRedisNodeByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/node`
    );
  };

  /** Get redis nodes */
  getProjectDatabaseRedisNodeByServiceNameAndClusterIdAndNodeId = (
    clusterId: string,
    nodeId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseServiceNode> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/node/${nodeId}`
    );
  };

  /** List users of the redis */
  listProjectDatabaseRedisUserByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/user`
    );
  };

  /** Create a new user on the redis cluster */
  createProjectDatabaseRedisUserByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string,
    body: CloudProjectDatabaseRedisUserCreation
  ): Promise<CloudProjectDatabaseRedisUserWithPassword> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/user`,
      body
    );
  };

  /** Delete a redis user */
  deleteProjectDatabaseRedisUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/user/${userId}`
    );
  };

  /** Get redis users */
  getProjectDatabaseRedisUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<CloudProjectDatabaseRedisUser> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/user/${userId}`
    );
  };

  /** Update a user on the redis cluster */
  updateProjectDatabaseRedisUserByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string,
    body: CloudProjectDatabaseRedisUser
  ): Promise<CloudProjectDatabaseRedisUser> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/user/${userId}`,
      body
    );
  };

  /** Resets the password of a user */
  postProjectDatabaseRedisUserCredentialsResetByServiceNameAndClusterIdAndUserId = (
    clusterId: string,
    serviceName: string,
    userId: string
  ): Promise<CloudProjectDatabaseRedisUserWithPassword> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/database/redis/${clusterId}/user/${userId}/credentials/reset`
    );
  };

  /** List database services of the project */
  listProjectDatabaseServiceByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/service`);
  };

  /** Get service cluster properties */
  getProjectDatabaseServiceByServiceNameAndClusterId = (
    clusterId: string,
    serviceName: string
  ): Promise<CloudProjectDatabaseService> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/database/service/${clusterId}`);
  };

  /** Get flavors */
  getProjectFlavorByServiceName = (serviceName: string): Promise<CloudFlavorFlavor[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/flavor`);
  };

  /** Get flavor */
  getProjectFlavorByServiceNameAndFlavorId = (
    flavorId: string,
    serviceName: string
  ): Promise<CloudFlavorFlavor> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/flavor/${flavorId}`);
  };

  /** Get your consumption forecast */
  getProjectForecastByServiceName = (
    serviceName: string
  ): Promise<CloudForecastProjectForecast> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/forecast`);
  };

  /** Get images */
  getProjectImageByServiceName = (serviceName: string): Promise<CloudImageImage[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/image`);
  };

  /** Get image */
  getProjectImageByServiceNameAndImageId = (
    imageId: string,
    serviceName: string
  ): Promise<CloudImageImage> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/image/${imageId}`);
  };

  /** Get instance */
  getProjectInstanceByServiceName = (serviceName: string): Promise<CloudInstanceInstance[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/instance`);
  };

  /** Create a new instance */
  createProjectInstanceByServiceName = (
    serviceName: string,
    body: CloudProjectInstanceCreation
  ): Promise<CloudInstanceInstanceDetail> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/instance`, body);
  };

  /** Create multiple instances */
  createProjectInstanceBulkByServiceName = (
    serviceName: string,
    body: CloudProjectInstanceBulkCreation
  ): Promise<CloudInstanceInstance[]> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/instance/bulk`, body);
  };

  /** Get the detail of a group */
  getProjectInstanceGroupByServiceName = (
    serviceName: string
  ): Promise<CloudInstancegroupInstanceGroup[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/instance/group`);
  };

  /** Create a group */
  createProjectInstanceGroupByServiceName = (
    serviceName: string,
    body: CloudProjectInstanceGroupCreation
  ): Promise<CloudInstancegroupInstanceGroup> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/instance/group`, body);
  };

  /** Delete a group */
  deleteProjectInstanceGroupByServiceNameAndGroupId = (
    groupId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/instance/group/${groupId}`);
  };

  /** Get all groups */
  getProjectInstanceGroupByServiceNameAndGroupId = (
    groupId: string,
    serviceName: string
  ): Promise<CloudInstancegroupInstanceGroup> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/instance/group/${groupId}`);
  };

  /** Delete an instance */
  deleteProjectInstanceByServiceNameAndInstanceId = (
    instanceId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/instance/${instanceId}`);
  };

  /** Get instance */
  getProjectInstanceByServiceNameAndInstanceId = (
    instanceId: string,
    serviceName: string
  ): Promise<CloudInstanceInstanceDetail> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/instance/${instanceId}`);
  };

  /** Alter an instance */
  updateProjectInstanceByServiceNameAndInstanceId = (
    instanceId: string,
    serviceName: string,
    body: CloudProjectInstanceUpdate
  ): Promise<void> => {
    return this.ovh.request('PUT', `/cloud/project/${serviceName}/instance/${instanceId}`, body);
  };

  /** Activate monthly billing on instance */
  postProjectInstanceActiveMonthlyBillingByServiceNameAndInstanceId = (
    instanceId: string,
    serviceName: string
  ): Promise<CloudInstanceInstanceDetail> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/instance/${instanceId}/activeMonthlyBilling`
    );
  };

  /** Return initial credentials of applications installed from public image */
  postProjectInstanceApplicationAccessByServiceNameAndInstanceId = (
    instanceId: string,
    serviceName: string
  ): Promise<CloudInstanceApplicationAccess> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/instance/${instanceId}/applicationAccess`
    );
  };

  /** Get interfaces */
  getProjectInstanceInterfaceByServiceNameAndInstanceId = (
    instanceId: string,
    serviceName: string
  ): Promise<CloudInstanceInterfaceInterface[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/instance/${instanceId}/interface`
    );
  };

  /** Create interface on an instance and attached it to a network */
  createProjectInstanceInterfaceByServiceNameAndInstanceId = (
    instanceId: string,
    serviceName: string,
    body: CloudProjectInstanceInterfaceCreation
  ): Promise<CloudInstanceInterfaceInterface> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/instance/${instanceId}/interface`,
      body
    );
  };

  /** Delete an interface */
  deleteProjectInstanceInterfaceByServiceNameAndInstanceIdAndInterfaceId = (
    instanceId: string,
    interfaceId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/instance/${instanceId}/interface/${interfaceId}`
    );
  };

  /** Get interface */
  getProjectInstanceInterfaceByServiceNameAndInstanceIdAndInterfaceId = (
    instanceId: string,
    interfaceId: string,
    serviceName: string
  ): Promise<CloudInstanceInterfaceInterface> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/instance/${instanceId}/interface/${interfaceId}`
    );
  };

  /** Return many statistics about the virtual machine for a given period */
  getProjectInstanceMonitoringByServiceNameAndInstanceId = (
    instanceId: string,
    serviceName: string
  ): Promise<CloudInstanceInstanceMetrics> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/instance/${instanceId}/monitoring`
    );
  };

  /** Reboot an instance */
  postProjectInstanceRebootByServiceNameAndInstanceId = (
    instanceId: string,
    serviceName: string,
    body: CloudProjectInstanceRebootCreation
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/instance/${instanceId}/reboot`,
      body
    );
  };

  /** Reinstall an instance */
  postProjectInstanceReinstallByServiceNameAndInstanceId = (
    instanceId: string,
    serviceName: string,
    body: CloudProjectInstanceReinstallCreation
  ): Promise<CloudInstanceInstanceDetail> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/instance/${instanceId}/reinstall`,
      body
    );
  };

  /** Enable or disable rescue mode */
  enableProjectInstanceRescueModeByServiceNameAndInstanceId = (
    instanceId: string,
    serviceName: string,
    body: CloudProjectInstanceRescueModeCreation
  ): Promise<CloudInstanceRescueAdminPassword> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/instance/${instanceId}/rescueMode`,
      body
    );
  };

  /** Migrate your instance to another flavor */
  postProjectInstanceResizeByServiceNameAndInstanceId = (
    instanceId: string,
    serviceName: string,
    body: CloudProjectInstanceResizeCreation
  ): Promise<CloudInstanceInstanceDetail> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/instance/${instanceId}/resize`,
      body
    );
  };

  /** Resume a suspended instance */
  postProjectInstanceResumeByServiceNameAndInstanceId = (
    instanceId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/instance/${instanceId}/resume`);
  };

  /** Shelve an instance. The resources dedicated to the Public Cloud instance are released. The data of the local storage will be stored, the duration of the operation depends on the size of the local disk. The instance can be unshelved at any time. Meanwhile hourly instances will not be billed. The Snapshot Storage used to store the instance's data will be billed. */
  postProjectInstanceShelveByServiceNameAndInstanceId = (
    instanceId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/instance/${instanceId}/shelve`);
  };

  /** Snapshot an instance */
  postProjectInstanceSnapshotByServiceNameAndInstanceId = (
    instanceId: string,
    serviceName: string,
    body: CloudProjectInstanceSnapshotCreation
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/instance/${instanceId}/snapshot`,
      body
    );
  };

  /** Start an instance */
  postProjectInstanceStartByServiceNameAndInstanceId = (
    instanceId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/instance/${instanceId}/start`);
  };

  /** Stop an instance. The resources dedicated to the Public Cloud instances are still reserved. The instance can be restarted at any time. Meanwhile, the same price is charged for the instance. */
  postProjectInstanceStopByServiceNameAndInstanceId = (
    instanceId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/instance/${instanceId}/stop`);
  };

  /** Unshelve an instance. The resources dedicated to the Public Cloud instance are restored. The duration of the operation depends on the size of the local disk. Instance billing will get back to normal and the snapshot used to store the instance's data will be deleted. */
  postProjectInstanceUnshelveByServiceNameAndInstanceId = (
    instanceId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/instance/${instanceId}/unshelve`
    );
  };

  /** Get VNC access to your instance */
  postProjectInstanceVncByServiceNameAndInstanceId = (
    instanceId: string,
    serviceName: string
  ): Promise<CloudInstanceInstanceVnc> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/instance/${instanceId}/vnc`);
  };

  /** List all available regions */
  listProjectIoCapabilitiesStreamRegionByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/io/capabilities/stream/region`);
  };

  /** Get connection information from a region */
  getProjectIoCapabilitiesStreamRegionByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<CloudProjectIoStreamRegion> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/io/capabilities/stream/region/${regionName}`
    );
  };

  /** List all stream for a tenant */
  listProjectIoStreamByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/io/stream`);
  };

  /** Create a stream */
  createProjectIoStreamByServiceName = (
    serviceName: string,
    body: CloudProjectIoStreamCreation
  ): Promise<CloudProjectIoStream> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/io/stream`, body);
  };

  /** Delete a stream */
  deleteProjectIoStreamByServiceNameAndStreamId = (
    serviceName: string,
    streamId: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/io/stream/${streamId}`);
  };

  /** Get a stream */
  getProjectIoStreamByServiceNameAndStreamId = (
    serviceName: string,
    streamId: string
  ): Promise<CloudProjectIoStream> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/io/stream/${streamId}`);
  };

  /** Update a stream */
  updateProjectIoStreamByServiceNameAndStreamId = (
    serviceName: string,
    streamId: string,
    body: CloudProjectIoStream
  ): Promise<CloudProjectIoStream> => {
    return this.ovh.request('PUT', `/cloud/project/${serviceName}/io/stream/${streamId}`, body);
  };

  /** Retrieve statistics of the stream */
  getProjectIoStreamStatsByServiceNameAndStreamId = (
    serviceName: string,
    streamId: string
  ): Promise<CloudProjectIoStreamStats> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/io/stream/${streamId}/stats`);
  };

  /** List all subscriptions for a stream */
  listProjectIoStreamSubscriptionByServiceNameAndStreamId = (
    serviceName: string,
    streamId: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/io/stream/${streamId}/subscription`
    );
  };

  /** Create a new subscription */
  createProjectIoStreamSubscriptionByServiceNameAndStreamId = (
    serviceName: string,
    streamId: string,
    body: CloudProjectIoStreamSubscriptionCreation
  ): Promise<CloudProjectIoStreamSubscription> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/io/stream/${streamId}/subscription`,
      body
    );
  };

  /** Delete a subscription */
  deleteProjectIoStreamSubscriptionByServiceNameAndStreamIdAndSubscriptionId = (
    serviceName: string,
    streamId: string,
    subscriptionId: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/io/stream/${streamId}/subscription/${subscriptionId}`
    );
  };

  /** Get a subscription */
  getProjectIoStreamSubscriptionByServiceNameAndStreamIdAndSubscriptionId = (
    serviceName: string,
    streamId: string,
    subscriptionId: string
  ): Promise<CloudProjectIoStreamSubscription> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/io/stream/${streamId}/subscription/${subscriptionId}`
    );
  };

  /** Reset a cursor */
  postProjectIoStreamSubscriptionResetCursorByServiceNameAndStreamIdAndSubscriptionId = (
    serviceName: string,
    streamId: string,
    subscriptionId: string
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/io/stream/${streamId}/subscription/${subscriptionId}/resetCursor`
    );
  };

  /** Retrieve statistics of the subscription */
  getProjectIoStreamSubscriptionStatsByServiceNameAndStreamIdAndSubscriptionId = (
    serviceName: string,
    streamId: string,
    subscriptionId: string
  ): Promise<CloudProjectIoStreamSubscriptionStats> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/io/stream/${streamId}/subscription/${subscriptionId}/stats`
    );
  };

  /** List all tokens for a stream */
  listProjectIoStreamTokenByServiceNameAndStreamId = (
    serviceName: string,
    streamId: string
  ): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/io/stream/${streamId}/token`);
  };

  /** Create a token */
  createProjectIoStreamTokenByServiceNameAndStreamId = (
    serviceName: string,
    streamId: string,
    body: CloudProjectIoStreamTokenCreation
  ): Promise<CloudProjectIoStreamToken> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/io/stream/${streamId}/token`,
      body
    );
  };

  /** Delete a token */
  deleteProjectIoStreamTokenByServiceNameAndStreamIdAndTokenId = (
    serviceName: string,
    streamId: string,
    tokenId: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/io/stream/${streamId}/token/${tokenId}`
    );
  };

  /** Get token */
  getProjectIoStreamTokenByServiceNameAndStreamIdAndTokenId = (
    serviceName: string,
    streamId: string,
    tokenId: string
  ): Promise<CloudProjectIoStreamToken> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/io/stream/${streamId}/token/${tokenId}`
    );
  };

  /** Get ips */
  getProjectIpByServiceName = (serviceName: string): Promise<CloudIpCloudIp[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ip`);
  };

  /** Get failover ips */
  getProjectIpFailoverByServiceName = (serviceName: string): Promise<CloudIpFailoverIp[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ip/failover`);
  };

  /** Get failover ip */
  getProjectIpFailoverByServiceNameAndId = (
    id: string,
    serviceName: string
  ): Promise<CloudIpFailoverIp> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/ip/failover/${id}`);
  };

  /** Attach failover ip to an instance */
  postProjectIpFailoverAttachByServiceNameAndId = (
    id: string,
    serviceName: string,
    body: CloudProjectIpFailoverAttachCreation
  ): Promise<CloudIpFailoverIp> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/ip/failover/${id}/attach`, body);
  };

  /** List your managed Kubernetes clusters */
  listProjectKubeByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/kube`);
  };

  /** Create a new managed Kubernetes cluster */
  createProjectKubeByServiceName = (
    serviceName: string,
    body: CloudProjectKubeCreation
  ): Promise<CloudKubeCluster> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/kube`, body);
  };

  /** List Kubernetes available regions */
  listProjectKubeRegionsByServiceName = (serviceName: string): Promise<CloudKubeRegionEnum[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/kube/regions`);
  };

  /** Delete your managed Kubernetes cluster */
  deleteProjectKubeByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/kube/${kubeId}`);
  };

  /** Get information about your managed Kubernetes cluster */
  getProjectKubeByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string
  ): Promise<CloudKubeCluster> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/kube/${kubeId}`);
  };

  /** Update information about your managed Kubernetes cluster */
  updateProjectKubeByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string,
    body: CloudProjectKubeUpdate
  ): Promise<void> => {
    return this.ovh.request('PUT', `/cloud/project/${serviceName}/kube/${kubeId}`, body);
  };

  /** Generate a temporary url to retrieve auditlogs */
  postProjectKubeAuditLogsByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string
  ): Promise<CloudKubeAuditLogs> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/kube/${kubeId}/auditLogs`);
  };

  /** Get cluster customization */
  getProjectKubeCustomizationByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string
  ): Promise<CloudProjectKubeCustomization> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/kube/${kubeId}/customization`);
  };

  /** Update cluster customization */
  updateProjectKubeCustomizationByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string,
    body: CloudProjectKubeCustomization
  ): Promise<CloudKubeResponseMessage> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/kube/${kubeId}/customization`,
      body
    );
  };

  /** List all flavors available */
  listProjectKubeFlavorsByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string
  ): Promise<CloudKubeFlavor[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/kube/${kubeId}/flavors`);
  };

  /** List your ip restrictions on your cluster */
  listProjectKubeIpRestrictionsByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/kube/${kubeId}/ipRestrictions`);
  };

  /** Append a list of ip restrictions on your cluster */
  postProjectKubeIpRestrictionsByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string,
    body: CloudProjectKubeIpRestrictionUpsert
  ): Promise<string[]> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/kube/${kubeId}/ipRestrictions`,
      body
    );
  };

  /** Remove the current list and add a list of ip restrictions on your cluster */
  putProjectKubeIpRestrictionsByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string,
    body: CloudProjectKubeIpRestrictionUpsert
  ): Promise<string[]> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/kube/${kubeId}/ipRestrictions`,
      body
    );
  };

  /** Delete an ip restriction from your cluster */
  deleteProjectKubeIpRestrictionsByServiceNameAndKubeIdAndIp = (
    ip: string,
    kubeId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/kube/${kubeId}/ipRestrictions/${ip}`
    );
  };

  /** Generate kubeconfig file */
  postProjectKubeKubeconfigByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string
  ): Promise<CloudKubeKubeconfig> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/kube/${kubeId}/kubeconfig`);
  };

  /** Reset kubeconfig: Certificates will be regenerated, nodes will be reinstalled */
  postProjectKubeKubeconfigResetByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/kube/${kubeId}/kubeconfig/reset`
    );
  };

  /** List available metrics for this cluster */
  listProjectKubeMetricsEtcdUsageByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string
  ): Promise<CloudKubeEtcdUsage> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/kube/${kubeId}/metrics/etcdUsage`
    );
  };

  /** List your nodes */
  listProjectKubeNodeByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string
  ): Promise<CloudKubeNode[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/kube/${kubeId}/node`);
  };

  /** Deploy a node for your cluster. This call is deprecated. In the meantime it will create a new node pool for each call. We encourage you to now either create a new nodepool or change the size on an existing one */
  postProjectKubeNodeByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string,
    body: CloudProjectKubeNodeCreation
  ): Promise<CloudKubeNode> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/kube/${kubeId}/node`, body);
  };

  /** Delete a specific node on your cluster. This will also decrease by one the desirednodes value of its nodepool */
  deleteProjectKubeNodeByServiceNameAndKubeIdAndNodeId = (
    kubeId: string,
    nodeId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/kube/${kubeId}/node/${nodeId}`
    );
  };

  /** Get information on a specific node on your cluster */
  getProjectKubeNodeByServiceNameAndKubeIdAndNodeId = (
    kubeId: string,
    nodeId: string,
    serviceName: string
  ): Promise<CloudKubeNode> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/kube/${kubeId}/node/${nodeId}`);
  };

  /** List your nodepools */
  listProjectKubeNodepoolByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string
  ): Promise<CloudKubeNodePool[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/kube/${kubeId}/nodepool`);
  };

  /** Create a nodepool on your cluster */
  createProjectKubeNodepoolByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string,
    body: CloudProjectKubeNodePoolCreation
  ): Promise<CloudKubeNodePool> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/kube/${kubeId}/nodepool`, body);
  };

  /** Delete a nodepool from your cluster */
  deleteProjectKubeNodepoolByServiceNameAndKubeIdAndNodePoolId = (
    kubeId: string,
    nodePoolId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/kube/${kubeId}/nodepool/${nodePoolId}`
    );
  };

  /** Get information on a specific nodepool on your cluster */
  getProjectKubeNodepoolByServiceNameAndKubeIdAndNodePoolId = (
    kubeId: string,
    nodePoolId: string,
    serviceName: string
  ): Promise<CloudKubeNodePool> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/kube/${kubeId}/nodepool/${nodePoolId}`
    );
  };

  /** Update your nodepool information */
  updateProjectKubeNodepoolByServiceNameAndKubeIdAndNodePoolId = (
    kubeId: string,
    nodePoolId: string,
    serviceName: string,
    body: CloudProjectKubeNodePoolUpdate
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/kube/${kubeId}/nodepool/${nodePoolId}`,
      body
    );
  };

  /** List all nodes contained in a nodepool */
  listProjectKubeNodepoolNodesByServiceNameAndKubeIdAndNodePoolId = (
    kubeId: string,
    nodePoolId: string,
    serviceName: string
  ): Promise<CloudKubeNode[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/kube/${kubeId}/nodepool/${nodePoolId}/nodes`
    );
  };

  /** Remove OpenIdConnect integration from APIServer */
  deleteProjectKubeOpenIdConnectByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/kube/${kubeId}/openIdConnect`);
  };

  /** Get openIdConnect integration parameters */
  getProjectKubeOpenIdConnectByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string
  ): Promise<CloudKubeOpenIdConnect> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/kube/${kubeId}/openIdConnect`);
  };

  /** Configure APIServer for OpenIdConnect */
  postProjectKubeOpenIdConnectByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string,
    body: CloudProjectKubeOpenIdConnectCreation
  ): Promise<CloudKubeOpenIdConnect> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/kube/${kubeId}/openIdConnect`,
      body
    );
  };

  /** Update parameters and reconfigure APIServer */
  updateProjectKubeOpenIdConnectByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string,
    body: CloudProjectKubeOpenIdConnectUpdate
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/kube/${kubeId}/openIdConnect`,
      body
    );
  };

  /** Get private network configuration */
  getProjectKubePrivateNetworkConfigurationByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string
  ): Promise<CloudKubePrivateNetworkConfiguration> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/kube/${kubeId}/privateNetworkConfiguration`
    );
  };

  /** Update private network configuration */
  updateProjectKubePrivateNetworkConfigurationByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string,
    body: CloudKubePrivateNetworkConfiguration
  ): Promise<CloudKubeResponseMessage> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/kube/${kubeId}/privateNetworkConfiguration`,
      body
    );
  };

  /** Reset cluster: all Kubernetes data will be erased (pods, services, configuration, etc), nodes will be either deleted or reinstalled */
  postProjectKubeResetByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string,
    body: CloudProjectKubeResetCreation
  ): Promise<void> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/kube/${kubeId}/reset`, body);
  };

  /** Restarting your control plane apiserver to invalidate cache without downtime (using force will create a slight downtime) */
  postProjectKubeRestartByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string,
    body: CloudProjectKubeRestart
  ): Promise<void> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/kube/${kubeId}/restart`, body);
  };

  /** Force cluster and node update to the latest patch within minor version or next minor version */
  postProjectKubeUpdateByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string,
    body: CloudProjectKubeUpdateCreation
  ): Promise<void> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/kube/${kubeId}/update`, body);
  };

  /** Change the update policy of your cluster */
  updateProjectKubeUpdatePolicyByServiceNameAndKubeId = (
    kubeId: string,
    serviceName: string,
    body: CloudProjectKubeUpdatePolicyUpdate
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/kube/${kubeId}/updatePolicy`,
      body
    );
  };

  /** List available public cloud labs */
  listProjectLabByServiceName = (serviceName: string): Promise<CloudLab[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/lab`);
  };

  /** Get details of a public cloud lab */
  getProjectLabByServiceNameAndLabId = (labId: string, serviceName: string): Promise<CloudLab> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/lab/${labId}`);
  };

  /** Activate a lab on your Cloud Project */
  postProjectLabByServiceNameAndLabId = (
    labId: string,
    serviceName: string
  ): Promise<CloudOperation> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/lab/${labId}`);
  };

  /** List required agreements to active this lab */
  listProjectLabAgreementByServiceNameAndLabId = (
    labId: string,
    serviceName: string
  ): Promise<CloudLabAgreements> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/lab/${labId}/agreement`);
  };

  /** List all load balancer for a tenant */
  listProjectLoadbalancerByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/loadbalancer`);
  };

  /** Create a load balancer */
  createProjectLoadbalancerByServiceName = (
    serviceName: string,
    body: CloudProjectLoadBalancerCreation
  ): Promise<CloudProjectLoadBalancer> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/loadbalancer`, body);
  };

  /** Delete a load balancer */
  deleteProjectLoadbalancerByServiceNameAndLoadBalancerId = (
    loadBalancerId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/loadbalancer/${loadBalancerId}`
    );
  };

  /** Get a load balancer */
  getProjectLoadbalancerByServiceNameAndLoadBalancerId = (
    loadBalancerId: string,
    serviceName: string
  ): Promise<CloudProjectLoadBalancer> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/loadbalancer/${loadBalancerId}`);
  };

  /** Update a load balancer */
  updateProjectLoadbalancerByServiceNameAndLoadBalancerId = (
    loadBalancerId: string,
    serviceName: string,
    body: CloudProjectLoadBalancer
  ): Promise<CloudProjectLoadBalancer> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/loadbalancer/${loadBalancerId}`,
      body
    );
  };

  /** List all versions of the configuration */
  listProjectLoadbalancerConfigurationByServiceNameAndLoadBalancerId = (
    loadBalancerId: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/loadbalancer/${loadBalancerId}/configuration`
    );
  };

  /** Create a configuration */
  createProjectLoadbalancerConfigurationByServiceNameAndLoadBalancerId = (
    loadBalancerId: string,
    serviceName: string,
    body: CloudProjectLoadbalancerConfigurationCreation
  ): Promise<CloudProjectLoadbalancerConfiguration> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/loadbalancer/${loadBalancerId}/configuration`,
      body
    );
  };

  /** Delete a configuration */
  deleteProjectLoadbalancerConfigurationByServiceNameAndLoadBalancerIdAndVersion = (
    loadBalancerId: string,
    serviceName: string,
    version: number
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/loadbalancer/${loadBalancerId}/configuration/${version}`
    );
  };

  /** Get a configuration */
  getProjectLoadbalancerConfigurationByServiceNameAndLoadBalancerIdAndVersion = (
    loadBalancerId: string,
    serviceName: string,
    version: number
  ): Promise<CloudProjectLoadbalancerConfiguration> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/loadbalancer/${loadBalancerId}/configuration/${version}`
    );
  };

  /** Apply a configuration */
  postProjectLoadbalancerConfigurationApplyByServiceNameAndLoadBalancerIdAndVersion = (
    loadBalancerId: string,
    serviceName: string,
    version: number
  ): Promise<CloudProjectLoadbalancerConfiguration> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/loadbalancer/${loadBalancerId}/configuration/${version}/apply`
    );
  };

  /** Get planned migrations */
  getProjectMigrationByServiceName = (serviceName: string): Promise<CloudMigrationMigration[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/migration`);
  };

  /** Get planned migration */
  getProjectMigrationByServiceNameAndMigrationId = (
    migrationId: string,
    serviceName: string
  ): Promise<CloudMigrationMigration> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/migration/${migrationId}`);
  };

  /** Update planned migration */
  updateProjectMigrationByServiceNameAndMigrationId = (
    migrationId: string,
    serviceName: string,
    body: CloudProjectMigrationUpdate
  ): Promise<CloudMigrationMigration> => {
    return this.ovh.request('PUT', `/cloud/project/${serviceName}/migration/${migrationId}`, body);
  };

  /** Get private networks */
  getProjectNetworkPrivateByServiceName = (serviceName: string): Promise<CloudNetworkNetwork[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/network/private`);
  };

  /** Create a new network */
  createProjectNetworkPrivateByServiceName = (
    serviceName: string,
    body: CloudProjectNetworkPrivateCreation
  ): Promise<CloudNetworkNetwork> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/network/private`, body);
  };

  /** Delete private network */
  deleteProjectNetworkPrivateByServiceNameAndNetworkId = (
    networkId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/network/private/${networkId}`);
  };

  /** Get private network */
  getProjectNetworkPrivateByServiceNameAndNetworkId = (
    networkId: string,
    serviceName: string
  ): Promise<CloudNetworkNetwork> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/network/private/${networkId}`);
  };

  /** Rename private network */
  putProjectNetworkPrivateByServiceNameAndNetworkId = (
    networkId: string,
    serviceName: string,
    body: CloudProjectNetworkPrivateUpdate
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/network/private/${networkId}`,
      body
    );
  };

  /** Activate private network in a new region */
  postProjectNetworkPrivateRegionByServiceNameAndNetworkId = (
    networkId: string,
    serviceName: string,
    body: CloudProjectNetworkPrivateRegionCreation
  ): Promise<CloudNetworkNetwork> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/network/private/${networkId}/region`,
      body
    );
  };

  /** Get network subnets */
  getProjectNetworkPrivateSubnetByServiceNameAndNetworkId = (
    networkId: string,
    serviceName: string
  ): Promise<CloudNetworkSubnet[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/network/private/${networkId}/subnet`
    );
  };

  /** Create a new network subnet */
  createProjectNetworkPrivateSubnetByServiceNameAndNetworkId = (
    networkId: string,
    serviceName: string,
    body: CloudProjectNetworkPrivateSubnetCreation
  ): Promise<CloudNetworkSubnet> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/network/private/${networkId}/subnet`,
      body
    );
  };

  /** Delete a network subnet */
  deleteProjectNetworkPrivateSubnetByServiceNameAndNetworkIdAndSubnetId = (
    networkId: string,
    serviceName: string,
    subnetId: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/network/private/${networkId}/subnet/${subnetId}`
    );
  };

  /** Get public networks */
  getProjectNetworkPublicByServiceName = (serviceName: string): Promise<CloudNetworkNetwork[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/network/public`);
  };

  /** List your operations */
  listProjectOperationByServiceName = (serviceName: string): Promise<CloudOperation[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/operation`);
  };

  /** Get information about one operation */
  getProjectOperationByServiceNameAndOperationId = (
    operationId: string,
    serviceName: string
  ): Promise<CloudOperation> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/operation/${operationId}`);
  };

  /** List quotas */
  listProjectQuotaByServiceName = (serviceName: string): Promise<CloudQuotaQuotas[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/quota`);
  };

  /** List your regions */
  listProjectRegionByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/region`);
  };

  /** Request access to a region */
  postProjectRegionByServiceName = (
    serviceName: string,
    body: CloudProjectRegionCreation
  ): Promise<CloudRegion> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/region`, body);
  };

  /** Get information about your region */
  getProjectRegionByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<CloudRegion> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/region/${regionName}`);
  };

  /** Get cold archive containers */
  getProjectRegionColdArchiveByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<CloudColdArchiveContainer[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/coldArchive`
    );
  };

  /** Create S3 cold archive container */
  createProjectRegionColdArchiveByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string,
    body: CloudStorageContainerCreation
  ): Promise<CloudColdArchiveContainer> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/coldArchive`,
      body
    );
  };

  /** Delete S3 cold archive container */
  deleteProjectRegionColdArchiveByServiceNameAndRegionNameAndName = (
    name: string,
    regionName: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/region/${regionName}/coldArchive/${name}`
    );
  };

  /** Get S3 cold archive container */
  getProjectRegionColdArchiveByServiceNameAndRegionNameAndName = (
    name: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudColdArchiveContainer> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/coldArchive/${name}`
    );
  };

  /** Start archiving of container */
  postProjectRegionColdArchiveArchiveByServiceNameAndRegionNameAndName = (
    name: string,
    regionName: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/coldArchive/${name}/archive`
    );
  };

  /** Start cleaning tape date of archived container */
  postProjectRegionColdArchiveDestroyByServiceNameAndRegionNameAndName = (
    name: string,
    regionName: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/coldArchive/${name}/destroy`
    );
  };

  /** Delete S3 cold archive container object */
  deleteProjectRegionColdArchiveObjectByServiceNameAndRegionNameAndNameAndObjectKey = (
    name: string,
    objectKey: string,
    regionName: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/region/${regionName}/coldArchive/${name}/object/${objectKey}`
    );
  };

  /** Add S3 cold archive container policy */
  addProjectRegionColdArchivePolicyByServiceNameAndRegionNameAndNameAndUserId = (
    name: string,
    regionName: string,
    serviceName: string,
    userId: string,
    body: CloudStorageAddContainerPolicy
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/coldArchive/${name}/policy/${userId}`,
      body
    );
  };

  /** Generate presigned URLs to download or upload objects */
  postProjectRegionColdArchivePresignByServiceNameAndRegionNameAndName = (
    name: string,
    regionName: string,
    serviceName: string,
    body: CloudStoragePresignedURLInput
  ): Promise<CloudStoragePresignedURL> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/coldArchive/${name}/presign`,
      body
    );
  };

  /** Start restoring of container */
  postProjectRegionColdArchiveRestoreByServiceNameAndRegionNameAndName = (
    name: string,
    regionName: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/coldArchive/${name}/restore`
    );
  };

  /** Get floating ips */
  getProjectRegionFloatingipByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<CloudProjectFloatingIp[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/region/${regionName}/floatingip`);
  };

  /** Delete a floating ip */
  deleteProjectRegionFloatingipByServiceNameAndRegionNameAndFloatingIpId = (
    floatingIpId: string,
    regionName: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/region/${regionName}/floatingip/${floatingIpId}`
    );
  };

  /** Get a floating ip */
  getProjectRegionFloatingipByServiceNameAndRegionNameAndFloatingIpId = (
    floatingIpId: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudProjectFloatingIp> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/floatingip/${floatingIpId}`
    );
  };

  /** Detach your floating ip */
  postProjectRegionFloatingipDetachByServiceNameAndRegionNameAndFloatingIpId = (
    floatingIpId: string,
    regionName: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/floatingip/${floatingIpId}/detach`
    );
  };

  /** List gateways */
  listProjectRegionGatewayByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<CloudNetworkGateway[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/region/${regionName}/gateway`);
  };

  /** Create new Gateway and new Private Network with new Subnet */
  createProjectRegionGatewayByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string,
    body: CloudNetworkCreateGateway
  ): Promise<CloudOperation> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/gateway`,
      body
    );
  };

  /** Delete gateway */
  deleteProjectRegionGatewayByServiceNameAndRegionNameAndId = (
    id: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudOperation> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/region/${regionName}/gateway/${id}`
    );
  };

  /** Get gateway */
  getProjectRegionGatewayByServiceNameAndRegionNameAndId = (
    id: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudNetworkGateway> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/gateway/${id}`
    );
  };

  /** Update a gateway */
  updateProjectRegionGatewayByServiceNameAndRegionNameAndId = (
    id: string,
    regionName: string,
    serviceName: string,
    body: CloudNetworkUpdateGateway
  ): Promise<CloudNetworkGateway> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/region/${regionName}/gateway/${id}`,
      body
    );
  };

  /** Expose gateway to public network by adding a public port on it. */
  postProjectRegionGatewayExposeByServiceNameAndRegionNameAndId = (
    id: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudNetworkGateway> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/gateway/${id}/expose`
    );
  };

  /** List interfaces */
  listProjectRegionGatewayInterfaceByServiceNameAndRegionNameAndId = (
    id: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudNetworkGatewayInterface[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/gateway/${id}/interface`
    );
  };

  /** Create gateway interface */
  createProjectRegionGatewayInterfaceByServiceNameAndRegionNameAndId = (
    id: string,
    regionName: string,
    serviceName: string,
    body: CloudNetworkGatewayCreateInterface
  ): Promise<CloudNetworkGatewayInterface> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/gateway/${id}/interface`,
      body
    );
  };

  /** Delete gateway interface */
  deleteProjectRegionGatewayInterfaceByServiceNameAndRegionNameAndIdAndInterfaceId = (
    id: string,
    interfaceId: string,
    regionName: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/region/${regionName}/gateway/${id}/interface/${interfaceId}`
    );
  };

  /** Get interface */
  getProjectRegionGatewayInterfaceByServiceNameAndRegionNameAndIdAndInterfaceId = (
    id: string,
    interfaceId: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudNetworkGatewayInterface> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/gateway/${id}/interface/${interfaceId}`
    );
  };

  /** Associate an existing floating IP to an instance */
  postProjectRegionInstanceAssociateFloatingIpByServiceNameAndRegionNameAndInstanceId = (
    instanceId: string,
    regionName: string,
    serviceName: string,
    body: CloudInstanceAssociateFloatingIp
  ): Promise<CloudOperation> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/instance/${instanceId}/associateFloatingIp`,
      body
    );
  };

  /** Create a floating IP and attach it to an instance */
  createProjectRegionInstanceFloatingIpByServiceNameAndRegionNameAndInstanceId = (
    instanceId: string,
    regionName: string,
    serviceName: string,
    body: CloudInstanceCreateFloatingIp
  ): Promise<CloudOperation> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/instance/${instanceId}/floatingIp`,
      body
    );
  };

  /** List certificates */
  listProjectRegionKeymanagerCertificateByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<CloudKeymanagerCertificate[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/keymanager/certificate`
    );
  };

  /** Create a new certificate */
  createProjectRegionKeymanagerCertificateByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string,
    body: CloudKeymanagerCertificateCreate
  ): Promise<CloudKeymanagerCertificate> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/keymanager/certificate`,
      body
    );
  };

  /** Delete a certificate */
  deleteProjectRegionKeymanagerCertificateByServiceNameAndRegionNameAndCertificateId = (
    certificateId: string,
    regionName: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/region/${regionName}/keymanager/certificate/${certificateId}`
    );
  };

  /** Get details about a certificate */
  getProjectRegionKeymanagerCertificateByServiceNameAndRegionNameAndCertificateId = (
    certificateId: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudKeymanagerCertificate> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/keymanager/certificate/${certificateId}`
    );
  };

  /** List secrets */
  listProjectRegionKeymanagerSecretByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<CloudKeymanagerSecret[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/keymanager/secret`
    );
  };

  /** Delete a secret */
  deleteProjectRegionKeymanagerSecretByServiceNameAndRegionNameAndSecretId = (
    regionName: string,
    secretId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/region/${regionName}/keymanager/secret/${secretId}`
    );
  };

  /** Get details about a secret */
  getProjectRegionKeymanagerSecretByServiceNameAndRegionNameAndSecretId = (
    regionName: string,
    secretId: string,
    serviceName: string
  ): Promise<CloudKeymanagerSecret> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/keymanager/secret/${secretId}`
    );
  };

  /** List flavors */
  listProjectRegionLoadbalancingFlavorByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<CloudLoadbalancingFlavor[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/flavor`
    );
  };

  /** Get details about a load balancing flavor */
  getProjectRegionLoadbalancingFlavorByServiceNameAndRegionNameAndFlavorId = (
    flavorId: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudLoadbalancingFlavor> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/flavor/${flavorId}`
    );
  };

  /** List health monitors */
  listProjectRegionLoadbalancingHealthMonitorByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<CloudLoadbalancingHealthMonitor[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/healthMonitor`
    );
  };

  /** Create health monitor */
  createProjectRegionLoadbalancingHealthMonitorByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string,
    body: CloudLoadbalancingHealthMonitor
  ): Promise<CloudLoadbalancingHealthMonitor> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/healthMonitor`,
      body
    );
  };

  /** Delete health monitor */
  deleteProjectRegionLoadbalancingHealthMonitorByServiceNameAndRegionNameAndHealthMonitorId = (
    healthMonitorId: string,
    regionName: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/healthMonitor/${healthMonitorId}`
    );
  };

  /** Get details about a loadbalancer health monitor */
  getProjectRegionLoadbalancingHealthMonitorByServiceNameAndRegionNameAndHealthMonitorId = (
    healthMonitorId: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudLoadbalancingHealthMonitor> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/healthMonitor/${healthMonitorId}`
    );
  };

  /** Update a health monitor */
  updateProjectRegionLoadbalancingHealthMonitorByServiceNameAndRegionNameAndHealthMonitorId = (
    healthMonitorId: string,
    regionName: string,
    serviceName: string,
    body: CloudLoadbalancingUpdateHealthMonitor
  ): Promise<CloudLoadbalancingHealthMonitor> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/healthMonitor/${healthMonitorId}`,
      body
    );
  };

  getProjectRegionLoadbalancingL7PolicyByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<CloudLoadbalancingL7Policy[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/l7Policy`
    );
  };

  postProjectRegionLoadbalancingL7PolicyByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string,
    body: CloudLoadbalancingL7Policy
  ): Promise<CloudLoadbalancingL7Policy> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/l7Policy`,
      body
    );
  };

  deleteProjectRegionLoadbalancingL7PolicyByServiceNameAndRegionNameAndL7PolicyId = (
    l7PolicyId: string,
    regionName: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/l7Policy/${l7PolicyId}`
    );
  };

  getProjectRegionLoadbalancingL7PolicyByServiceNameAndRegionNameAndL7PolicyId = (
    l7PolicyId: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudLoadbalancingL7Policy> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/l7Policy/${l7PolicyId}`
    );
  };

  putProjectRegionLoadbalancingL7PolicyByServiceNameAndRegionNameAndL7PolicyId = (
    l7PolicyId: string,
    regionName: string,
    serviceName: string,
    body: CloudLoadbalancingL7PolicyUpdate
  ): Promise<CloudLoadbalancingL7Policy> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/l7Policy/${l7PolicyId}`,
      body
    );
  };

  getProjectRegionLoadbalancingL7PolicyL7RuleByServiceNameAndRegionNameAndL7PolicyId = (
    l7PolicyId: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudLoadbalancingL7Rule[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/l7Policy/${l7PolicyId}/l7Rule`
    );
  };

  postProjectRegionLoadbalancingL7PolicyL7RuleByServiceNameAndRegionNameAndL7PolicyId = (
    l7PolicyId: string,
    regionName: string,
    serviceName: string,
    body: CloudLoadbalancingL7Rule
  ): Promise<CloudLoadbalancingL7Rule> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/l7Policy/${l7PolicyId}/l7Rule`,
      body
    );
  };

  deleteProjectRegionLoadbalancingL7PolicyL7RuleByServiceNameAndRegionNameAndL7PolicyIdAndL7RuleId =
    (
      l7PolicyId: string,
      l7RuleId: string,
      regionName: string,
      serviceName: string
    ): Promise<void> => {
      return this.ovh.request(
        'DELETE',
        `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/l7Policy/${l7PolicyId}/l7Rule/${l7RuleId}`
      );
    };

  getProjectRegionLoadbalancingL7PolicyL7RuleByServiceNameAndRegionNameAndL7PolicyIdAndL7RuleId = (
    l7PolicyId: string,
    l7RuleId: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudLoadbalancingL7Rule> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/l7Policy/${l7PolicyId}/l7Rule/${l7RuleId}`
    );
  };

  putProjectRegionLoadbalancingL7PolicyL7RuleByServiceNameAndRegionNameAndL7PolicyIdAndL7RuleId = (
    l7PolicyId: string,
    l7RuleId: string,
    regionName: string,
    serviceName: string,
    body: CloudLoadbalancingL7Rule
  ): Promise<CloudLoadbalancingL7Rule> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/l7Policy/${l7PolicyId}/l7Rule/${l7RuleId}`,
      body
    );
  };

  /** List your loadbalancer listeners */
  listProjectRegionLoadbalancingenerByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<CloudLoadbalancingListener[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/listener`
    );
  };

  /** Create a loadbalancer listerner */
  createProjectRegionLoadbalancingListenerByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string,
    body: CloudLoadbalancingCreateListener
  ): Promise<CloudLoadbalancingListener> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/listener`,
      body
    );
  };

  /** Delete loadbalancer listener */
  deleteProjectRegionLoadbalancingListenerByServiceNameAndRegionNameAndListenerId = (
    listenerId: string,
    regionName: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/listener/${listenerId}`
    );
  };

  /** Get details about a loadbalancer listener */
  getProjectRegionLoadbalancingListenerByServiceNameAndRegionNameAndListenerId = (
    listenerId: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudLoadbalancingListener> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/listener/${listenerId}`
    );
  };

  /** List your load balancers */
  listProjectRegionLoadbalancingLoadbalancerByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<CloudLoadbalancingLoadBalancer[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/loadbalancer`
    );
  };

  /** Create a loadbalancer */
  createProjectRegionLoadbalancingLoadbalancerByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string,
    body: CloudLoadbalancingLoadbalancerCreate
  ): Promise<CloudOperation> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/loadbalancer`,
      body
    );
  };

  /** Delete loadbalancer */
  deleteProjectRegionLoadbalancingLoadbalancerByServiceNameAndRegionNameAndLoadBalancerId = (
    loadBalancerId: string,
    regionName: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/loadbalancer/${loadBalancerId}`
    );
  };

  /** Get details about a load balancer */
  getProjectRegionLoadbalancingLoadbalancerByServiceNameAndRegionNameAndLoadBalancerId = (
    loadBalancerId: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudLoadbalancingLoadBalancer> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/loadbalancer/${loadBalancerId}`
    );
  };

  /** Associate an existing floating IP to a loadbalancer */
  postProjectRegionLoadbalancingLoadbalancerAssociateFloatingIpByServiceNameAndRegionNameAndLoadBalancerId =
    (
      loadBalancerId: string,
      regionName: string,
      serviceName: string,
      body: CloudLoadbalancingAssociateFloatingIp
    ): Promise<CloudOperation> => {
      return this.ovh.request(
        'POST',
        `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/loadbalancer/${loadBalancerId}/associateFloatingIp`,
        body
      );
    };

  /** Create a floating IP and attach it to a loadbalancer */
  createProjectRegionLoadbalancingLoadbalancerFloatingIpByServiceNameAndRegionNameAndLoadBalancerId =
    (
      loadBalancerId: string,
      regionName: string,
      serviceName: string,
      body: CloudLoadbalancingCreateFloatingIp
    ): Promise<CloudOperation> => {
      return this.ovh.request(
        'POST',
        `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/loadbalancer/${loadBalancerId}/floatingIp`,
        body
      );
    };

  /** List your loadbalancer pools */
  listProjectRegionLoadbalancingPoolByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<CloudLoadbalancingPool[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/pool`
    );
  };

  /** Create a loadbalancer pool */
  createProjectRegionLoadbalancingPoolByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string,
    body: CloudLoadbalancingPoolCreate
  ): Promise<CloudLoadbalancingPool> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/pool`,
      body
    );
  };

  /** Delete a loadbalancer pool */
  deleteProjectRegionLoadbalancingPoolByServiceNameAndRegionNameAndPoolId = (
    poolId: string,
    regionName: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/pool/${poolId}`
    );
  };

  /** Get details about a loadbalancer pool */
  getProjectRegionLoadbalancingPoolByServiceNameAndRegionNameAndPoolId = (
    poolId: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudLoadbalancingPool> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/pool/${poolId}`
    );
  };

  /** Update a loadbalancer pool */
  updateProjectRegionLoadbalancingPoolByServiceNameAndRegionNameAndPoolId = (
    poolId: string,
    regionName: string,
    serviceName: string,
    body: CloudLoadbalancingPoolUpdate
  ): Promise<CloudLoadbalancingPool> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/pool/${poolId}`,
      body
    );
  };

  /** List your pool members */
  listProjectRegionLoadbalancingPoolMemberByServiceNameAndRegionNameAndPoolId = (
    poolId: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudLoadbalancingPoolMember[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/pool/${poolId}/member`
    );
  };

  /** Create a pool member */
  createProjectRegionLoadbalancingPoolMemberByServiceNameAndRegionNameAndPoolId = (
    poolId: string,
    regionName: string,
    serviceName: string,
    body: CloudLoadbalancingPoolMember
  ): Promise<CloudLoadbalancingPoolMember> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/pool/${poolId}/member`,
      body
    );
  };

  /** Delete a pool member */
  deleteProjectRegionLoadbalancingPoolMemberByServiceNameAndRegionNameAndPoolIdAndMemberId = (
    memberId: string,
    poolId: string,
    regionName: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/pool/${poolId}/member/${memberId}`
    );
  };

  /** Get details about a pool member */
  getProjectRegionLoadbalancingPoolMemberByServiceNameAndRegionNameAndPoolIdAndMemberId = (
    memberId: string,
    poolId: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudLoadbalancingPoolMember> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/pool/${poolId}/member/${memberId}`
    );
  };

  /** Update a pool member */
  updateProjectRegionLoadbalancingPoolMemberByServiceNameAndRegionNameAndPoolIdAndMemberId = (
    memberId: string,
    poolId: string,
    regionName: string,
    serviceName: string,
    body: CloudLoadbalancingPoolMemberUpdate
  ): Promise<CloudLoadbalancingPoolMember> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/region/${regionName}/loadbalancing/pool/${poolId}/member/${memberId}`,
      body
    );
  };

  /** List networks */
  listProjectRegionNetworkByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<CloudProjectNetwork[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/region/${regionName}/network`);
  };

  /** Create a network with a gateway */
  createProjectRegionNetworkByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string,
    body: CloudNetworkCreateNetwork
  ): Promise<CloudOperation> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/network`,
      body
    );
  };

  /** Delete network */
  deleteProjectRegionNetworkByServiceNameAndRegionNameAndNetworkId = (
    networkId: string,
    regionName: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/region/${regionName}/network/${networkId}`
    );
  };

  /** Get network */
  getProjectRegionNetworkByServiceNameAndRegionNameAndNetworkId = (
    networkId: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudProjectNetwork> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/network/${networkId}`
    );
  };

  /** List subnets */
  listProjectRegionNetworkSubnetByServiceNameAndRegionNameAndNetworkId = (
    networkId: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudProjectSubnet[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/network/${networkId}/subnet`
    );
  };

  /** Delete subnet */
  deleteProjectRegionNetworkSubnetByServiceNameAndRegionNameAndNetworkIdAndSubnetId = (
    networkId: string,
    regionName: string,
    serviceName: string,
    subnetId: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/region/${regionName}/network/${networkId}/subnet/${subnetId}`
    );
  };

  /** Get subnet */
  getProjectRegionNetworkSubnetByServiceNameAndRegionNameAndNetworkIdAndSubnetId = (
    networkId: string,
    regionName: string,
    serviceName: string,
    subnetId: string
  ): Promise<CloudProjectSubnet> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/network/${networkId}/subnet/${subnetId}`
    );
  };

  /** Create Gateway for existing subnet */
  createProjectRegionNetworkSubnetGatewayByServiceNameAndRegionNameAndNetworkIdAndSubnetId = (
    networkId: string,
    regionName: string,
    serviceName: string,
    subnetId: string,
    body: CloudNetworkCreateGatewaySummary
  ): Promise<CloudOperation> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/network/${networkId}/subnet/${subnetId}/gateway`,
      body
    );
  };

  /** List quotas */
  listProjectRegionQuotaByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<CloudQuotaQuotas> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/region/${regionName}/quota`);
  };

  /** Change project quotas on region */
  updateProjectRegionQuotaByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string,
    body: CloudProjectRegionQuotaCreation
  ): Promise<CloudOperation> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/quota`,
      body
    );
  };

  /** Get allowed quotas on region */
  getProjectRegionQuotaAllowedByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<CloudQuotaAllowedQuota[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/quota/allowed`
    );
  };

  /** Delete storage quota on region */
  deleteProjectRegionQuotaStorageByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/region/${regionName}/quota/storage`
    );
  };

  /** Get storage quotas on region */
  getProjectRegionQuotaStorageByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<CloudQuotaStorageQuota> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/quota/storage`
    );
  };

  /** Update storage quota on region */
  updateProjectRegionQuotaStorageByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string,
    body: CloudQuotaStorageQuotaUpdate
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/cloud/project/${serviceName}/region/${regionName}/quota/storage`,
      body
    );
  };

  /** Get S3 storage containers */
  getProjectRegionStorageByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<CloudStorageContainer[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/region/${regionName}/storage`);
  };

  /** Create S3 storage container */
  createProjectRegionStorageByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string,
    body: CloudStorageContainerCreation
  ): Promise<CloudStorageContainer> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/storage`,
      body
    );
  };

  /** Delete S3 storage container */
  deleteProjectRegionStorageByServiceNameAndRegionNameAndName = (
    name: string,
    regionName: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/region/${regionName}/storage/${name}`
    );
  };

  /** Get S3 storage container */
  getProjectRegionStorageByServiceNameAndRegionNameAndName = (
    name: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudStorageContainer> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/storage/${name}`
    );
  };

  /** Delete S3 storage container object */
  deleteProjectRegionStorageObjectByServiceNameAndRegionNameAndNameAndObjectKey = (
    name: string,
    objectKey: string,
    regionName: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/region/${regionName}/storage/${name}/object/${objectKey}`
    );
  };

  /** Add S3 storage container policy */
  addProjectRegionStoragePolicyByServiceNameAndRegionNameAndNameAndUserId = (
    name: string,
    regionName: string,
    serviceName: string,
    userId: string,
    body: CloudStorageAddContainerPolicy
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/storage/${name}/policy/${userId}`,
      body
    );
  };

  /** Generate S3 presigned URLs to download or upload objects */
  postProjectRegionStoragePresignByServiceNameAndRegionNameAndName = (
    name: string,
    regionName: string,
    serviceName: string,
    body: CloudStoragePresignedURLInput
  ): Promise<CloudStoragePresignedURL> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/storage/${name}/presign`,
      body
    );
  };

  /** List volume backups */
  listProjectRegionVolumeBackupByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<CloudVolumeBackupVolumeBackup[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/volumeBackup`
    );
  };

  /** Create a volume backup */
  createProjectRegionVolumeBackupByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string,
    body: CloudVolumeBackupVolumeBackupCreation
  ): Promise<CloudVolumeBackupVolumeBackup> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/volumeBackup`,
      body
    );
  };

  /** Delete volume backup */
  deleteProjectRegionVolumeBackupByServiceNameAndRegionNameAndVolumeBackupId = (
    regionName: string,
    serviceName: string,
    volumeBackupId: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/region/${regionName}/volumeBackup/${volumeBackupId}`
    );
  };

  /** Get volume backup */
  getProjectRegionVolumeBackupByServiceNameAndRegionNameAndVolumeBackupId = (
    regionName: string,
    serviceName: string,
    volumeBackupId: string
  ): Promise<CloudVolumeBackupVolumeBackup> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/volumeBackup/${volumeBackupId}`
    );
  };

  /** Restore a volume backup on a volume */
  postProjectRegionVolumeBackupRestoreByServiceNameAndRegionNameAndVolumeBackupId = (
    regionName: string,
    serviceName: string,
    volumeBackupId: string,
    body: CloudVolumeBackupVolumeBackupRestore
  ): Promise<CloudVolumeBackupVolumeBackup> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/volumeBackup/${volumeBackupId}/restore`,
      body
    );
  };

  /** Create a volume from a volume backup */
  createProjectRegionVolumeBackupVolumeByServiceNameAndRegionNameAndVolumeBackupId = (
    regionName: string,
    serviceName: string,
    volumeBackupId: string,
    body: CloudVolumeBackupVolumeCreationFromBackup
  ): Promise<CloudVolumeVolume> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/volumeBackup/${volumeBackupId}/volume`,
      body
    );
  };

  /** List your automated backups */
  listProjectRegionWorkflowBackupByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string
  ): Promise<CloudBackup[]> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/workflow/backup`
    );
  };

  /** Create a new automated backup */
  createProjectRegionWorkflowBackupByServiceNameAndRegionName = (
    regionName: string,
    serviceName: string,
    body: CloudProjectRegionWorkflowBackupCreation
  ): Promise<CloudBackup> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/region/${regionName}/workflow/backup`,
      body
    );
  };

  /** Delete a backup workflow process */
  deleteProjectRegionWorkflowBackupByServiceNameAndRegionNameAndBackupWorkflowId = (
    backupWorkflowId: string,
    regionName: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/region/${regionName}/workflow/backup/${backupWorkflowId}`
    );
  };

  /** Get details about a backup workflow process */
  getProjectRegionWorkflowBackupByServiceNameAndRegionNameAndBackupWorkflowId = (
    backupWorkflowId: string,
    regionName: string,
    serviceName: string
  ): Promise<CloudBackup> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/region/${regionName}/workflow/backup/${backupWorkflowId}`
    );
  };

  /** List the regions on which you can ask an access to */
  listProjectRegionAvailableByServiceName = (
    serviceName: string
  ): Promise<CloudAvailableRegion[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/regionAvailable`);
  };

  /** Do not expire the project, and retain it. You will have to pay for the resources you will use after using this call */
  postProjectRetainByServiceName = (serviceName: string): Promise<void> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/retain`);
  };

  /** Get all Roles */
  getProjectRoleByServiceName = (serviceName: string): Promise<CloudRoleRoles> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/role`);
  };

  /** Get this object properties */
  getProjectServiceInfosByServiceName = (serviceName: string): Promise<ServicesService> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/serviceInfos`);
  };

  /** Alter this object properties */
  updateProjectServiceInfosByServiceName = (
    serviceName: string,
    body: ServicesService
  ): Promise<void> => {
    return this.ovh.request('PUT', `/cloud/project/${serviceName}/serviceInfos`, body);
  };

  /** Get snapshots */
  getProjectSnapshotByServiceName = (serviceName: string): Promise<CloudImageImage[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/snapshot`);
  };

  /** Delete a snapshot */
  deleteProjectSnapshotByServiceNameAndImageId = (
    imageId: string,
    serviceName: string
  ): Promise<CloudImageImage> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/snapshot/${imageId}`);
  };

  /** Get snapshot details */
  getProjectSnapshotByServiceNameAndImageId = (
    imageId: string,
    serviceName: string
  ): Promise<CloudImageImage> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/snapshot/${imageId}`);
  };

  /** Get SSH keys */
  getProjectSshkeyByServiceName = (serviceName: string): Promise<CloudSshkeySshKey[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/sshkey`);
  };

  /** Create SSH key */
  createProjectSshkeyByServiceName = (
    serviceName: string,
    body: CloudProjectSshkeyCreation
  ): Promise<CloudSshkeySshKeyDetail> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/sshkey`, body);
  };

  /** Delete SSH key */
  deleteProjectSshkeyByServiceNameAndKeyId = (
    keyId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/sshkey/${keyId}`);
  };

  /** Get SSH key */
  getProjectSshkeyByServiceNameAndKeyId = (
    keyId: string,
    serviceName: string
  ): Promise<CloudSshkeySshKeyDetail> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/sshkey/${keyId}`);
  };

  /** Get stacks */
  getProjectStackByServiceName = (serviceName: string): Promise<CloudStackStack[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/stack`);
  };

  /** Get stack */
  getProjectStackByServiceNameAndStackId = (
    serviceName: string,
    stackId: string
  ): Promise<CloudStackStack> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/stack/${stackId}`);
  };

  /** Get SWIFT storage containers */
  getProjectStorageByServiceName = (serviceName: string): Promise<CloudStorageContainer[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/storage`);
  };

  /** Create SWIFT container */
  createProjectStorageByServiceName = (
    serviceName: string,
    body: CloudProjectStorageCreation
  ): Promise<CloudStorageContainer> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/storage`, body);
  };

  /** Access to SWIFT storage API */
  getProjectStorageAccessByServiceName = (
    serviceName: string
  ): Promise<CloudStorageContainerAccess> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/storage/access`);
  };

  /** Access to SWIFT storage API */
  postProjectStorageAccessByServiceName = (
    serviceName: string
  ): Promise<CloudStorageContainerAccess> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/storage/access`);
  };

  /** List storage quotas */
  listProjectStorageQuotaByServiceName = (serviceName: string): Promise<CloudStorageQuota> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/storage/quota`);
  };

  /** Delete SWIFT container */
  deleteProjectStorageByServiceNameAndContainerId = (
    containerId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/storage/${containerId}`);
  };

  /** Get SWIFT storage container */
  getProjectStorageByServiceNameAndContainerId = (
    containerId: string,
    serviceName: string
  ): Promise<CloudStorageContainerDetail> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/storage/${containerId}`);
  };

  /** Update SWIFT storage container */
  updateProjectStorageByServiceNameAndContainerId = (
    containerId: string,
    serviceName: string,
    body: CloudProjectStorageUpdate
  ): Promise<void> => {
    return this.ovh.request('PUT', `/cloud/project/${serviceName}/storage/${containerId}`, body);
  };

  /** Delete CORS support on SWIFT container */
  deleteProjectStorageCorsByServiceNameAndContainerId = (
    containerId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/storage/${containerId}/cors`);
  };

  /** Add CORS support on SWIFT container */
  addProjectStorageCorsByServiceNameAndContainerId = (
    containerId: string,
    serviceName: string,
    body: CloudProjectStorageCorsCreation
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/storage/${containerId}/cors`,
      body
    );
  };

  /** Get a public temporary URL to access one of your SWIFT object */
  postProjectStoragePublicUrlByServiceNameAndContainerId = (
    containerId: string,
    serviceName: string,
    body: CloudProjectStoragePublicUrlCreation
  ): Promise<CloudStorageContainerObjectTempURL> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/storage/${containerId}/publicUrl`,
      body
    );
  };

  /** Deploy your SWIFT container files as a static web site */
  postProjectStorageStaticByServiceNameAndContainerId = (
    containerId: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/storage/${containerId}/static`);
  };

  /** Create openstack user with only access to this SWIFT container */
  createProjectStorageUserByServiceNameAndContainerId = (
    containerId: string,
    serviceName: string,
    body: CloudProjectStorageUserCreation
  ): Promise<CloudUserUserDetail> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/storage/${containerId}/user`,
      body
    );
  };

  /** Terminate your service */
  postProjectTerminateByServiceName = (serviceName: string): Promise<string> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/terminate`);
  };

  /** Request more quota on your /cloud project */
  postProjectUnleashByServiceName = (serviceName: string): Promise<void> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/unleash`);
  };

  /** Get current usage */
  getProjectUsageCurrentByServiceName = (serviceName: string): Promise<CloudUsageUsageCurrent> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/usage/current`);
  };

  /** Get usage forecast */
  getProjectUsageForecastByServiceName = (
    serviceName: string
  ): Promise<CloudUsageUsageForecast> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/usage/forecast`);
  };

  /** Usage information details */
  getProjectUsageHistoryByServiceName = (
    serviceName: string
  ): Promise<CloudUsageUsageHistory[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/usage/history`);
  };

  /** Usage information details */
  getProjectUsageHistoryByServiceNameAndUsageId = (
    serviceName: string,
    usageId: string
  ): Promise<CloudUsageUsageHistoryDetail> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/usage/history/${usageId}`);
  };

  /** Get all users */
  getProjectUserByServiceName = (serviceName: string): Promise<CloudUserUser[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/user`);
  };

  /** Create user */
  createProjectUserByServiceName = (
    serviceName: string,
    body: CloudProjectUserCreation
  ): Promise<CloudUserUserDetail> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/user`, body);
  };

  /** Delete user */
  deleteProjectUserByServiceNameAndUserId = (
    serviceName: string,
    userId: number
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/user/${userId}`);
  };

  /** Get user details */
  getProjectUserByServiceNameAndUserId = (
    serviceName: string,
    userId: number
  ): Promise<CloudUserUser> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/user/${userId}`);
  };

  /** Get RC file of OpenStack */
  getProjectUserOpenrcByServiceNameAndUserId = (
    serviceName: string,
    userId: number
  ): Promise<CloudUserOpenrc> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/user/${userId}/openrc`);
  };

  /** Export user storage policy */
  exportProjectUserPolicyByServiceNameAndUserId = (
    serviceName: string,
    userId: number
  ): Promise<CloudStoragePolicyRaw> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/user/${userId}/policy`);
  };

  /** Import user storage policy */
  postProjectUserPolicyByServiceNameAndUserId = (
    serviceName: string,
    userId: number,
    body: CloudStoragePolicyRaw
  ): Promise<void> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/user/${userId}/policy`, body);
  };

  /** Get rclone configuration file */
  getProjectUserRcloneByServiceNameAndUserId = (
    serviceName: string,
    userId: number
  ): Promise<CloudUserRclone> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/user/${userId}/rclone`);
  };

  /** Regenerate user password */
  postProjectUserRegeneratePasswordByServiceNameAndUserId = (
    serviceName: string,
    userId: number
  ): Promise<CloudUserUserDetail> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/user/${userId}/regeneratePassword`
    );
  };

  /** Get user roles */
  getProjectUserRoleByServiceNameAndUserId = (
    serviceName: string,
    userId: number
  ): Promise<CloudRoleRole[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/user/${userId}/role`);
  };

  /** Add a role to a user */
  addProjectUserRoleByServiceNameAndUserId = (
    serviceName: string,
    userId: number,
    body: CloudProjectUserRoleCreation
  ): Promise<CloudUserUserDetail> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/user/${userId}/role`, body);
  };

  /** Update roles of a user */
  updateProjectUserRoleByServiceNameAndUserId = (
    serviceName: string,
    userId: number,
    body: CloudProjectUserRoleUpdate
  ): Promise<CloudUserUserDetail> => {
    return this.ovh.request('PUT', `/cloud/project/${serviceName}/user/${userId}/role`, body);
  };

  /** Remove role for a user */
  deleteProjectUserRoleByServiceNameAndUserIdAndRoleId = (
    roleId: string,
    serviceName: string,
    userId: number
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/user/${userId}/role/${roleId}`
    );
  };

  /** Get role detail */
  getProjectUserRoleByServiceNameAndUserIdAndRoleId = (
    roleId: string,
    serviceName: string,
    userId: number
  ): Promise<CloudRoleRole> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/user/${userId}/role/${roleId}`);
  };

  /** List your S3 credentials */
  listProjectUserS3CredentialsByServiceNameAndUserId = (
    serviceName: string,
    userId: number
  ): Promise<CloudUserS3CredentialsWithSecret[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/user/${userId}/s3Credentials`);
  };

  /** Create a new S3 credentials for an user */
  createProjectUserS3CredentialsByServiceNameAndUserId = (
    serviceName: string,
    userId: number
  ): Promise<CloudUserS3CredentialsWithSecret> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/user/${userId}/s3Credentials`);
  };

  /** Delete an S3 credential */
  deleteProjectUserS3CredentialsByServiceNameAndUserIdAndAccess = (
    access: string,
    serviceName: string,
    userId: number
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/user/${userId}/s3Credentials/${access}`
    );
  };

  /** Get details about an S3 credential */
  getProjectUserS3CredentialsByServiceNameAndUserIdAndAccess = (
    access: string,
    serviceName: string,
    userId: number
  ): Promise<CloudUserS3CredentialsWithSecret> => {
    return this.ovh.request(
      'GET',
      `/cloud/project/${serviceName}/user/${userId}/s3Credentials/${access}`
    );
  };

  /** Get token for user */
  postProjectUserTokenByServiceNameAndUserId = (
    serviceName: string,
    userId: number,
    body: CloudProjectUserTokenCreation
  ): Promise<CloudAuthenticationToken> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/user/${userId}/token`, body);
  };

  /** Get volumes */
  getProjectVolumeByServiceName = (serviceName: string): Promise<CloudVolumeVolume[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/volume`);
  };

  /** Create a volume */
  createProjectVolumeByServiceName = (
    serviceName: string,
    body: CloudProjectVolumeCreation
  ): Promise<CloudVolumeVolume> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/volume`, body);
  };

  /** Get volume snapshots */
  getProjectVolumeSnapshotByServiceName = (serviceName: string): Promise<CloudVolumeSnapshot[]> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/volume/snapshot`);
  };

  /** Delete a volume snapshot */
  deleteProjectVolumeSnapshotByServiceNameAndSnapshotId = (
    serviceName: string,
    snapshotId: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/cloud/project/${serviceName}/volume/snapshot/${snapshotId}`
    );
  };

  /** Get volume snapshot details */
  getProjectVolumeSnapshotByServiceNameAndSnapshotId = (
    serviceName: string,
    snapshotId: string
  ): Promise<CloudVolumeSnapshot> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/volume/snapshot/${snapshotId}`);
  };

  /** Delete a volume */
  deleteProjectVolumeByServiceNameAndVolumeId = (
    serviceName: string,
    volumeId: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/cloud/project/${serviceName}/volume/${volumeId}`);
  };

  /** Get volume details */
  getProjectVolumeByServiceNameAndVolumeId = (
    serviceName: string,
    volumeId: string
  ): Promise<CloudVolumeVolume> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/volume/${volumeId}`);
  };

  /** Update a volume */
  updateProjectVolumeByServiceNameAndVolumeId = (
    serviceName: string,
    volumeId: string,
    body: CloudProjectVolumeUpdate
  ): Promise<CloudVolumeVolume> => {
    return this.ovh.request('PUT', `/cloud/project/${serviceName}/volume/${volumeId}`, body);
  };

  /** Attach a volume on an instance */
  postProjectVolumeAttachByServiceNameAndVolumeId = (
    serviceName: string,
    volumeId: string,
    body: CloudProjectVolumeAttachCreation
  ): Promise<CloudVolumeVolume> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/volume/${volumeId}/attach`,
      body
    );
  };

  /** Detach a volume from an instance */
  postProjectVolumeDetachByServiceNameAndVolumeId = (
    serviceName: string,
    volumeId: string,
    body: CloudProjectVolumeDetachCreation
  ): Promise<CloudVolumeVolume> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/volume/${volumeId}/detach`,
      body
    );
  };

  /** Snapshot a volume */
  postProjectVolumeSnapshotByServiceNameAndVolumeId = (
    serviceName: string,
    volumeId: string,
    body: CloudProjectVolumeSnapshotCreation
  ): Promise<CloudVolumeSnapshot> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/volume/${volumeId}/snapshot`,
      body
    );
  };

  /** Extend a volume */
  postProjectVolumeUpsizeByServiceNameAndVolumeId = (
    serviceName: string,
    volumeId: string,
    body: CloudProjectVolumeUpsizeCreation
  ): Promise<CloudVolumeVolume> => {
    return this.ovh.request(
      'POST',
      `/cloud/project/${serviceName}/volume/${volumeId}/upsize`,
      body
    );
  };

  /** Get the linked vRack on your project */
  getProjectVrackByServiceName = (serviceName: string): Promise<CloudVrack> => {
    return this.ovh.request('GET', `/cloud/project/${serviceName}/vrack`);
  };

  /** Order and attach a new vRack on your project */
  postProjectVrackByServiceName = (serviceName: string): Promise<CloudOperation> => {
    return this.ovh.request('POST', `/cloud/project/${serviceName}/vrack`);
  };

  /** Get services prices for a subsidiary */
  getSubsidiaryPrice = (): Promise<CloudPrice> => {
    return this.ovh.request('GET', '/cloud/subsidiaryPrice');
  };
}

export { CloudHandler };
